
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78e9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78e9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4d1Vr", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e09d4787d3ead01$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("4d6dI")).CLIENT_VERSION);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $b5pyb = parcelRequire("b5pyb");

var $4d6dI = parcelRequire("4d6dI");



var $joS99 = parcelRequire("joS99");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $9e09d4787d3ead01$var$FeatureGates {
    static{
        this.client = new (0, $b5pyb.Client)();
    }
    static{
        this.hasCheckGateErrorOccurred = false;
    }
    static{
        this.hasGetExperimentValueErrorOccurred = false;
    }
    static{
        this.checkGate = (gateName, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                    // Attempt to retrieve an override value for the feature gate
                    const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                    // If an override value is found, return it immediately
                    if (overrideValue !== undefined) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$9e09d4787d3ead01$var$FeatureGates.hasCheckGateErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                        gateName: gateName,
                        error: error
                    });
                    $9e09d4787d3ead01$var$FeatureGates.hasCheckGateErrorOccurred = true;
                }
            }
            // Proceed with the main logic if no override is found
            return this.client.checkGate(gateName, options);
        };
    }
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static{
        this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                    const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                    if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$9e09d4787d3ead01$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    this.hasGetExperimentValueErrorOccurred = true;
                }
                return defaultValue;
            }
            // Proceed with the main logic if no override is found
            return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
        };
    }
    static{
        this.initializeCalled = this.client.initializeCalled.bind(this.client);
    }
    static{
        this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    }
    static{
        this.waitUntilInitializeCompleted = this.client.waitUntilInitializeCompleted.bind(this.client);
    }
    static{
        this.initialize = this.client.initialize.bind(this.client);
    }
    static{
        this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    }
    static{
        this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    }
    static{
        this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    }
    static{
        this.getExperiment = this.client.getExperiment.bind(this.client);
    }
    static{
        this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    }
    static{
        this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    }
    static{
        this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    }
    static{
        this.overrideGate = this.client.overrideGate.bind(this.client);
    }
    static{
        this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    }
    static{
        this.overrideConfig = this.client.overrideConfig.bind(this.client);
    }
    static{
        this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    }
    static{
        this.setOverrides = this.client.setOverrides.bind(this.client);
    }
    static{
        this.getOverrides = this.client.getOverrides.bind(this.client);
    }
    static{
        this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    }
    static{
        this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    }
    static{
        this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    }
    static{
        this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    }
    static{
        this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    }
    static{
        this.updateUser = this.client.updateUser.bind(this.client);
    }
    static{
        this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    }
    static{
        this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    }
    static{
        this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    }
    static{
        this.getTargetApp = this.client.getTargetApp.bind(this.client);
    }
    static{
        this.getLayer = this.client.getLayer.bind(this.client);
    }
    static{
        this.getLayerValue = this.client.getLayerValue.bind(this.client);
    }
}
let $9e09d4787d3ead01$var$boundFGJS = $9e09d4787d3ead01$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $9e09d4787d3ead01$var$FeatureGates;
    else {
        $9e09d4787d3ead01$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $9e09d4787d3ead01$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $4d6dI.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $4d6dI.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $9e09d4787d3ead01$export$2e2bcd8739ae039 = $9e09d4787d3ead01$var$boundFGJS;

});
parcelRegister("b5pyb", function(module, exports) {
$parcel$export(module.exports, "Client", () => $c464ed79c9f7a942$export$1f2bb630327ac4b6);

var $1T45w = parcelRequire("1T45w");

var $iaAZy = parcelRequire("iaAZy");

var $4p9Sd = parcelRequire("4p9Sd");

var $kIeaF = parcelRequire("kIeaF");

var $lOIRH = parcelRequire("lOIRH");

var $jQSGj = parcelRequire("jQSGj");

var $5Oj64 = parcelRequire("5Oj64");

var $jOwMd = parcelRequire("jOwMd");

var $2YPaE = parcelRequire("2YPaE");

var $iTSgg = parcelRequire("iTSgg");

var $1xPXE = parcelRequire("1xPXE");

var $deCXZ = parcelRequire("deCXZ");

var $hHsjm = parcelRequire("hHsjm");

var $joS99 = parcelRequire("joS99");

var $4d6dI = parcelRequire("4d6dI");
const $c464ed79c9f7a942$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $c464ed79c9f7a942$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $c464ed79c9f7a942$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $1xPXE.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
   * True if an initialize method was called and completed, meaning the client is now usable.
   * However if there was an error during initialization it may have initialized with default
   * values. Use {@link initCompleted} to check for this.
   */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $iaAZy.default)();
        this.dataAdapter = new (0, $iTSgg.NoFetchDataAdapter)();
        /**
   * Call this if modifying the values being served by the Statsig library since it has its own
   * memoization cache which will not be updated if the values are changed outside of the library.
   */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $1xPXE.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $jOwMd.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $deCXZ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $jOwMd.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $deCXZ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $4d6dI.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $4d6dI.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $joS99.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $jOwMd.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $deCXZ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $jOwMd.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $5Oj64.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $4p9Sd.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $4p9Sd.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $lOIRH.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $deCXZ.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $deCXZ.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $5Oj64.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $5Oj64.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $2YPaE.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $c464ed79c9f7a942$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $c464ed79c9f7a942$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $joS99.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        const frontendUser = (0, $hHsjm.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, $jQSGj.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $1T45w.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $1T45w.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $1T45w.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $1T45w.StatsigClient)($c464ed79c9f7a942$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            const frontendUser = (0, $hHsjm.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
            user = (0, $jQSGj.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $4d6dI.CLIENT_VERSION;
    }
    /**
   * Returns the `targetApp` value that was provided during client initialization.
   * This identifies the product/app context (e.g., `'confluence_web'`, `'jira_web'`).
   *
   * Returns `undefined` if `initialize` has never been called.
   *
   * @returns The targetApp string, or undefined if initialize has never been called.
   */ getTargetApp() {
        return this.initOptions?.targetApp;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $kIeaF.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $kIeaF.Layer).fromLayer((0, $1T45w._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("1T45w", function(module, exports) {
"use strict";
var $15fe194a98569649$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $15fe194a98569649$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $15fe194a98569649$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $jCry9 = parcelRequire("jCry9");
module.exports.StatsigClient = $jCry9.default;

$15fe194a98569649$var$__exportStar((parcelRequire("49Dnu")), module.exports);
const $15fe194a98569649$var$__STATSIG__ = Object.assign((0, (parcelRequire("49Dnu"))._getStatsigGlobal)(), {
    StatsigClient: $jCry9.default
});
module.exports.default = $15fe194a98569649$var$__STATSIG__;

});
parcelRegister("49Dnu", function(module, exports) {
"use strict";
var $30668c514f90d554$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $30668c514f90d554$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $30668c514f90d554$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("dlLC5")).Diagnostics;
    }
});

var $4CA2n = parcelRequire("4CA2n");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $4CA2n.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eIUhW")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("kf7uu")).Storage;
    }
});

$30668c514f90d554$var$__exportStar((parcelRequire("ge5Q0")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("gQAqt")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("gMEdt")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("6yXjF")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("dlLC5")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("eY3Ok")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("8AmNf")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("jIYlr")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("1zMX2")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("gJOcU")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("84MPJ")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("eIUhW")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("l2wIj")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("4NRde")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("dskBU")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("7Q0Y4")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("39Oab")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("3NmQX")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("fdSDn")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("cZ6kH")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("9LSa2")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("4TgO5")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("7jKOl")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("46jth")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("46Eic")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("bhhEl")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("1JtKM")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("5D3EU")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("ipkFC")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("jE84N")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("anXRC")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("4qBGS")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("kf7uu")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("RzrOC")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("h0RPa")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("jglHZ")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("6ULMU")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("21ucb")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("7N1Ma")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("b3IPY")), module.exports);
Object.assign((0, (parcelRequire("ge5Q0"))._getStatsigGlobal)(), {
    Log: (parcelRequire("eIUhW")).Log,
    SDK_VERSION: (parcelRequire("1JtKM")).SDK_VERSION
});

});
parcelRegister("ge5Q0", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $bd027b6447a8f66d$var$_a, $bd027b6447a8f66d$var$_b, $bd027b6447a8f66d$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $eIUhW = parcelRequire("eIUhW");
const $bd027b6447a8f66d$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $bd027b6447a8f66d$var$statsigGlobal;
    } catch (e) {
        return $bd027b6447a8f66d$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $bd027b6447a8f66d$var$_getStatsigGlobal;
const $bd027b6447a8f66d$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $bd027b6447a8f66d$var$_getStatsigGlobalFlag;
const $bd027b6447a8f66d$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $eIUhW.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $bd027b6447a8f66d$var$_getInstance;
const $bd027b6447a8f66d$var$GLOBAL_KEY = '__STATSIG__';
const $bd027b6447a8f66d$var$_window = typeof window !== 'undefined' ? window : {};
const $bd027b6447a8f66d$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $bd027b6447a8f66d$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $bd027b6447a8f66d$var$statsigGlobal = ($bd027b6447a8f66d$var$_c = ($bd027b6447a8f66d$var$_b = ($bd027b6447a8f66d$var$_a = $bd027b6447a8f66d$var$_window[$bd027b6447a8f66d$var$GLOBAL_KEY]) !== null && $bd027b6447a8f66d$var$_a !== void 0 ? $bd027b6447a8f66d$var$_a : $bd027b6447a8f66d$var$_global[$bd027b6447a8f66d$var$GLOBAL_KEY]) !== null && $bd027b6447a8f66d$var$_b !== void 0 ? $bd027b6447a8f66d$var$_b : $bd027b6447a8f66d$var$_globalThis[$bd027b6447a8f66d$var$GLOBAL_KEY]) !== null && $bd027b6447a8f66d$var$_c !== void 0 ? $bd027b6447a8f66d$var$_c : {
    instance: module.exports._getInstance
};
$bd027b6447a8f66d$var$_window[$bd027b6447a8f66d$var$GLOBAL_KEY] = $bd027b6447a8f66d$var$statsigGlobal;
$bd027b6447a8f66d$var$_global[$bd027b6447a8f66d$var$GLOBAL_KEY] = $bd027b6447a8f66d$var$statsigGlobal;
$bd027b6447a8f66d$var$_globalThis[$bd027b6447a8f66d$var$GLOBAL_KEY] = $bd027b6447a8f66d$var$statsigGlobal;

});
parcelRegister("eIUhW", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $ab80d676264066c9$var$DEBUG = ' DEBUG ';
const $ab80d676264066c9$var$_INFO = '  INFO ';
const $ab80d676264066c9$var$_WARN = '  WARN ';
const $ab80d676264066c9$var$ERROR = ' ERROR ';
function $ab80d676264066c9$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $ab80d676264066c9$var$Log {
    static info(...args) {
        if ($ab80d676264066c9$var$Log.level >= module.exports.LogLevel.Info) console.info($ab80d676264066c9$var$_INFO, ...$ab80d676264066c9$var$addTag(args));
    }
    static debug(...args) {
        if ($ab80d676264066c9$var$Log.level >= module.exports.LogLevel.Debug) console.debug($ab80d676264066c9$var$DEBUG, ...$ab80d676264066c9$var$addTag(args));
    }
    static warn(...args) {
        if ($ab80d676264066c9$var$Log.level >= module.exports.LogLevel.Warn) console.warn($ab80d676264066c9$var$_WARN, ...$ab80d676264066c9$var$addTag(args));
    }
    static error(...args) {
        if ($ab80d676264066c9$var$Log.level >= module.exports.LogLevel.Error) console.error($ab80d676264066c9$var$ERROR, ...$ab80d676264066c9$var$addTag(args));
    }
}
module.exports.Log = $ab80d676264066c9$var$Log;
$ab80d676264066c9$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("dlLC5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $9b822b8692b18229$var$MARKER_MAP = new Map();
const $9b822b8692b18229$var$ACT_START = 'start';
const $9b822b8692b18229$var$ACT_END = 'end';
const $9b822b8692b18229$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $9b822b8692b18229$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker({}, $9b822b8692b18229$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $9b822b8692b18229$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker(data, $9b822b8692b18229$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker(data, $9b822b8692b18229$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker({}, $9b822b8692b18229$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker(data, $9b822b8692b18229$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $9b822b8692b18229$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $9b822b8692b18229$var$_safeGetField(e, 'code'),
            name: $9b822b8692b18229$var$_safeGetField(e, 'name'),
            message: $9b822b8692b18229$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $9b822b8692b18229$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $9b822b8692b18229$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $9b822b8692b18229$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $9b822b8692b18229$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $9b822b8692b18229$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $9b822b8692b18229$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $9b822b8692b18229$var$MARKER_MAP.set(sdkKey, markers);
}
function $9b822b8692b18229$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("4CA2n", function(module, exports) {
"use strict";
var $35d6aa4b60253a18$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $gQAqt = parcelRequire("gQAqt");

var $gJOcU = parcelRequire("gJOcU");

var $eIUhW = parcelRequire("eIUhW");

var $4NRde = parcelRequire("4NRde");

var $3NmQX = parcelRequire("3NmQX");

var $bhhEl = parcelRequire("bhhEl");

var $5D3EU = parcelRequire("5D3EU");

var $kf7uu = parcelRequire("kf7uu");

var $jglHZ = parcelRequire("jglHZ");

var $21ucb = parcelRequire("21ucb");
const $35d6aa4b60253a18$var$DEFAULT_QUEUE_SIZE = 100;
const $35d6aa4b60253a18$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $35d6aa4b60253a18$var$MAX_DEDUPER_KEYS = 1000;
const $35d6aa4b60253a18$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $35d6aa4b60253a18$var$MAX_FAILED_LOGS = 500;
const $35d6aa4b60253a18$var$QUICK_FLUSH_WINDOW_MS = 200;
const $35d6aa4b60253a18$var$EVENT_LOGGER_MAP = {};
class $35d6aa4b60253a18$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $5D3EU.LoggingEnabledOption.disabled : $5D3EU.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $eIUhW.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $35d6aa4b60253a18$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $jglHZ.UrlConfiguration($4NRde.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $kf7uu._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $kf7uu.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $35d6aa4b60253a18$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $3NmQX._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $21ucb._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $35d6aa4b60253a18$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $35d6aa4b60253a18$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $35d6aa4b60253a18$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$35d6aa4b60253a18$var$EventLogger._safeFlushAndForget(this._sdkKey), $35d6aa4b60253a18$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $3NmQX._isServerEnv)()) return false;
        if (!(0, $bhhEl._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $gQAqt._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $35d6aa4b60253a18$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $35d6aa4b60253a18$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $21ucb._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $eIUhW.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $eIUhW.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$4NRde.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $35d6aa4b60253a18$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $kf7uu._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $eIUhW.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $kf7uu._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
                if (!$kf7uu.Storage.isReady()) yield $kf7uu.Storage.isReadyResolver();
                const events = (0, $kf7uu._getObjectFromStorage)(storageKey);
                if (!events) return;
                $kf7uu.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $eIUhW.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $gJOcU._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $eIUhW.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $3NmQX._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $35d6aa4b60253a18$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $35d6aa4b60253a18$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $35d6aa4b60253a18$var$EventLogger;

});
parcelRegister("gQAqt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $gJOcU = parcelRequire("gJOcU");
function $c43dc21f20ea933f$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $gJOcU._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $c43dc21f20ea933f$var$_getUserStorageKey;
function $c43dc21f20ea933f$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $c43dc21f20ea933f$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $gJOcU._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $c43dc21f20ea933f$var$_getStorageKey;

});
parcelRegister("gJOcU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $h0RPa = parcelRequire("h0RPa");
const $c2f7cb67581a275d$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $c2f7cb67581a275d$var$_DJB2;
const $c2f7cb67581a275d$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $c2f7cb67581a275d$var$_DJB2Object;
const $c2f7cb67581a275d$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $h0RPa._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $c2f7cb67581a275d$var$_getSortedObject;

});
parcelRegister("h0RPa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $c62c301f927e3283$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $c62c301f927e3283$var$_typeOf;
function $c62c301f927e3283$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $c62c301f927e3283$var$_isTypeMatch;

});



parcelRegister("4NRde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("3NmQX", function(module, exports) {

var $k1Wvt = parcelRequire("k1Wvt");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $2c37acdc22b09f9b$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $2c37acdc22b09f9b$var$_getWindowSafe;
const $2c37acdc22b09f9b$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $2c37acdc22b09f9b$var$_getDocumentSafe;
const $2c37acdc22b09f9b$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $k1Wvt !== 'undefined' && $k1Wvt.versions != null && $k1Wvt.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $2c37acdc22b09f9b$var$_isServerEnv;
const $2c37acdc22b09f9b$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $2c37acdc22b09f9b$var$_addWindowEventListenerSafe;
const $2c37acdc22b09f9b$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $2c37acdc22b09f9b$var$_addDocumentEventListenerSafe;
const $2c37acdc22b09f9b$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $2c37acdc22b09f9b$var$_getCurrentPageUrlSafe;
const $2c37acdc22b09f9b$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $2c37acdc22b09f9b$var$_getUnloadEvent;

});

parcelRegister("bhhEl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $835ef9220bfb399c$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $835ef9220bfb399c$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $835ef9220bfb399c$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $835ef9220bfb399c$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $835ef9220bfb399c$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $835ef9220bfb399c$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $835ef9220bfb399c$var$GATE_EXPOSURE_NAME || eventName === $835ef9220bfb399c$var$CONFIG_EXPOSURE_NAME || eventName === $835ef9220bfb399c$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $835ef9220bfb399c$var$_isExposureEvent;
const $835ef9220bfb399c$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $835ef9220bfb399c$var$_createExposure($835ef9220bfb399c$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $835ef9220bfb399c$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $835ef9220bfb399c$var$_createGateExposure;
function $835ef9220bfb399c$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $835ef9220bfb399c$var$_mapExposures;
const $835ef9220bfb399c$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $835ef9220bfb399c$var$_createExposure($835ef9220bfb399c$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $835ef9220bfb399c$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $835ef9220bfb399c$var$_createConfigExposure;
const $835ef9220bfb399c$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $835ef9220bfb399c$var$_createExposure($835ef9220bfb399c$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $835ef9220bfb399c$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $835ef9220bfb399c$var$_createLayerParameterExposure;
const $835ef9220bfb399c$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("5D3EU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("kf7uu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $eIUhW = parcelRequire("eIUhW");

var $3NmQX = parcelRequire("3NmQX");
const $ebcb04e5ffd9f73c$var$inMemoryStore = {};
const $ebcb04e5ffd9f73c$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$ebcb04e5ffd9f73c$var$inMemoryStore[key] ? $ebcb04e5ffd9f73c$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $ebcb04e5ffd9f73c$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $ebcb04e5ffd9f73c$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($ebcb04e5ffd9f73c$var$inMemoryStore)
};
let $ebcb04e5ffd9f73c$var$_localStorageProvider = null;
try {
    const win = (0, $3NmQX._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $ebcb04e5ffd9f73c$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $eIUhW.Log.warn('Failed to setup localStorageProvider.');
}
let $ebcb04e5ffd9f73c$var$_main = $ebcb04e5ffd9f73c$var$_localStorageProvider !== null && $ebcb04e5ffd9f73c$var$_localStorageProvider !== void 0 ? $ebcb04e5ffd9f73c$var$_localStorageProvider : $ebcb04e5ffd9f73c$var$_inMemoryProvider;
let $ebcb04e5ffd9f73c$var$_current = $ebcb04e5ffd9f73c$var$_main;
function $ebcb04e5ffd9f73c$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($ebcb04e5ffd9f73c$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$ebcb04e5ffd9f73c$var$_current.isReady(),
    isReadyResolver: ()=>$ebcb04e5ffd9f73c$var$_current.isReadyResolver(),
    getProviderName: ()=>$ebcb04e5ffd9f73c$var$_current.getProviderName(),
    getItem: (key)=>$ebcb04e5ffd9f73c$var$_inMemoryBreaker(()=>$ebcb04e5ffd9f73c$var$_current.getItem(key)),
    setItem: (key, value)=>$ebcb04e5ffd9f73c$var$_inMemoryBreaker(()=>$ebcb04e5ffd9f73c$var$_current.setItem(key, value)),
    removeItem: (key)=>$ebcb04e5ffd9f73c$var$_current.removeItem(key),
    getAllKeys: ()=>$ebcb04e5ffd9f73c$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $ebcb04e5ffd9f73c$var$_main = newProvider;
        $ebcb04e5ffd9f73c$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $ebcb04e5ffd9f73c$var$_current = $ebcb04e5ffd9f73c$var$_inMemoryProvider;
        else $ebcb04e5ffd9f73c$var$_current = $ebcb04e5ffd9f73c$var$_main;
    }
};
function $ebcb04e5ffd9f73c$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $eIUhW.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $ebcb04e5ffd9f73c$var$_getObjectFromStorage;
function $ebcb04e5ffd9f73c$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $ebcb04e5ffd9f73c$var$_setObjectInStorage;

});

parcelRegister("jglHZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $gJOcU = parcelRequire("gJOcU");

var $4NRde = parcelRequire("4NRde");
const $e06059cb188639a0$var$ENDPOINT_DNS_KEY_MAP = {
    [$4NRde.Endpoint._initialize]: 'i',
    [$4NRde.Endpoint._rgstr]: 'e',
    [$4NRde.Endpoint._download_config_specs]: 'd'
};
class $e06059cb188639a0$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $e06059cb188639a0$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $4NRde.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $gJOcU._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $e06059cb188639a0$var$UrlConfiguration;

});

parcelRegister("21ucb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $3NmQX = parcelRequire("3NmQX");
const $179318fcf1eb5c3d$var$FOREGROUND = 'foreground';
const $179318fcf1eb5c3d$var$BACKGROUND = 'background';
const $179318fcf1eb5c3d$var$LISTENERS = [];
let $179318fcf1eb5c3d$var$current = $179318fcf1eb5c3d$var$FOREGROUND;
let $179318fcf1eb5c3d$var$isUnloading = false;
const $179318fcf1eb5c3d$var$_isCurrentlyVisible = ()=>{
    return $179318fcf1eb5c3d$var$current === $179318fcf1eb5c3d$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $179318fcf1eb5c3d$var$_isCurrentlyVisible;
const $179318fcf1eb5c3d$var$_isUnloading = ()=>$179318fcf1eb5c3d$var$isUnloading;
module.exports._isUnloading = $179318fcf1eb5c3d$var$_isUnloading;
const $179318fcf1eb5c3d$var$_subscribeToVisiblityChanged = (listener)=>{
    $179318fcf1eb5c3d$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $179318fcf1eb5c3d$var$_subscribeToVisiblityChanged;
const $179318fcf1eb5c3d$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $179318fcf1eb5c3d$var$current) return;
    $179318fcf1eb5c3d$var$current = visibility;
    $179318fcf1eb5c3d$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $179318fcf1eb5c3d$var$_notifyVisibilityChanged;
(0, $3NmQX._addWindowEventListenerSafe)('focus', ()=>{
    $179318fcf1eb5c3d$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($179318fcf1eb5c3d$var$FOREGROUND);
});
(0, $3NmQX._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($179318fcf1eb5c3d$var$BACKGROUND));
(0, $3NmQX._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $179318fcf1eb5c3d$var$FOREGROUND : $179318fcf1eb5c3d$var$BACKGROUND);
});
(0, $3NmQX._addWindowEventListenerSafe)((0, $3NmQX._getUnloadEvent)(), ()=>{
    $179318fcf1eb5c3d$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($179318fcf1eb5c3d$var$BACKGROUND);
});

});


parcelRegister("1JtKM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $143112de3ba9f699$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$143112de3ba9f699$var$metadata,
    add: (additions)=>{
        $143112de3ba9f699$var$metadata = Object.assign(Object.assign({}, $143112de3ba9f699$var$metadata), additions);
    }
};

});

parcelRegister("gMEdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6yXjF", function(module, exports) {
"use strict";
var $4c73ee05cee48c47$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $eIUhW = parcelRequire("eIUhW");

var $4TgO5 = parcelRequire("4TgO5");

var $4qBGS = parcelRequire("4qBGS");

var $kf7uu = parcelRequire("kf7uu");

var $RzrOC = parcelRequire("RzrOC");
const $4c73ee05cee48c47$var$CACHE_LIMIT = 10;
const $4c73ee05cee48c47$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $4c73ee05cee48c47$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $4c73ee05cee48c47$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $4c73ee05cee48c47$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $4qBGS._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $4qBGS._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $4c73ee05cee48c47$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $4TgO5.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $4c73ee05cee48c47$var$__awaiter(this, void 0, void 0, function*() {
            if (!$kf7uu.Storage.isReady()) yield $kf7uu.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $eIUhW.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $4c73ee05cee48c47$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $4qBGS._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $4c73ee05cee48c47$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $eIUhW.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $RzrOC._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $4TgO5.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $4c73ee05cee48c47$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $4c73ee05cee48c47$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $eIUhW.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $kf7uu.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($kf7uu.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $RzrOC._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $4c73ee05cee48c47$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $kf7uu.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $kf7uu._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $4c73ee05cee48c47$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $kf7uu.Storage.removeItem(evictable);
        }
        (0, $kf7uu._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $4c73ee05cee48c47$var$DataAdapterCore;
function $4c73ee05cee48c47$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $4qBGS._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $4c73ee05cee48c47$var$_makeDataAdapterResult;
class $4c73ee05cee48c47$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $eIUhW.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $4c73ee05cee48c47$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $4c73ee05cee48c47$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("4TgO5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $gQAqt = parcelRequire("gQAqt");

var $eIUhW = parcelRequire("eIUhW");

var $3NmQX = parcelRequire("3NmQX");

var $kf7uu = parcelRequire("kf7uu");

var $6ULMU = parcelRequire("6ULMU");
const $38f955f33f5880aa$var$PROMISE_MAP = {};
const $38f955f33f5880aa$var$COOKIE_ENABLED_MAP = {};
const $38f955f33f5880aa$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($38f955f33f5880aa$var$DISABLED_MAP[sdkKey]) return null;
        if ($38f955f33f5880aa$var$PROMISE_MAP[sdkKey] != null) return $38f955f33f5880aa$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $38f955f33f5880aa$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $38f955f33f5880aa$var$PROMISE_MAP[sdkKey] = stableID;
            $38f955f33f5880aa$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $38f955f33f5880aa$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $6ULMU.getUUID)();
        $38f955f33f5880aa$var$_persistToStorage(stableID, sdkKey);
        $38f955f33f5880aa$var$_persistToCookie(stableID, sdkKey);
        $38f955f33f5880aa$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $38f955f33f5880aa$var$PROMISE_MAP[sdkKey] = override;
        $38f955f33f5880aa$var$_persistToStorage(override, sdkKey);
        $38f955f33f5880aa$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $38f955f33f5880aa$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $38f955f33f5880aa$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $38f955f33f5880aa$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $gQAqt._getStorageKey)(sdkKey)}`;
}
function $38f955f33f5880aa$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $38f955f33f5880aa$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $kf7uu._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $eIUhW.Log.warn('Failed to save StableID to storage');
    }
}
function $38f955f33f5880aa$var$_loadFromStorage(sdkKey) {
    const storageKey = $38f955f33f5880aa$var$_getStableIDStorageKey(sdkKey);
    return (0, $kf7uu._getObjectFromStorage)(storageKey);
}
function $38f955f33f5880aa$var$_loadFromCookie(sdkKey) {
    if (!$38f955f33f5880aa$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $3NmQX._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $38f955f33f5880aa$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $38f955f33f5880aa$var$_persistToCookie(stableID, sdkKey) {
    if (!$38f955f33f5880aa$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $3NmQX._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$38f955f33f5880aa$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $38f955f33f5880aa$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $gQAqt._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $38f955f33f5880aa$var$getCookieName;

});
parcelRegister("6ULMU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $508d0abbed982e19$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $508d0abbed982e19$var$getUUID;

});


parcelRegister("4qBGS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $gJOcU = parcelRequire("gJOcU");

var $eIUhW = parcelRequire("eIUhW");
function $3396d3ab5fe99a49$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $eIUhW.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $3396d3ab5fe99a49$var$_normalizeUser;
function $3396d3ab5fe99a49$var$_getFullUserHash(user) {
    return user ? (0, $gJOcU._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $3396d3ab5fe99a49$var$_getFullUserHash;

});

parcelRegister("RzrOC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $eIUhW = parcelRequire("eIUhW");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $0a1072837f60f5e9$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $eIUhW.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $0a1072837f60f5e9$var$_typedJsonParse;

});


parcelRegister("eY3Ok", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8AmNf", function(module, exports) {
"use strict";
var $64035dcb506143c7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $eIUhW = parcelRequire("eIUhW");

var $fdSDn = parcelRequire("fdSDn");

var $1JtKM = parcelRequire("1JtKM");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $64035dcb506143c7$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $64035dcb506143c7$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $64035dcb506143c7$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $64035dcb506143c7$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $eIUhW.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$64035dcb506143c7$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($64035dcb506143c7$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $64035dcb506143c7$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $fdSDn.SDKType._get(this._sdkKey);
                    const statsigMetadata = $1JtKM.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $64035dcb506143c7$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $64035dcb506143c7$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $64035dcb506143c7$var$ErrorBoundary;
function $64035dcb506143c7$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $64035dcb506143c7$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $64035dcb506143c7$var$UNKNOWN_ERROR;
    }
}
function $64035dcb506143c7$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $64035dcb506143c7$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("fdSDn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $b152731e92464821$var$SDK_CLIENT = {};
let $b152731e92464821$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $b152731e92464821$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($b152731e92464821$var$suffix !== null && $b152731e92464821$var$suffix !== void 0 ? $b152731e92464821$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $b152731e92464821$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$b152731e92464821$var$suffix || $b152731e92464821$var$suffix === '-react') $b152731e92464821$var$suffix = '-' + binding;
    }
};

});


parcelRegister("jIYlr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1zMX2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("84MPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("l2wIj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $f5132924e603febc$var$EXIST_KEYS = new Set([]);
const $f5132924e603febc$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $f5132924e603febc$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($f5132924e603febc$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($f5132924e603febc$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $f5132924e603febc$var$createMemoKey;

});

parcelRegister("dskBU", function(module, exports) {
"use strict";
var $9cbde0aae193ec4d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $ge5Q0 = parcelRequire("ge5Q0");

var $ge5Q0 = parcelRequire("ge5Q0");

var $dlLC5 = parcelRequire("dlLC5");

var $eIUhW = parcelRequire("eIUhW");

var $4NRde = parcelRequire("4NRde");

var $hf2Ts = parcelRequire("hf2Ts");

var $b3IPY = parcelRequire("b3IPY");

var $fdSDn = parcelRequire("fdSDn");

var $3NmQX = parcelRequire("3NmQX");

var $cZ6kH = parcelRequire("cZ6kH");

var $4TgO5 = parcelRequire("4TgO5");

var $46jth = parcelRequire("46jth");

var $1JtKM = parcelRequire("1JtKM");

var $5D3EU = parcelRequire("5D3EU");

var $21ucb = parcelRequire("21ucb");
const $9cbde0aae193ec4d$var$DEFAULT_TIMEOUT_MS = 10000;
const $9cbde0aae193ec4d$var$BACKOFF_BASE_MS = 500;
const $9cbde0aae193ec4d$var$BACKOFF_MAX_MS = 30000;
const $9cbde0aae193ec4d$var$RATE_LIMIT_WINDOW_MS = 1000;
const $9cbde0aae193ec4d$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $9cbde0aae193ec4d$var$LEAK_RATE = $9cbde0aae193ec4d$var$RATE_LIMIT_MAX_REQ_COUNT / $9cbde0aae193ec4d$var$RATE_LIMIT_WINDOW_MS;
const $9cbde0aae193ec4d$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $9cbde0aae193ec4d$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $9cbde0aae193ec4d$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $hf2Ts.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$9cbde0aae193ec4d$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $9cbde0aae193ec4d$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $9cbde0aae193ec4d$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$9cbde0aae193ec4d$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $eIUhW.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $21ucb._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $9cbde0aae193ec4d$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $9cbde0aae193ec4d$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $9cbde0aae193ec4d$var$_getErrorMessage(error);
                const timedOut = $9cbde0aae193ec4d$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $9cbde0aae193ec4d$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$9cbde0aae193ec4d$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $46jth.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $eIUhW.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $9cbde0aae193ec4d$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $5D3EU.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $5D3EU.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $9cbde0aae193ec4d$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $9cbde0aae193ec4d$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $4NRde.Endpoint._initialize || args.urlConfig.endpoint === $4NRde.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$4NRde.NetworkParam.SdkKey]: args.sdkKey,
            [$4NRde.NetworkParam.SdkType]: $fdSDn.SDKType._get(args.sdkKey),
            [$4NRde.NetworkParam.SdkVersion]: $1JtKM.SDK_VERSION,
            [$4NRde.NetworkParam.Time]: String(Date.now()),
            [$4NRde.NetworkParam.SessionID]: $cZ6kH.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $3NmQX._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $ge5Q0._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$4NRde.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $eIUhW.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $9cbde0aae193ec4d$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$9cbde0aae193ec4d$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($eIUhW.Log.error);
                writer.close().catch($eIUhW.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$4NRde.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $eIUhW.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $9cbde0aae193ec4d$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $9cbde0aae193ec4d$var$NetworkCore;
const $9cbde0aae193ec4d$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $eIUhW.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $9cbde0aae193ec4d$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $4TgO5.StableID.get(sdkKey);
    const sessionID = $cZ6kH.SessionID.get(sdkKey);
    const sdkType = $fdSDn.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $1JtKM.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $9cbde0aae193ec4d$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $ge5Q0._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $b3IPY.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $5D3EU.LogEventCompressionMode.Disabled:
            return false;
        case $5D3EU.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $5D3EU.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $9cbde0aae193ec4d$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $9cbde0aae193ec4d$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $9cbde0aae193ec4d$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $4NRde.Endpoint._initialize) return;
    $dlLC5.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $9cbde0aae193ec4d$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $4NRde.Endpoint._initialize) return;
    $dlLC5.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $dlLC5.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $9cbde0aae193ec4d$var$_exponentialBackoff(attempt) {
    return $9cbde0aae193ec4d$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($9cbde0aae193ec4d$var$BACKOFF_BASE_MS * (attempt * attempt), $9cbde0aae193ec4d$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("hf2Ts", function(module, exports) {
"use strict";
var $c8d614f560972e95$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $4J75K = parcelRequire("4J75K");

var $gJOcU = parcelRequire("gJOcU");

var $eIUhW = parcelRequire("eIUhW");

var $kf7uu = parcelRequire("kf7uu");
const $c8d614f560972e95$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $c8d614f560972e95$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $c8d614f560972e95$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $c8d614f560972e95$var$DEFAULT_TTL_MS;
        $c8d614f560972e95$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $c8d614f560972e95$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $c8d614f560972e95$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $c8d614f560972e95$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$c8d614f560972e95$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $c8d614f560972e95$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $c8d614f560972e95$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $c8d614f560972e95$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $c8d614f560972e95$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $4J75K._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $c8d614f560972e95$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $c8d614f560972e95$var$NetworkFallbackResolver;
function $c8d614f560972e95$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $c8d614f560972e95$var$_isDomainFailure;
function $c8d614f560972e95$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $gJOcU._DJB2)(sdkKey)}`;
}
function $c8d614f560972e95$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $c8d614f560972e95$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $kf7uu.Storage.removeItem(hashKey);
        return;
    }
    $kf7uu.Storage.setItem(hashKey, JSON.stringify(info));
}
function $c8d614f560972e95$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $c8d614f560972e95$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $kf7uu.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $eIUhW.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $c8d614f560972e95$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("4J75K", function(module, exports) {
"use strict";
var $3710dda6ba9e9270$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $3710dda6ba9e9270$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $3710dda6ba9e9270$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $3710dda6ba9e9270$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $3710dda6ba9e9270$var$MAX_START_LOOKUP = 200;
function $3710dda6ba9e9270$var$_fetchTxtRecords(networkFunc) {
    return $3710dda6ba9e9270$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($3710dda6ba9e9270$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $3710dda6ba9e9270$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $3710dda6ba9e9270$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $3710dda6ba9e9270$var$_fetchTxtRecords;
function $3710dda6ba9e9270$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $3710dda6ba9e9270$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $3710dda6ba9e9270$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("b3IPY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $80d2c148579ecbac$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $80d2c148579ecbac$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $80d2c148579ecbac$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("cZ6kH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $ge5Q0 = parcelRequire("ge5Q0");

var $gQAqt = parcelRequire("gQAqt");

var $eIUhW = parcelRequire("eIUhW");

var $kf7uu = parcelRequire("kf7uu");

var $6ULMU = parcelRequire("6ULMU");
const $9740181bf2016a22$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $9740181bf2016a22$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $9740181bf2016a22$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($9740181bf2016a22$var$PROMISE_MAP[sdkKey] == null) $9740181bf2016a22$var$PROMISE_MAP[sdkKey] = $9740181bf2016a22$var$_loadSession(sdkKey);
        const session = $9740181bf2016a22$var$PROMISE_MAP[sdkKey];
        return $9740181bf2016a22$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $9740181bf2016a22$var$PROMISE_MAP[sdkKey] = $9740181bf2016a22$var$_overrideSessionId(override, sdkKey);
    }
};
function $9740181bf2016a22$var$_loadSession(sdkKey) {
    let data = $9740181bf2016a22$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $6ULMU.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $9740181bf2016a22$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $9740181bf2016a22$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($9740181bf2016a22$var$_isIdle(data) || $9740181bf2016a22$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $6ULMU.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $9740181bf2016a22$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $9740181bf2016a22$var$_createSessionTimeout(sdkKey, $9740181bf2016a22$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $9740181bf2016a22$var$_createSessionTimeout(sdkKey, $9740181bf2016a22$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $9740181bf2016a22$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $ge5Q0._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $9740181bf2016a22$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $9740181bf2016a22$var$MAX_SESSION_IDLE_TIME;
}
function $9740181bf2016a22$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $9740181bf2016a22$var$MAX_SESSION_AGE;
}
function $9740181bf2016a22$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $gQAqt._getStorageKey)(sdkKey)}`;
}
function $9740181bf2016a22$var$_persistToStorage(session, sdkKey) {
    const storageKey = $9740181bf2016a22$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $kf7uu._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $eIUhW.Log.warn('Failed to save SessionID');
    }
}
function $9740181bf2016a22$var$_loadFromStorage(sdkKey) {
    const storageKey = $9740181bf2016a22$var$_getSessionIDStorageKey(sdkKey);
    return (0, $kf7uu._getObjectFromStorage)(storageKey);
}

});

parcelRegister("46jth", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("7Q0Y4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("39Oab", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9LSa2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $71d2840c914b9cdf$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $71d2840c914b9cdf$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $71d2840c914b9cdf$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $71d2840c914b9cdf$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $71d2840c914b9cdf$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $71d2840c914b9cdf$var$_fastApproxSizeOf;

});

parcelRegister("7jKOl", function(module, exports) {
"use strict";
var $553e9e732ea8cd3f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $ge5Q0 = parcelRequire("ge5Q0");

var $ge5Q0 = parcelRequire("ge5Q0");

var $8AmNf = parcelRequire("8AmNf");

var $4CA2n = parcelRequire("4CA2n");

var $eIUhW = parcelRequire("eIUhW");

var $l2wIj = parcelRequire("l2wIj");

var $3NmQX = parcelRequire("3NmQX");

var $cZ6kH = parcelRequire("cZ6kH");

var $4TgO5 = parcelRequire("4TgO5");

var $5D3EU = parcelRequire("5D3EU");

var $kf7uu = parcelRequire("kf7uu");
const $553e9e732ea8cd3f$var$MAX_MEMO_CACHE_SIZE = 3000;
class $553e9e732ea8cd3f$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($eIUhW.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $kf7uu.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $cZ6kH.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $kf7uu.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $4TgO5.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $4TgO5.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $4CA2n.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $8AmNf.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $kf7uu.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $553e9e732ea8cd3f$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $kf7uu.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $4TgO5.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($5D3EU.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $553e9e732ea8cd3f$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $eIUhW.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $l2wIj.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $553e9e732ea8cd3f$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $553e9e732ea8cd3f$var$StatsigClientBase;
function $553e9e732ea8cd3f$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $3NmQX._isServerEnv)()) return;
    const statsigGlobal = (0, $ge5Q0._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $eIUhW.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("46Eic", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("ipkFC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jE84N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $eIUhW = parcelRequire("eIUhW");

var $h0RPa = parcelRequire("h0RPa");
function $e4d8048876970bcc$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $e4d8048876970bcc$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $e4d8048876970bcc$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $e4d8048876970bcc$var$_makeFeatureGate;
function $e4d8048876970bcc$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $e4d8048876970bcc$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $e4d8048876970bcc$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $e4d8048876970bcc$var$_makeDynamicConfig;
function $e4d8048876970bcc$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $e4d8048876970bcc$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $e4d8048876970bcc$var$_makeExperiment;
function $e4d8048876970bcc$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $e4d8048876970bcc$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $e4d8048876970bcc$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $e4d8048876970bcc$var$_makeLayer;
function $e4d8048876970bcc$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $e4d8048876970bcc$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $e4d8048876970bcc$var$_mergeOverride;
function $e4d8048876970bcc$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $h0RPa._isTypeMatch)(found, fallback)) {
            $eIUhW.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $e4d8048876970bcc$var$_makeTypedGet;

});

parcelRegister("anXRC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7N1Ma", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $5abe7cac4a102f53$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $5abe7cac4a102f53$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("jCry9", function(module, exports) {
"use strict";
var $03af98832d29291f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $49Dnu = parcelRequire("49Dnu");

var $91Bz6 = parcelRequire("91Bz6");

var $5qJeH = parcelRequire("5qJeH");

var $19OtR = parcelRequire("19OtR");

var $6cXIa = parcelRequire("6cXIa");
class $03af98832d29291f$var$StatsigClient extends $49Dnu.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $49Dnu._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $03af98832d29291f$var$StatsigClient) return instance;
        $49Dnu.Log.warn((0, $49Dnu._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $03af98832d29291f$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $49Dnu.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $5qJeH.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $6cXIa.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($49Dnu.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($49Dnu.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($49Dnu.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($49Dnu.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($49Dnu.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($49Dnu.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $91Bz6.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $49Dnu.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $49Dnu.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $03af98832d29291f$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $49Dnu.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $49Dnu.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $03af98832d29291f$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $03af98832d29291f$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $49Dnu.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $49Dnu.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $49Dnu.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $49Dnu.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($49Dnu.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $49Dnu.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $49Dnu.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $49Dnu.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $49Dnu.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $49Dnu.StatsigSession.get(this._sdkKey),
            stableID: $49Dnu.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $03af98832d29291f$var$__awaiter(this, void 0, void 0, function*() {
            if (!$49Dnu.Storage.isReady()) yield $49Dnu.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $49Dnu.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $49Dnu.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $49Dnu._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$49Dnu.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$49Dnu.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $49Dnu.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $49Dnu._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $49Dnu._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $49Dnu._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $49Dnu._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $49Dnu._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $49Dnu._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $49Dnu._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $49Dnu._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $49Dnu._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $49Dnu._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $19OtR._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $19OtR._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $03af98832d29291f$var$StatsigClient;

});
parcelRegister("91Bz6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $49Dnu = parcelRequire("49Dnu");

var $8PO8Y = parcelRequire("8PO8Y");

var $aD2oW = parcelRequire("aD2oW");
class $692158b116e95668$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $49Dnu._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $49Dnu._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $aD2oW.V2InitializeContainer(values);
        else this._values = new $8PO8Y.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $49Dnu.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $49Dnu.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $49Dnu._getFullUserHash)(userForComparison) !== (0, $49Dnu._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $692158b116e95668$var$EvaluationStore;

});
parcelRegister("8PO8Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $49Dnu = parcelRequire("49Dnu");
class $66e9fbacb8c716bd$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $49Dnu._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $66e9fbacb8c716bd$var$V1InitializeContainer;

});

parcelRegister("aD2oW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $49Dnu = parcelRequire("49Dnu");
class $7bcf68ba3431efb7$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $49Dnu._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $7bcf68ba3431efb7$var$V2InitializeContainer;

});


parcelRegister("5qJeH", function(module, exports) {
"use strict";
var $3f4278646d739f63$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $49Dnu = parcelRequire("49Dnu");

var $gd5Yu = parcelRequire("gd5Yu");
class $3f4278646d739f63$var$StatsigNetwork extends $49Dnu.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $49Dnu.UrlConfiguration($49Dnu.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $3f4278646d739f63$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $49Dnu._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $3f4278646d739f63$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $gd5Yu._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $3f4278646d739f63$var$StatsigNetwork;

});
parcelRegister("gd5Yu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $49Dnu = parcelRequire("49Dnu");
const $bcd27ea837ac45e4$var$MAX_DELTAS_SORT_DEPTH = 2;
function $bcd27ea837ac45e4$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $49Dnu._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $bcd27ea837ac45e4$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $bcd27ea837ac45e4$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $49Dnu._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $bcd27ea837ac45e4$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $bcd27ea837ac45e4$var$_resolveDeltasResponse;
function $bcd27ea837ac45e4$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $bcd27ea837ac45e4$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $bcd27ea837ac45e4$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $bcd27ea837ac45e4$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $bcd27ea837ac45e4$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $bcd27ea837ac45e4$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("19OtR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $49Dnu = parcelRequire("49Dnu");
const $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $0d7dca1fe2ab336f$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $0d7dca1fe2ab336f$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $49Dnu._isTypeMatch)(value, fallback);
}
function $0d7dca1fe2ab336f$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $0d7dca1fe2ab336f$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $0d7dca1fe2ab336f$var$_shouldLogExposure(options) ? undefined : $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $0d7dca1fe2ab336f$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $0d7dca1fe2ab336f$var$_shouldLogExposure(options) ? undefined : $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($0d7dca1fe2ab336f$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $0d7dca1fe2ab336f$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $0d7dca1fe2ab336f$var$_shouldLogExposure(options) ? undefined : $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($0d7dca1fe2ab336f$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $0d7dca1fe2ab336f$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $0d7dca1fe2ab336f$var$_shouldLogExposure(options) ? undefined : $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($0d7dca1fe2ab336f$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $0d7dca1fe2ab336f$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $49Dnu._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $0d7dca1fe2ab336f$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $0d7dca1fe2ab336f$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $0d7dca1fe2ab336f$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $0d7dca1fe2ab336f$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $0d7dca1fe2ab336f$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $0d7dca1fe2ab336f$var$_makeParamStoreGetter;

});

parcelRegister("6cXIa", function(module, exports) {
"use strict";
var $48522e816d83b334$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $49Dnu = parcelRequire("49Dnu");

var $5qJeH = parcelRequire("5qJeH");
class $48522e816d83b334$var$StatsigEvaluationsDataAdapter extends $49Dnu.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $5qJeH.default) this._network = network;
        else this._network = new $5qJeH.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $49Dnu._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $49Dnu._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $49Dnu.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $48522e816d83b334$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $49Dnu._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$49Dnu.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $49Dnu._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $48522e816d83b334$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("iaAZy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6823a650e7a352e$export$2e2bcd8739ae039);

var $hacB2 = parcelRequire("hacB2");
const $d6823a650e7a352e$export$a66cbd9b2289cd78 = '@all-features';
class $d6823a650e7a352e$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hacB2)))();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($d6823a650e7a352e$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($d6823a650e7a352e$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($d6823a650e7a352e$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $d6823a650e7a352e$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});

parcelRegister("4p9Sd", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $654031b0bde63c04$export$6dc24881a3d96325);

var $dBdHW = parcelRequire("dBdHW");

var $23J4N = parcelRequire("23J4N");
class $654031b0bde63c04$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $654031b0bde63c04$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $dBdHW.migrateEvaluationDetails)(experiment.details), (0, $23J4N.migrateSecondaryExposures)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("dBdHW", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $c84ffd3ef08963ee$export$18ad168d3dbac899);

var $lOIRH = parcelRequire("lOIRH");
const $c84ffd3ef08963ee$var$evaluationReasonMappings = Object.entries((0, $lOIRH.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $c84ffd3ef08963ee$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $c84ffd3ef08963ee$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $lOIRH.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};

});
parcelRegister("lOIRH", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $d66c4f9a9e8cecbd$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
const $d66c4f9a9e8cecbd$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

});


parcelRegister("23J4N", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $44e2b104b9319839$export$55fd683752d01e67);
const $44e2b104b9319839$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("kIeaF", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $83e053890fdc7361$export$936d0764594b6eb3);

var $dBdHW = parcelRequire("dBdHW");

var $23J4N = parcelRequire("23J4N");
class $83e053890fdc7361$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $83e053890fdc7361$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $dBdHW.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $23J4N.migrateSecondaryExposures)(layer.__evaluation?.secondary_exposures ?? []), (0, $23J4N.migrateSecondaryExposures)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
}

});

parcelRegister("jQSGj", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $eb3a7f8a80185386$export$1148cb79ceecd5fa);
/**
 * Deeply merges source objects into the target object.
 * Handles nested objects, but arrays are not handled (replaced).
 */ function $eb3a7f8a80185386$export$1148cb79ceecd5fa(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return $eb3a7f8a80185386$export$1148cb79ceecd5fa(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $eb3a7f8a80185386$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $eb3a7f8a80185386$export$1148cb79ceecd5fa(target, ...sources);
}

});

parcelRegister("5Oj64", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f12bd6461e3c73f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $joS99 = parcelRequire("joS99");

var $4d6dI = parcelRequire("4d6dI");

var $4VRUo = parcelRequire("4VRUo");
const $3f12bd6461e3c73f$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $3f12bd6461e3c73f$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $3f12bd6461e3c73f$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $3f12bd6461e3c73f$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $3f12bd6461e3c73f$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $3f12bd6461e3c73f$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $3f12bd6461e3c73f$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $3f12bd6461e3c73f$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $3f12bd6461e3c73f$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $3f12bd6461e3c73f$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $3f12bd6461e3c73f$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $4VRUo.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $4VRUo.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $3f12bd6461e3c73f$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $joS99.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $joS99.FeatureGateEnvironment).Production:
                return $3f12bd6461e3c73f$export$18c93900db9358a4;
            case (0, $joS99.FeatureGateEnvironment).Staging:
                return $3f12bd6461e3c73f$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $joS99.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $joS99.FeatureGateEnvironment).Development:
                return $3f12bd6461e3c73f$export$f058dbf75c3bc647;
            case (0, $joS99.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $3f12bd6461e3c73f$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $3f12bd6461e3c73f$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $3f12bd6461e3c73f$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $3f12bd6461e3c73f$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $4d6dI.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $3f12bd6461e3c73f$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$3f12bd6461e3c73f$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$3f12bd6461e3c73f$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("joS99", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $b88290f2101ac95e$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $b88290f2101ac95e$export$c42b7bbc5e7ba555);
const $b88290f2101ac95e$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const $b88290f2101ac95e$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const $b88290f2101ac95e$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("4d6dI", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $c298906a7c96abbb$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $c298906a7c96abbb$export$a59f8d67326bd1cb = undefined;

});

parcelRegister("4VRUo", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $fcd83743f85c978c$export$286baf652d0b1206);
class $fcd83743f85c978c$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("jOwMd", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $4b80c6b0ddd45a4a$export$d119b37e5f788b43);

var $1KT2J = parcelRequire("1KT2J");

var $joS99 = parcelRequire("joS99");
const $4b80c6b0ddd45a4a$export$d119b37e5f788b43 = (options)=>({
        /**
   * If more federal PerimeterTypes are added in the future, this should be updated so
   * that isFedRamp() === true always returns the strictest perimeter.
   */ perimeter: (0, $1KT2J.isFedRamp)() ? (0, $joS99.PerimeterType).FEDRAMP_MODERATE : (0, $joS99.PerimeterType).COMMERCIAL,
        ...options
    });

});

parcelRegister("2YPaE", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $d4cddd24e8d889db$export$202946b690d26d22);
const $d4cddd24e8d889db$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};

});

parcelRegister("iTSgg", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $9cfd8eba476dcbec$export$55fffef3474104af);

var $1T45w = parcelRequire("1T45w");
class $9cfd8eba476dcbec$export$55fffef3474104af extends (0, $1T45w.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $1T45w.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1T45w._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1T45w._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $1T45w._getStorageKey)(this._getSdkKey(), user);
        return `${0, $1T45w.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("1xPXE", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $5df8651d7f89ed9e$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $5df8651d7f89ed9e$export$bcb28fbac1def494);

var $49Dnu = parcelRequire("49Dnu");
const $5df8651d7f89ed9e$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $5df8651d7f89ed9e$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $5df8651d7f89ed9e$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $5df8651d7f89ed9e$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $5df8651d7f89ed9e$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $5df8651d7f89ed9e$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $5df8651d7f89ed9e$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $5df8651d7f89ed9e$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $5df8651d7f89ed9e$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $5df8651d7f89ed9e$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($5df8651d7f89ed9e$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem($5df8651d7f89ed9e$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $49Dnu._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$5df8651d7f89ed9e$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($5df8651d7f89ed9e$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $5df8651d7f89ed9e$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $5df8651d7f89ed9e$var$makeEmptyStore();
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($5df8651d7f89ed9e$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $49Dnu._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $5df8651d7f89ed9e$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($5df8651d7f89ed9e$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $49Dnu._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $5df8651d7f89ed9e$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});

parcelRegister("deCXZ", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $11e748dcc8cde44b$export$fa1c2bbf4100b8bc);
const $11e748dcc8cde44b$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("hHsjm", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $67768b8aa87e23ed$export$3dad1db244472f32);
const $67768b8aa87e23ed$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    const { stableId: stableId, ...otherIdentifiers } = identifiers;
    const user = {
        customIDs: {
            ...otherIdentifiers,
            ...stableId !== undefined ? {
                stableID: stableId
            } : {}
        },
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("7qISg", function(module, exports) {
$parcel$export(module.exports, "default", () => $e118919a32101f2b$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
const $e118919a32101f2b$var$interactionContext = (0, $1v5pe.createContext)(null);
var $e118919a32101f2b$export$2e2bcd8739ae039 = $e118919a32101f2b$var$interactionContext;

});

parcelRegister("gOQGR", function(module, exports) {
$parcel$export(module.exports, "PersistQueryClientProvider", () => $c3ea3010b9f638d5$export$9d736f54481e482f);

var $g2Cfd = parcelRequire("g2Cfd");

var $1v5pe = parcelRequire("1v5pe");

var $13qag = parcelRequire("13qag");

var $9Zfop = parcelRequire("9Zfop");
var $eAih2 = parcelRequire("eAih2");
'use client';
const $c3ea3010b9f638d5$export$9d736f54481e482f = ({ client: client, children: children, persistOptions: persistOptions, onSuccess: onSuccess, ...props })=>{
    const [isRestoring, setIsRestoring] = $1v5pe.useState(true);
    const refs = $1v5pe.useRef({
        persistOptions: persistOptions,
        onSuccess: onSuccess
    });
    const didRestore = $1v5pe.useRef(false);
    $1v5pe.useEffect(()=>{
        refs.current = {
            persistOptions: persistOptions,
            onSuccess: onSuccess
        };
    });
    $1v5pe.useEffect(()=>{
        const options = {
            ...refs.current.persistOptions,
            queryClient: client
        };
        if (!didRestore.current) {
            didRestore.current = true;
            setIsRestoring(true);
            (0, $13qag.persistQueryClientRestore)(options).then(async ()=>{
                try {
                    await (refs.current.onSuccess == null ? void 0 : refs.current.onSuccess());
                } finally{
                    setIsRestoring(false);
                }
            });
        }
        return isRestoring ? undefined : (0, $13qag.persistQueryClientSubscribe)(options);
    }, [
        client,
        isRestoring
    ]);
    return /*#__PURE__*/ $1v5pe.createElement((0, $eAih2.QueryClientProvider), (0, $g2Cfd.extends)({
        client: client
    }, props), /*#__PURE__*/ $1v5pe.createElement((0, $9Zfop.IsRestoringProvider), {
        value: isRestoring
    }, children));
};

});
parcelRegister("g2Cfd", function(module, exports) {
$parcel$export(module.exports, "extends", () => $bada7fc616d94b6c$export$e092ad3ec43b55ee);
function $bada7fc616d94b6c$export$e092ad3ec43b55ee() {
    $bada7fc616d94b6c$export$e092ad3ec43b55ee = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bada7fc616d94b6c$export$e092ad3ec43b55ee.apply(this, arguments);
}

});

parcelRegister("13qag", function(module, exports) {
$parcel$export(module.exports, "persistQueryClientRestore", () => $0c4a5df75c87dec8$export$781eb0ebad7272a1);
$parcel$export(module.exports, "persistQueryClientSubscribe", () => $0c4a5df75c87dec8$export$9fe01d80627be88c);

var $g8bXl = parcelRequire("g8bXl");
/**
 * Checks if emitted event is about cache change and not about observers.
 * Useful for persist, where we only want to trigger save when cache is changed.
 */ const $0c4a5df75c87dec8$var$cacheableEventTypes = [
    'added',
    'removed',
    'updated'
];
function $0c4a5df75c87dec8$var$isCacheableEventType(eventType) {
    return $0c4a5df75c87dec8$var$cacheableEventTypes.includes(eventType);
}
/**
 * Restores persisted data to the QueryCache
 *  - data obtained from persister.restoreClient
 *  - data is hydrated using hydrateOptions
 * If data is expired, busted, empty, or throws, it runs persister.removeClient
 */ async function $0c4a5df75c87dec8$export$781eb0ebad7272a1({ queryClient: queryClient, persister: persister, maxAge: maxAge = 86400000, buster: buster = '', hydrateOptions: hydrateOptions }) {
    try {
        const persistedClient = await persister.restoreClient();
        if (persistedClient) {
            if (persistedClient.timestamp) {
                const expired = Date.now() - persistedClient.timestamp > maxAge;
                const busted = persistedClient.buster !== buster;
                if (expired || busted) persister.removeClient();
                else (0, $g8bXl.hydrate)(queryClient, persistedClient.clientState, hydrateOptions);
            } else persister.removeClient();
        }
    } catch (err) {
        persister.removeClient();
    }
}
/**
 * Persists data from the QueryCache
 *  - data dehydrated using dehydrateOptions
 *  - data is persisted using persister.persistClient
 */ async function $0c4a5df75c87dec8$export$8a3b4786a14f2528({ queryClient: queryClient, persister: persister, buster: buster = '', dehydrateOptions: dehydrateOptions }) {
    const persistClient = {
        buster: buster,
        timestamp: Date.now(),
        clientState: (0, $g8bXl.dehydrate)(queryClient, dehydrateOptions)
    };
    await persister.persistClient(persistClient);
}
/**
 * Subscribe to QueryCache and MutationCache updates (for persisting)
 * @returns an unsubscribe function (to discontinue monitoring)
 */ function $0c4a5df75c87dec8$export$9fe01d80627be88c(props) {
    const unsubscribeQueryCache = props.queryClient.getQueryCache().subscribe((event)=>{
        if ($0c4a5df75c87dec8$var$isCacheableEventType(event.type)) $0c4a5df75c87dec8$export$8a3b4786a14f2528(props);
    });
    const unusbscribeMutationCache = props.queryClient.getMutationCache().subscribe((event)=>{
        if ($0c4a5df75c87dec8$var$isCacheableEventType(event.type)) $0c4a5df75c87dec8$export$8a3b4786a14f2528(props);
    });
    return ()=>{
        unsubscribeQueryCache();
        unusbscribeMutationCache();
    };
}
/**
 * Restores persisted data to QueryCache and persists further changes.
 */ function $0c4a5df75c87dec8$export$217ab42a80f50b3b(props) {
    let hasUnsubscribed = false;
    let persistQueryClientUnsubscribe;
    const unsubscribe = ()=>{
        hasUnsubscribed = true;
        persistQueryClientUnsubscribe == null || persistQueryClientUnsubscribe();
    }; // Attempt restore
    const restorePromise = $0c4a5df75c87dec8$export$781eb0ebad7272a1(props).then(()=>{
        if (!hasUnsubscribed) // Subscribe to changes in the query cache to trigger the save
        persistQueryClientUnsubscribe = $0c4a5df75c87dec8$export$9fe01d80627be88c(props);
    });
    return [
        unsubscribe,
        restorePromise
    ];
}

});
parcelRegister("g8bXl", function(module, exports) {
$parcel$export(module.exports, "dehydrate", () => $bbe6aaf1bf5b2fa1$export$12aee8bb597e7dfe);
$parcel$export(module.exports, "hydrate", () => $bbe6aaf1bf5b2fa1$export$fa8d919ba61d84db);
// TYPES
// FUNCTIONS
function $bbe6aaf1bf5b2fa1$var$dehydrateMutation(mutation) {
    return {
        mutationKey: mutation.options.mutationKey,
        state: mutation.state
    };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.
function $bbe6aaf1bf5b2fa1$var$dehydrateQuery(query) {
    return {
        state: query.state,
        queryKey: query.queryKey,
        queryHash: query.queryHash
    };
}
function $bbe6aaf1bf5b2fa1$export$3aa4c2840e01e53(mutation) {
    return mutation.state.isPaused;
}
function $bbe6aaf1bf5b2fa1$export$e71bc20295698fa1(query) {
    return query.state.status === 'success';
}
function $bbe6aaf1bf5b2fa1$export$12aee8bb597e7dfe(client, options = {}) {
    const mutations = [];
    const queries = [];
    if (options.dehydrateMutations !== false) {
        const shouldDehydrateMutation = options.shouldDehydrateMutation || $bbe6aaf1bf5b2fa1$export$3aa4c2840e01e53;
        client.getMutationCache().getAll().forEach((mutation)=>{
            if (shouldDehydrateMutation(mutation)) mutations.push($bbe6aaf1bf5b2fa1$var$dehydrateMutation(mutation));
        });
    }
    if (options.dehydrateQueries !== false) {
        const shouldDehydrateQuery = options.shouldDehydrateQuery || $bbe6aaf1bf5b2fa1$export$e71bc20295698fa1;
        client.getQueryCache().getAll().forEach((query)=>{
            if (shouldDehydrateQuery(query)) queries.push($bbe6aaf1bf5b2fa1$var$dehydrateQuery(query));
        });
    }
    return {
        mutations: mutations,
        queries: queries
    };
}
function $bbe6aaf1bf5b2fa1$export$fa8d919ba61d84db(client, dehydratedState, options) {
    if (typeof dehydratedState !== 'object' || dehydratedState === null) return;
    const mutationCache = client.getMutationCache();
    const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const queries = dehydratedState.queries || [];
    mutations.forEach((dehydratedMutation)=>{
        var _options$defaultOptio;
        mutationCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations,
            mutationKey: dehydratedMutation.mutationKey
        }, dehydratedMutation.state);
    });
    queries.forEach(({ queryKey: queryKey, state: state, queryHash: queryHash })=>{
        var _options$defaultOptio2;
        const query = queryCache.get(queryHash); // Do not hydrate if an existing query exists with newer data
        if (query) {
            if (query.state.dataUpdatedAt < state.dataUpdatedAt) {
                // omit fetchStatus from dehydrated state
                // so that query stays in its current fetchStatus
                const { fetchStatus: _ignored, ...dehydratedQueryState } = state;
                query.setState(dehydratedQueryState);
            }
            return;
        } // Restore query
        queryCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries,
            queryKey: queryKey,
            queryHash: queryHash
        }, // query being stuck in fetching state upon hydration
        {
            ...state,
            fetchStatus: 'idle'
        });
    });
}

});


parcelRegister("9Zfop", function(module, exports) {
$parcel$export(module.exports, "useIsRestoring", () => $7455c03ec1a3f653$export$4da0178d6b5f553);
$parcel$export(module.exports, "IsRestoringProvider", () => $7455c03ec1a3f653$export$593807d4e94f9621);

var $1v5pe = parcelRequire("1v5pe");
"use client";
var $7455c03ec1a3f653$var$IsRestoringContext = $1v5pe.createContext(false);
var $7455c03ec1a3f653$export$4da0178d6b5f553 = ()=>$1v5pe.useContext($7455c03ec1a3f653$var$IsRestoringContext);
var $7455c03ec1a3f653$export$593807d4e94f9621 = $7455c03ec1a3f653$var$IsRestoringContext.Provider;

});

parcelRegister("eAih2", function(module, exports) {
$parcel$export(module.exports, "useQueryClient", () => $a9e29a46de51d309$export$22e77b9572c4fded);
$parcel$export(module.exports, "QueryClientProvider", () => $a9e29a46de51d309$export$45604f0cc8ae667b);

var $1v5pe = parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
"use client";
var $a9e29a46de51d309$export$da112d31b0149f31 = $1v5pe.createContext(void 0);
var $a9e29a46de51d309$export$22e77b9572c4fded = (queryClient)=>{
    const client = $1v5pe.useContext($a9e29a46de51d309$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $a9e29a46de51d309$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $1v5pe.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $kIqwl.jsx)($a9e29a46de51d309$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};

});


parcelRegister("cc5qg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $5JCtR = parcelRequire("5JCtR");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $5JCtR.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $5JCtR.isFeatureEnabled;
    }
});

});
parcelRegister("5JCtR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $40Sn3 = parcelRequire("40Sn3");
var $dEnZ3 = parcelRequire("dEnZ3");
var $kHb6M = parcelRequire("kHb6M");

var $4qXSO = parcelRequire("4qXSO");

var $1wz5q = parcelRequire("1wz5q");

var $kLfgy = parcelRequire("kLfgy");
const $42cf0131eca6fd98$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $42cf0131eca6fd98$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $42cf0131eca6fd98$var$getBoundaryKey();
    return (0, $4qXSO.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $42cf0131eca6fd98$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $42cf0131eca6fd98$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $1wz5q.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $42cf0131eca6fd98$var$getBoundaryKey();
    const aemResult = (0, $4qXSO.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    // Keep predicate evaluation deferred until AEM or an explicit fallback resolves the feature as enabled.
    const isAllowedForCurrentOffering = ()=>{
        const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
        return predicate ? predicate() : true;
    };
    if (!aemResult) {
        const metadata = (0, $4qXSO.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if ($42cf0131eca6fd98$var$shouldEnableForIcPreRelease(metadata, boundaryKey)) return isAllowedForCurrentOffering();
        if ((0, $kLfgy.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        if (metadata && metadata.auditPhase) return $42cf0131eca6fd98$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    return isAllowedForCurrentOffering();
}
module.exports.isFeatureEnabled = $42cf0131eca6fd98$var$isFeatureEnabled;
/** Enables IC pre-release features only for the pre-release isolation context. */ function $42cf0131eca6fd98$var$shouldEnableForIcPreRelease(metadata, boundaryKey) {
    return boundaryKey === $4qXSO.ISOLATED_CLOUD_COMMERCIAL_KEY && (0, $kHb6M.isolationContextId)() === "ic-dr6" && metadata !== undefined && metadata.preRelease === true;
}
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $42cf0131eca6fd98$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $kLfgy.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $4qXSO.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $kLfgy.isSSR)() && localStorage.getItem(`${$42cf0131eca6fd98$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $42cf0131eca6fd98$var$shouldEnableForAudit;
function $42cf0131eca6fd98$var$getBoundaryKey() {
    if ((0, $40Sn3.isFedrampModerate)()) return $4qXSO.FED_MOD_KEY;
    if ((0, $dEnZ3.isIsolatedCloud)()) return $4qXSO.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $4qXSO.COMMERCIAL_KEY;
}
function $42cf0131eca6fd98$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$42cf0131eca6fd98$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $42cf0131eca6fd98$var$configureAuditState;
function $42cf0131eca6fd98$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$42cf0131eca6fd98$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $42cf0131eca6fd98$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $42cf0131eca6fd98$var$isFeatureEnabled,
    overrideFeature: $1wz5q.overrideFeature,
    clearFeatureOverride: $1wz5q.clearFeatureOverride,
    clearAllOverrides: $1wz5q.clearAllOverrides,
    configureAuditState: $42cf0131eca6fd98$var$configureAuditState,
    clearAuditState: $42cf0131eca6fd98$var$clearAuditState
};

});
parcelRegister("4qXSO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $hcZ24 = parcelRequire("hcZ24");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $hcZ24.isEnvironmentBlockEnabledForBoundary;
    }
});

var $hcZ24 = parcelRequire("hcZ24");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $hcZ24.isFeatureEnabledForBoundary;
    }
});

var $hcZ24 = parcelRequire("hcZ24");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $hcZ24.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $1pIeV = parcelRequire("1pIeV");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $1pIeV.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $1pIeV.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $1pIeV.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $1pIeV.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $1pIeV.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});
parcelRegister("hcZ24", function(module, exports) {
"use strict";
var $c872e66d13fefca4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $c872e66d13fefca4$var$sdk_data_json_1 = $c872e66d13fefca4$var$__importDefault((parcelRequire("5FmmH")));
const $c872e66d13fefca4$var$aemEnvironmentBlockData = $c872e66d13fefca4$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $c872e66d13fefca4$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($c872e66d13fefca4$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $c872e66d13fefca4$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $c872e66d13fefca4$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $c872e66d13fefca4$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $c872e66d13fefca4$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $c872e66d13fefca4$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $c872e66d13fefca4$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($c872e66d13fefca4$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $c872e66d13fefca4$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$c872e66d13fefca4$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $c872e66d13fefca4$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $c872e66d13fefca4$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $c872e66d13fefca4$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$c872e66d13fefca4$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $c872e66d13fefca4$var$getFeatureAvailabilityMetadataForBoundary;
function $c872e66d13fefca4$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $c872e66d13fefca4$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$c872e66d13fefca4$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("5FmmH", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-api-token-and-key-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-atlassian-guard-standard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-portfolio-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-searchbar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager-client-tools-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"assets-data-manager-ui\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-canvas-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-canvas-relay\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-create-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-legacy-collaborative-editor\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-legacy-ssr-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-page-tree\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-remix\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-view-page\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"moved-to-monolith-awaiting-deprecation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"customer-service-management-ai-agent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"dx\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"goals-townsquare-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"guard-premium-atlassian-guard-premium-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"guard-premium-full-site-security-scanning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"home\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"basic-home-experience\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":true}},\"home-cross-app-create\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-dashboard-experience\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"home-ms-teams-and-slack-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-rerouting-services\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"home-where-you-work\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jcma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-ai-planner\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-issue-centric-deployments\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-global-issue-create-smart-fields\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-individual-capacity-planning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-jinx-blue-green-jql-search\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"jira-monolith\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-planned-deprecated-jira-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-project\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-search-investigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-share\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-core-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-case-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-jira-event-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-slack-and-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-account-directory\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-hr-employee-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-lightweight-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-ops-gatekeeper\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-support-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-workforce-management-and-smart-routing\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-automation-actions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-bitbucket-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-internal-ops\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"opsgenie-onboarding\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-postmortem\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-url-shortener\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-web-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"projects-townsquare-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"rovo\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"teams-directory-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"teams-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"unified-profile\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"anti-abuse-classification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-chart-export\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-monolith\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-experience-connector\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-barrel-next-gen\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-barrel\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-network-and-key-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-legacy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-sieve\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-provisioner\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"agentic-runtime-session-execution\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"ai-3p-lifecycle\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-3p-permissions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-safety\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"alta\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"convo-ai-legacy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"convo-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai-tecton\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform-supporting-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-send-message\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"cloud-to-data-center-connection-bridge\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"code-assist\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"userbase-merge\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"orcs\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"org-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"druid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"link-paste-anonymization\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"plato-data-lake-proxy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"plato-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"socrates-demux\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"starrocks\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"customer-facing-observability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"aggregated-support-help\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ecosystem-outbound-auth-flow\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"forge-ac-checker-fedramp\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-ac-checker\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"forge-app-client-events\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-apps-bff\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-developer-console\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-entity-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-object-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-runtime-logs-api\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-sql-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-storage-control-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"export-control-compliance\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"auto-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"bxp-signup\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"cross-flow\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"feedback-collection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"growth-content-generation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"growth-unified-profile\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"authz-consistency-checker\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-cache\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"identity-core-post-m4\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-deprecated-for-gcp-m5\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-gsuite-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-microsoft-azure-ad-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-mobile-integrity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-userbase-merge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"suspicious-login-blocking\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-amkt-fe-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-powered-migration-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"app-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"brie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"continuous-import-export-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"dare-app-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"file-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"lio-synthetic-consumer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"media-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"migration-admin-ui\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"sandbox-promotion\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"monolith-key-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"units-icons\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"post-office-rml-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"gitlab-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"reporting-lines\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-reporting-lines\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"search-identity-dare-isolated\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"search-identity-user-validator\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"user-search-indexing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"xpsearch-forward-store\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-third-party-smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"linking-platform-cdn\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"linking-platform-user-preferences\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"stakeholder-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"usage-based-pricing-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"atlassian-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-secure-sandbox-platform\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-workflow-platform-temporal\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kamino-ingestion\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"kamino-portal\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"browser-remote-update-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"artifact-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"deployment-gating\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"deployments\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kitt-source-control\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"racs-refapp-archetype\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"racs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"secrets\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"change-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"change-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"experimentation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"feature-flag\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"flag-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"cloud-governance-and-inventory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-cell-provisioning\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}}}},\"cloud-telemetry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-posture-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"configuration-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"config-registry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-network\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"fedramp-network\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"core-network-automation-telemetry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cna-theia\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"cna-theid\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}}}},\"cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"cpg-federal\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"data-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"icg-commercial\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"icg-ic\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-center-diagnostics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"data-depot-legacy-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"phoenix-tester\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"queuing-platform\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}},\"streamhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"streaming-processing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"streaming-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"emperor-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"hydra\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"pii-mapper\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"postgres-telemetry-agent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"telemetry-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"region-failover-orchestration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"edge-diagnostics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"edge-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"edge-sliver-refapp-archetype\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"envoy-partitions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor-ref-client\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"cryptor\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kms-proxy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"error-tracking-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"event-demux\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"gasv3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"analytics-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"gasv3-tester\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"rapid-investigation-framework\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlaskube\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"kitt-fleet-scoped\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet-unscoped\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"logging-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"management-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"media-control-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"metrics-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"network-extension-routing\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"observability-visualization-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"opensearch\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"per-tenant-loop\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"performance-testing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"provisioning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"public-backend-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-public-backend-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"heimdall-tester\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"hofund-platform-tester\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"relational-database-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"homa\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"postgresql\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"release-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"release-tracks\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"wiremock\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"security-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-authentication\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"identity-provider\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"key-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"poco\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"rollcall\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"slauth\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"service-mesh\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"sp-ref-kitt-consumer-archetype\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}},\"sp-ref-kitt-provider\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}}}},\"shard-and-cell-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"raptor-archetype\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"shard-lifecycle-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"software-system-of-record-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-directory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"static-app-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cookie-reference-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ssr-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"static-app-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"statsig\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-statsig-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tdp-control-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tdp-object-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-object-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"tcs-ref-client\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"tenant-data-destroyer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"testing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"polliwhirl\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"testing-platform-legacy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tracing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"vector-database\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"violation-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"volt-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"volt-platform-app\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"workplace-infra\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

});


parcelRegister("1pIeV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var $107a714ef3ae0230$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($107a714ef3ae0230$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $107a714ef3ae0230$var$UnderAuditPhase = {}));

});


parcelRegister("1wz5q", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $11c3ff0b47072a2c$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $11c3ff0b47072a2c$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $11c3ff0b47072a2c$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $11c3ff0b47072a2c$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $11c3ff0b47072a2c$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$11c3ff0b47072a2c$var$isBrowserEnvironment()) return null;
    const map = $11c3ff0b47072a2c$var$getOverridesMap();
    const key = $11c3ff0b47072a2c$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $11c3ff0b47072a2c$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $11c3ff0b47072a2c$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$11c3ff0b47072a2c$var$isBrowserEnvironment()) return;
    const map = $11c3ff0b47072a2c$var$getOverridesMap();
    map[$11c3ff0b47072a2c$var$buildKey(environmentBlockName, featureName)] = value;
    $11c3ff0b47072a2c$var$setOverridesMap(map);
}
module.exports.overrideFeature = $11c3ff0b47072a2c$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $11c3ff0b47072a2c$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$11c3ff0b47072a2c$var$isBrowserEnvironment()) return;
    const map = $11c3ff0b47072a2c$var$getOverridesMap();
    delete map[$11c3ff0b47072a2c$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $11c3ff0b47072a2c$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $11c3ff0b47072a2c$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $11c3ff0b47072a2c$var$clearAllOverrides() {
    if (!$11c3ff0b47072a2c$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $11c3ff0b47072a2c$var$clearAllOverrides;

});

parcelRegister("kLfgy", function(module, exports) {

var $k1Wvt = parcelRequire("k1Wvt");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $f1d409ef19b076f1$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $k1Wvt !== "undefined" && $k1Wvt && $k1Wvt.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $f1d409ef19b076f1$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $f1d409ef19b076f1$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.") || host.endsWith(".atlassian-stg-fedm.net") || host.endsWith(".atlassian-stg-fedm.com")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $f1d409ef19b076f1$var$getEnvironmentType;

});



parcelRegister("hAXMW", function(module, exports) {
$parcel$export(module.exports, "useQuery", () => $ccf42d2c16c882c3$export$dd0a697e1782aedd);

var $8JUrJ = parcelRequire("8JUrJ");

var $aSdrA = parcelRequire("aSdrA");
"use client";
function $ccf42d2c16c882c3$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $aSdrA.useBaseQuery)(options, (0, $8JUrJ.QueryObserver), queryClient);
}

});
parcelRegister("8JUrJ", function(module, exports) {
$parcel$export(module.exports, "QueryObserver", () => $65ce4fc2153e40ad$export$a06cf8c0066f0d4c);
// src/queryObserver.ts

var $bxfwH = parcelRequire("bxfwH");

var $7SKaq = parcelRequire("7SKaq");

var $98YQN = parcelRequire("98YQN");

var $g6YUH = parcelRequire("g6YUH");

var $gvNQc = parcelRequire("gvNQc");

var $jWbIA = parcelRequire("jWbIA");
var $65ce4fc2153e40ad$export$a06cf8c0066f0d4c = class extends (0, $g6YUH.Subscribable) {
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.#currentThenable = (0, $gvNQc.pendingThenable)();
        if (!this.options.experimental_prefetchInRender) this.#currentThenable.reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
        this.bindMethods();
        this.setOptions(options);
    }
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #currentThenable;
    #selectError;
    #selectFn;
    #selectResult;
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if ($65ce4fc2153e40ad$var$shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $65ce4fc2153e40ad$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $65ce4fc2153e40ad$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $jWbIA.resolveEnabled)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, $jWbIA.shallowEqualObjects)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $65ce4fc2153e40ad$var$shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $jWbIA.resolveEnabled)(this.options.enabled, this.#currentQuery) !== (0, $jWbIA.resolveEnabled)(prevOptions.enabled, this.#currentQuery) || (0, $jWbIA.resolveStaleTime)(this.options.staleTime, this.#currentQuery) !== (0, $jWbIA.resolveStaleTime)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $jWbIA.resolveEnabled)(this.options.enabled, this.#currentQuery) !== (0, $jWbIA.resolveEnabled)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if ($65ce4fc2153e40ad$var$shouldAssignObserverCurrentProperties(this, result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked?.(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        this.#trackedProps.add(key);
    }
    getCurrentQuery() {
        return this.#currentQuery;
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, $jWbIA.noop));
        return promise;
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, $jWbIA.resolveStaleTime)(this.options.staleTime, this.#currentQuery);
        if ((0, $jWbIA.isServer) || this.#currentResult.isStale || !(0, $jWbIA.isValidTimeout)(staleTime)) return;
        const time = (0, $jWbIA.timeUntilStale)(this.#currentResult.dataUpdatedAt, staleTime);
        const timeout = time + 1;
        this.#staleTimeoutId = setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.#currentQuery) : this.options.refetchInterval) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if ((0, $jWbIA.isServer) || (0, $jWbIA.resolveEnabled)(this.options.enabled, this.#currentQuery) === false || !(0, $jWbIA.isValidTimeout)(this.#currentRefetchInterval) || this.#currentRefetchInterval === 0) return;
        this.#refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $bxfwH.focusManager).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId) {
            clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId) {
            clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.#currentQueryInitialState;
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $65ce4fc2153e40ad$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $65ce4fc2153e40ad$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $98YQN.fetchState)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(newState.data);
                data = (0, $jWbIA.replaceData)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    this.#selectError = null;
                } catch (selectError) {
                    this.#selectError = selectError;
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $jWbIA.replaceData)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $65ce4fc2153e40ad$var$isStale(query, options),
            refetch: this.refetch,
            promise: this.#currentThenable
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = this.#currentThenable = nextResult.promise = (0, $gvNQc.pendingThenable)();
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = this.#currentThenable;
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, $jWbIA.shallowEqualObjects)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.#currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        this.#notify({
            listeners: shouldNotifyListeners()
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
    #notify(notifyOptions) {
        (0, $7SKaq.notifyManager).batch(()=>{
            if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
};
function $65ce4fc2153e40ad$var$shouldLoadOnMount(query, options) {
    return (0, $jWbIA.resolveEnabled)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $65ce4fc2153e40ad$var$shouldFetchOnMount(query, options) {
    return $65ce4fc2153e40ad$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $65ce4fc2153e40ad$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $65ce4fc2153e40ad$var$shouldFetchOn(query, options, field) {
    if ((0, $jWbIA.resolveEnabled)(options.enabled, query) !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $65ce4fc2153e40ad$var$isStale(query, options);
    }
    return false;
}
function $65ce4fc2153e40ad$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $jWbIA.resolveEnabled)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $65ce4fc2153e40ad$var$isStale(query, options);
}
function $65ce4fc2153e40ad$var$isStale(query, options) {
    return (0, $jWbIA.resolveEnabled)(options.enabled, query) !== false && query.isStaleByTime((0, $jWbIA.resolveStaleTime)(options.staleTime, query));
}
function $65ce4fc2153e40ad$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $jWbIA.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}

});
parcelRegister("bxfwH", function(module, exports) {
$parcel$export(module.exports, "focusManager", () => $865ed205b3e3bd58$export$6bf54661be5b02cf);
// src/focusManager.ts

var $g6YUH = parcelRequire("g6YUH");

var $jWbIA = parcelRequire("jWbIA");
var $865ed205b3e3bd58$export$86f1af424b2ca4de = class extends (0, $g6YUH.Subscribable) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (!(0, $jWbIA.isServer) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $865ed205b3e3bd58$export$6bf54661be5b02cf = new $865ed205b3e3bd58$export$86f1af424b2ca4de();

});
parcelRegister("g6YUH", function(module, exports) {
$parcel$export(module.exports, "Subscribable", () => $bbac75089fd751a3$export$d26086b469ecdbcc);
// src/subscribable.ts
var $bbac75089fd751a3$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};

});

parcelRegister("jWbIA", function(module, exports) {
$parcel$export(module.exports, "isServer", () => $e83c861719bed486$export$6acf61af03e62db);
$parcel$export(module.exports, "noop", () => $e83c861719bed486$export$8793edee2d425525);
$parcel$export(module.exports, "functionalUpdate", () => $e83c861719bed486$export$7f095f455ad5af3f);
$parcel$export(module.exports, "isValidTimeout", () => $e83c861719bed486$export$e539f754e934e270);
$parcel$export(module.exports, "timeUntilStale", () => $e83c861719bed486$export$811b83d62bcf47f0);
$parcel$export(module.exports, "resolveStaleTime", () => $e83c861719bed486$export$cb3145f011bda3ac);
$parcel$export(module.exports, "resolveEnabled", () => $e83c861719bed486$export$8c88ee6f2357230d);
$parcel$export(module.exports, "matchQuery", () => $e83c861719bed486$export$c5d1efe363797780);
$parcel$export(module.exports, "hashQueryKeyByOptions", () => $e83c861719bed486$export$cc90ca97bc0d73fd);
$parcel$export(module.exports, "partialMatchKey", () => $e83c861719bed486$export$2f07189bb9fa26a7);
$parcel$export(module.exports, "matchMutation", () => $e83c861719bed486$export$a1ea5fb559f63ae3);
$parcel$export(module.exports, "hashKey", () => $e83c861719bed486$export$1e87d19d4aab5805);
$parcel$export(module.exports, "replaceEqualDeep", () => $e83c861719bed486$export$77a71fc411098696);
$parcel$export(module.exports, "shallowEqualObjects", () => $e83c861719bed486$export$3e67810a3f0e9f1c);
$parcel$export(module.exports, "sleep", () => $e83c861719bed486$export$e772c8ff12451969);
$parcel$export(module.exports, "replaceData", () => $e83c861719bed486$export$17619bac5b909b23);
$parcel$export(module.exports, "addToEnd", () => $e83c861719bed486$export$ccce65a22a26f2bc);
$parcel$export(module.exports, "addToStart", () => $e83c861719bed486$export$8c6246b73dd61f4a);
$parcel$export(module.exports, "skipToken", () => $e83c861719bed486$export$1aa5a89531b7670d);
$parcel$export(module.exports, "ensureQueryFn", () => $e83c861719bed486$export$c71c44209368a3bc);
// src/utils.ts
var $e83c861719bed486$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $e83c861719bed486$export$8793edee2d425525() {}
function $e83c861719bed486$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $e83c861719bed486$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $e83c861719bed486$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $e83c861719bed486$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $e83c861719bed486$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $e83c861719bed486$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $e83c861719bed486$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$e83c861719bed486$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $e83c861719bed486$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($e83c861719bed486$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $e83c861719bed486$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$e83c861719bed486$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $e83c861719bed486$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $e83c861719bed486$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $e83c861719bed486$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$e83c861719bed486$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $e83c861719bed486$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$e83c861719bed486$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $e83c861719bed486$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $e83c861719bed486$export$7a8558113332b71e(a) && $e83c861719bed486$export$7a8558113332b71e(b);
    if (array || $e83c861719bed486$export$53b83ca8eaab0383(a) && $e83c861719bed486$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $e83c861719bed486$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $e83c861719bed486$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $e83c861719bed486$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $e83c861719bed486$export$53b83ca8eaab0383(o) {
    if (!$e83c861719bed486$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$e83c861719bed486$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $e83c861719bed486$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $e83c861719bed486$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $e83c861719bed486$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $e83c861719bed486$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $e83c861719bed486$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $e83c861719bed486$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $e83c861719bed486$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $e83c861719bed486$export$1aa5a89531b7670d = Symbol();
function $e83c861719bed486$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $e83c861719bed486$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}

});


parcelRegister("7SKaq", function(module, exports) {
$parcel$export(module.exports, "notifyManager", () => $5bd16367d6208496$export$520687f44db6e1ab);
// src/notifyManager.ts
var $5bd16367d6208496$export$7c76da44185e6090 = (cb)=>setTimeout(cb, 0);
function $5bd16367d6208496$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $5bd16367d6208496$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $5bd16367d6208496$export$520687f44db6e1ab = $5bd16367d6208496$export$316a8efd03cd1458();

});

parcelRegister("98YQN", function(module, exports) {
$parcel$export(module.exports, "Query", () => $6a84100aa0e01427$export$62297b13309008b2);
$parcel$export(module.exports, "fetchState", () => $6a84100aa0e01427$export$f3df9013f2b58bce);
// src/query.ts

var $jWbIA = parcelRequire("jWbIA");

var $7SKaq = parcelRequire("7SKaq");

var $6G84Q = parcelRequire("6G84Q");

var $a9qWf = parcelRequire("a9qWf");
var $6a84100aa0e01427$export$62297b13309008b2 = class extends (0, $a9qWf.Removable) {
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $6a84100aa0e01427$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $jWbIA.replaceData)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.#dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $jWbIA.noop)).catch((0, $jWbIA.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.#initialState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $jWbIA.resolveEnabled)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $jWbIA.skipToken) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $jWbIA.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $jWbIA.ensureQueryFn)(this.options, fetchOptions);
            const queryFnContext = {
                client: this.#client,
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            client: this.#client,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        this.options.behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        const onError = (error)=>{
            if (!((0, $6G84Q.isCancelledError)(error) && error.silent)) this.#dispatch({
                type: "error",
                error: error
            });
            if (!(0, $6G84Q.isCancelledError)(error)) {
                this.#cache.config.onError?.(error, this);
                this.#cache.config.onSettled?.(this.state.data, error, this);
            }
            this.scheduleGc();
        };
        this.#retryer = (0, $6G84Q.createRetryer)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                this.#cache.config.onSuccess?.(data, this);
                this.#cache.config.onSettled?.(data, this.state.error, this);
                this.scheduleGc();
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        return this.#retryer.start();
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$6a84100aa0e01427$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $6G84Q.isCancelledError)(error) && error.revert && this.#revertState) return {
                        ...this.#revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7SKaq.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $6a84100aa0e01427$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $6G84Q.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $6a84100aa0e01427$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

});
parcelRegister("6G84Q", function(module, exports) {
$parcel$export(module.exports, "canFetch", () => $4dccee4365fa0ad2$export$61b92f63f30245cf);
$parcel$export(module.exports, "isCancelledError", () => $4dccee4365fa0ad2$export$986cc6445c1d323);
$parcel$export(module.exports, "createRetryer", () => $4dccee4365fa0ad2$export$2cbd00fe8a2c8d85);
// src/retryer.ts

var $bxfwH = parcelRequire("bxfwH");

var $7LwdT = parcelRequire("7LwdT");

var $gvNQc = parcelRequire("gvNQc");

var $jWbIA = parcelRequire("jWbIA");
function $4dccee4365fa0ad2$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $4dccee4365fa0ad2$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $7LwdT.onlineManager).isOnline() : true;
}
var $4dccee4365fa0ad2$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $4dccee4365fa0ad2$export$986cc6445c1d323(value) {
    return value instanceof $4dccee4365fa0ad2$export$a8430ed4188f35a9;
}
function $4dccee4365fa0ad2$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    const thenable = (0, $gvNQc.pendingThenable)();
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $4dccee4365fa0ad2$export$a8430ed4188f35a9(cancelOptions));
            config.abort?.();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $bxfwH.focusManager).isFocused() && (config.networkMode === "always" || (0, $7LwdT.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>$4dccee4365fa0ad2$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess?.(value);
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError?.(value);
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved) return;
            const retry = config.retry ?? ((0, $jWbIA.isServer) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $4dccee4365fa0ad2$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $jWbIA.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}

});
parcelRegister("7LwdT", function(module, exports) {
$parcel$export(module.exports, "onlineManager", () => $5a75eb05bb8a2af5$export$b113e788b2dd3fdc);
// src/onlineManager.ts

var $g6YUH = parcelRequire("g6YUH");

var $jWbIA = parcelRequire("jWbIA");
var $5a75eb05bb8a2af5$export$58774fb55d5ff7fc = class extends (0, $g6YUH.Subscribable) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (!(0, $jWbIA.isServer) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $5a75eb05bb8a2af5$export$b113e788b2dd3fdc = new $5a75eb05bb8a2af5$export$58774fb55d5ff7fc();

});

parcelRegister("gvNQc", function(module, exports) {
$parcel$export(module.exports, "pendingThenable", () => $c05633fa6b569b72$export$d54630db02a12b72);
// src/thenable.ts
function $c05633fa6b569b72$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}

});


parcelRegister("a9qWf", function(module, exports) {
$parcel$export(module.exports, "Removable", () => $763fa41011bf6634$export$e09608847fcc8c59);
// src/removable.ts

var $jWbIA = parcelRequire("jWbIA");
var $763fa41011bf6634$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $jWbIA.isValidTimeout)(this.gcTime)) this.#gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $jWbIA.isServer) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout) {
            clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};

});



parcelRegister("aSdrA", function(module, exports) {
$parcel$export(module.exports, "useBaseQuery", () => $020afd6c27a7be5a$export$fff0865807e996c5);

var $1v5pe = parcelRequire("1v5pe");

var $jWbIA = parcelRequire("jWbIA");
var $7SKaq = parcelRequire("7SKaq");

var $eAih2 = parcelRequire("eAih2");

var $17k5Z = parcelRequire("17k5Z");

var $hTEKq = parcelRequire("hTEKq");

var $9Zfop = parcelRequire("9Zfop");

var $aw3OK = parcelRequire("aw3OK");

var $6hs8J = parcelRequire("6hs8J");
"use client";
function $020afd6c27a7be5a$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $eAih2.useQueryClient)(queryClient);
    const isRestoring = (0, $9Zfop.useIsRestoring)();
    const errorResetBoundary = (0, $17k5Z.useQueryErrorResetBoundary)();
    const defaultedOptions = client.defaultQueryOptions(options);
    client.getDefaultOptions().queries?._experimental_beforeQuery?.(defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $aw3OK.ensureSuspenseTimers)(defaultedOptions);
    (0, $hTEKq.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $hTEKq.useClearResetErrorBoundary)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $1v5pe.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $1v5pe.useSyncExternalStore($1v5pe.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $7SKaq.notifyManager).batchCalls(onStoreChange)) : (0, $6hs8J.noop);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $1v5pe.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $aw3OK.shouldSuspend)(defaultedOptions, result)) throw (0, $aw3OK.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $hTEKq.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    client.getDefaultOptions().queries?._experimental_afterQuery?.(defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $jWbIA.isServer) && (0, $aw3OK.willFetch)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $aw3OK.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        client.getQueryCache().get(defaultedOptions.queryHash)?.promise;
        promise?.catch((0, $6hs8J.noop)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("17k5Z", function(module, exports) {
$parcel$export(module.exports, "useQueryErrorResetBoundary", () => $0d06087c25524407$export$50dfac555130cafd);

var $1v5pe = parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
"use client";
function $0d06087c25524407$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $0d06087c25524407$var$QueryErrorResetBoundaryContext = $1v5pe.createContext($0d06087c25524407$var$createValue());
var $0d06087c25524407$export$50dfac555130cafd = ()=>$1v5pe.useContext($0d06087c25524407$var$QueryErrorResetBoundaryContext);
var $0d06087c25524407$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $1v5pe.useState(()=>$0d06087c25524407$var$createValue());
    return /* @__PURE__ */ (0, $kIqwl.jsx)($0d06087c25524407$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};

});

parcelRegister("hTEKq", function(module, exports) {
$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", () => $d0772e5c74204360$export$ae8adb3de3d77633);
$parcel$export(module.exports, "useClearResetErrorBoundary", () => $d0772e5c74204360$export$b2b17ca3a1fb0229);
$parcel$export(module.exports, "getHasError", () => $d0772e5c74204360$export$1fbcf724762d607);

var $1v5pe = parcelRequire("1v5pe");

var $6hs8J = parcelRequire("6hs8J");
"use client";
var $d0772e5c74204360$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $d0772e5c74204360$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $1v5pe.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $d0772e5c74204360$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $6hs8J.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]));
};

});
parcelRegister("6hs8J", function(module, exports) {
$parcel$export(module.exports, "shouldThrowError", () => $492a2895229638be$export$2072f68e6c3507cf);
$parcel$export(module.exports, "noop", () => $492a2895229638be$export$8793edee2d425525);
// src/utils.ts
function $492a2895229638be$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $492a2895229638be$export$8793edee2d425525() {}

});


parcelRegister("aw3OK", function(module, exports) {
$parcel$export(module.exports, "defaultThrowOnError", () => $7a7fdaa4deaea417$export$8bed2f8d02206063);
$parcel$export(module.exports, "ensureSuspenseTimers", () => $7a7fdaa4deaea417$export$274d2a1db5a20c09);
$parcel$export(module.exports, "willFetch", () => $7a7fdaa4deaea417$export$e0a3f29513afe430);
$parcel$export(module.exports, "shouldSuspend", () => $7a7fdaa4deaea417$export$88d3586dfed64df9);
$parcel$export(module.exports, "fetchOptimistic", () => $7a7fdaa4deaea417$export$defdc11a9c9acfcf);
// src/suspense.ts
var $7a7fdaa4deaea417$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $7a7fdaa4deaea417$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    const originalStaleTime = defaultedOptions.staleTime;
    if (defaultedOptions.suspense) {
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>Math.max(originalStaleTime(...args), 1e3) : Math.max(originalStaleTime ?? 1e3, 1e3);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $7a7fdaa4deaea417$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $7a7fdaa4deaea417$export$88d3586dfed64df9 = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
var $7a7fdaa4deaea417$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

});



parcelRegister("iWPIE", function(module, exports) {
$parcel$export(module.exports, "Main", () => $dcb5c31cd4d7c146$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $2aEiL = parcelRequire("2aEiL");

var $9TUqr = parcelRequire("9TUqr");


var $jJU6i = parcelRequire("jJU6i");

var $8cQFk = parcelRequire("8cQFk");
var $dcb5c31cd4d7c146$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8"
};
function $dcb5c31cd4d7c146$export$861edd1ccea2f746(_ref) {
    var children = _ref.children, isFixedProp = _ref.isFixed, xcss = _ref.xcss, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? 'Main Content' : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id;
    var id = (0, $jJU6i.useLayoutId)({
        providedId: providedId
    });
    var isFixed = (0, $2aEiL.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    (0, $9TUqr.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ $1v5pe.createElement((0, $1v5pe.Fragment), null, /*#__PURE__*/ $1v5pe.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $hMvDh.default)([
            $dcb5c31cd4d7c146$var$mainElementStyles.root,
            isFixed && $dcb5c31cd4d7c146$var$mainElementStyles.fixedContentArea,
            xcss
        ]),
        role: "main",
        "data-testid": testId
    }, /*#__PURE__*/ $1v5pe.createElement((0, $8cQFk.MainStickyContext).Provider, {
        value: Boolean(isFixed)
    }, children)));
}

});
parcelRegister("9TUqr", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $7355050cf81fbe49$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $7355050cf81fbe49$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $7355050cf81fbe49$export$89d9323301efc7d6);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
var $7355050cf81fbe49$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $1v5pe.createContext)({
    registerSkipLink: (0, $aD9yk.default),
    unregisterSkipLink: (0, $aD9yk.default)
});
var $7355050cf81fbe49$var$useSkipLinks = function useSkipLinks() {
    return (0, $1v5pe.useContext)($7355050cf81fbe49$export$4c5cc3b14c7678a);
};
var $7355050cf81fbe49$export$707b94c26b8b75aa = function useSkipLinkInternal(_ref) {
    var id = _ref.id, label = _ref.label, listIndex = _ref.listIndex, onBeforeNavigate = _ref.onBeforeNavigate, isHidden = _ref.isHidden;
    var _useSkipLinks = $7355050cf81fbe49$var$useSkipLinks(), registerSkipLink = _useSkipLinks.registerSkipLink, unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
    (0, $1v5pe.useEffect)(function() {
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
var $7355050cf81fbe49$export$89d9323301efc7d6 = function useSkipLink(id, label, listIndex) {
    $7355050cf81fbe49$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("jJU6i", function(module, exports) {
$parcel$export(module.exports, "useLayoutId", () => $e5edbcadf8b53856$export$110c3550c7c1c9aa);

var $lHxwq = parcelRequire("lHxwq");
function $e5edbcadf8b53856$export$fa3cfac0c8e29c5c() {
    var uniqueId = (0, $lHxwq.useId)();
    return uniqueId;
}
function $e5edbcadf8b53856$export$110c3550c7c1c9aa() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, providedId = _ref.providedId;
    var uniqueId = $e5edbcadf8b53856$export$fa3cfac0c8e29c5c();
    var id = providedId ? providedId : uniqueId;
    return id;
}

});

parcelRegister("8cQFk", function(module, exports) {
$parcel$export(module.exports, "MainStickyContext", () => $5f984bfeab071abd$export$3b369e2c6c1ec840);

var $1v5pe = parcelRequire("1v5pe");
var $5f984bfeab071abd$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});


parcelRegister("7kOlB", function(module, exports) {
$parcel$export(module.exports, "gridRootId", () => $5571749fbfcbfd4f$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $5571749fbfcbfd4f$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $1Q8aC = parcelRequire("1Q8aC");

var $fKxsu = parcelRequire("fKxsu");

var $hCuHy = parcelRequire("hCuHy");

var $fUzPo = parcelRequire("fUzPo");

var $lSd5u = parcelRequire("lSd5u");

var $9Gee5 = parcelRequire("9Gee5");

var $9yxUV = parcelRequire("9yxUV");

var $9YTHd = parcelRequire("9YTHd");
var $5571749fbfcbfd4f$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
var $5571749fbfcbfd4f$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $5571749fbfcbfd4f$export$be92b6f5f03c0fe9(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$UNSAFE_dangerous = _ref.UNSAFE_dangerouslyHoistSlotSizes, UNSAFE_dangerouslyHoistSlotSizes = _ref$UNSAFE_dangerous === void 0 ? false : _ref$UNSAFE_dangerous, _ref$skipLinksLabel = _ref.skipLinksLabel, skipLinksLabel = _ref$skipLinksLabel === void 0 ? 'Skip to:' : _ref$skipLinksLabel, testId = _ref.testId;
    var ref = (0, $1v5pe.useRef)(null);
    (0, $1v5pe.useEffect)(function() {
        var IGNORED_ELEMENTS;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $9YTHd.SideNavVisibilityProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $9yxUV.SideNavToggleButtonProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $9Gee5.SideNavElementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fUzPo.TopNavStartProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1Q8aC.OpenLayerObserver), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $lSd5u.DangerouslyHoistSlotSizes).Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hCuHy.SkipLinksProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fKxsu.SkipLinksContainer), {
        label: skipLinksLabel,
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        ref: ref,
        className: (0, $hMvDh.default)([
            $5571749fbfcbfd4f$var$styles.root,
            xcss
        ]),
        id: $5571749fbfcbfd4f$export$a6d827031bcb31d1,
        "data-testid": testId
    }, children))))))));
}

});
parcelRegister("fKxsu", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContainer", () => $b7751b0cc3ace9b7$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $fRfXo = parcelRequire("fRfXo");

var $2euwY = parcelRequire("2euwY");

var $DEbbW = parcelRequire("DEbbW");
var $b7751b0cc3ace9b7$var$styles = {
    root: "_zulp1b66 _2rkoglpi _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ var $b7751b0cc3ace9b7$var$closeOnEscape = function closeOnEscape(event) {
    if (event.key !== 'Escape') return;
    var activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
var $b7751b0cc3ace9b7$var$isOnlyWhitespaceRegex = /^\s*$/;
var $b7751b0cc3ace9b7$export$fce25a0c32fbc1e1 = function SkipLinksContainer(_ref) {
    var label = _ref.label, testId = _ref.testId;
    var sortedSkipLinks = (0, $2euwY.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    var isEmptyLabel = $b7751b0cc3ace9b7$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        onKeyDown: $b7751b0cc3ace9b7$var$closeOnEscape,
        "data-testid": testId ? "".concat(testId, "--skip-links-container") : undefined,
        className: (0, $hMvDh.default)([
            $b7751b0cc3ace9b7$var$styles.root
        ])
    }, !isEmptyLabel && /*#__PURE__*/ $1v5pe.createElement((0, $fRfXo.Text), {
        weight: "bold",
        testId: testId ? "".concat(testId, "--skip-links-container--label") : undefined
    }, label), /*#__PURE__*/ $1v5pe.createElement("ol", {
        className: (0, $hMvDh.default)([
            $b7751b0cc3ace9b7$var$styles.skipLinkList
        ])
    }, sortedSkipLinks.map(function(_ref2) {
        var id = _ref2.id, label = _ref2.label, onBeforeNavigate = _ref2.onBeforeNavigate;
        return /*#__PURE__*/ $1v5pe.createElement((0, $DEbbW.SkipLink), {
            key: id,
            id: id,
            onBeforeNavigate: onBeforeNavigate
        }, label);
    })));
};

});
parcelRegister("2euwY", function(module, exports) {
$parcel$export(module.exports, "SkipLinksDataContext", () => $1a04925e6fc12ab1$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $1a04925e6fc12ab1$export$b0b0d4fc1b356759);

var $8DJJm = parcelRequire("8DJJm");

var $7sAh5 = parcelRequire("7sAh5");

var $1v5pe = parcelRequire("1v5pe");
function $1a04925e6fc12ab1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a04925e6fc12ab1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a04925e6fc12ab1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7sAh5.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a04925e6fc12ab1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1a04925e6fc12ab1$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $1v5pe.createContext)([]);
var $1a04925e6fc12ab1$var$_assignIndex = function assignIndex(num, arr) {
    if (!arr.includes(num)) return num;
    return $1a04925e6fc12ab1$var$_assignIndex(num + 1, arr);
};
var $1a04925e6fc12ab1$var$sortSkipLinks = function sortSkipLinks(arr) {
    var customLinks = arr.filter(function(link) {
        return Number.isInteger(link.listIndex);
    });
    if (customLinks.length === 0) return arr;
    var usedIndexes = customLinks.map(function(a) {
        return a.listIndex;
    });
    var regularLinksWithIdx = arr.filter(function(link) {
        return link.listIndex === undefined;
    }).map(function(link, idx) {
        var listIndex = $1a04925e6fc12ab1$var$_assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return $1a04925e6fc12ab1$var$_objectSpread($1a04925e6fc12ab1$var$_objectSpread({}, link), {}, {
            listIndex: listIndex
        });
    });
    return [].concat((0, $8DJJm.default)(customLinks), (0, $8DJJm.default)(regularLinksWithIdx)).sort(function(a, b) {
        return a.listIndex - b.listIndex;
    });
};
var $1a04925e6fc12ab1$export$b0b0d4fc1b356759 = function useSortedSkipLinks() {
    var skipLinksData = (0, $1v5pe.useContext)($1a04925e6fc12ab1$export$e9ab38ce6147d3d2);
    return (0, $1v5pe.useMemo)(function() {
        return $1a04925e6fc12ab1$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("DEbbW", function(module, exports) {
$parcel$export(module.exports, "SkipLink", () => $0772cf7249b0a8b6$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $hpF1c = parcelRequire("hpF1c");
var $0772cf7249b0a8b6$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $0772cf7249b0a8b6$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $dmmsG.bind)(element, {
        type: 'blur',
        listener: function listener() {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
var $0772cf7249b0a8b6$export$ef95c37428582a65 = function SkipLink(_ref) {
    var id = _ref.id, children = _ref.children, onBeforeNavigate = _ref.onBeforeNavigate;
    var href = "#".concat(id);
    var onClick = (0, $1v5pe.useCallback)(function(event) {
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        var target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate === null || onBeforeNavigate === void 0 || onBeforeNavigate();
        $0772cf7249b0a8b6$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("li", {
        className: (0, $hMvDh.default)([
            $0772cf7249b0a8b6$var$styles.skipLinkListItem
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hpF1c.Anchor), {
        tabIndex: 0,
        href: href,
        onClick: onClick
    }, children));
};

});


parcelRegister("hCuHy", function(module, exports) {
$parcel$export(module.exports, "SkipLinksProvider", () => $cd3dccf1ab9c5d27$export$fe514f9f7b03d46f);

var $8DJJm = parcelRequire("8DJJm");

var $aHHxB = parcelRequire("aHHxB");

var $1v5pe = parcelRequire("1v5pe");

var $9TUqr = parcelRequire("9TUqr");

var $2euwY = parcelRequire("2euwY");
var $cd3dccf1ab9c5d27$var$getByDomOrderSortFunction = function getByDomOrderSortFunction() {
    var layoutSlots = Array.from(document.querySelectorAll("[data-layout-slot]"));
    return function(a, b) {
        var _a$listIndex, _b$listIndex;
        var indexA = (_a$listIndex = a.listIndex) !== null && _a$listIndex !== void 0 ? _a$listIndex : layoutSlots.indexOf(document.getElementById(a.id));
        var indexB = (_b$listIndex = b.listIndex) !== null && _b$listIndex !== void 0 ? _b$listIndex : layoutSlots.indexOf(document.getElementById(b.id));
        /**
     * If they are tied it is because one (or both) is
     * a custom skiplink with a set index.
     *
     * Give the custom skiplink priority.
     */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
var $cd3dccf1ab9c5d27$export$fe514f9f7b03d46f = function SkipLinksProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $1v5pe.useState)([]), _useState2 = (0, $aHHxB.default)(_useState, 2), links = _useState2[0], setLinks = _useState2[1];
    var registerSkipLink = (0, $1v5pe.useCallback)(function(skipLinkData) {
        // Don't add duplicate skip links
        setLinks(function(oldLinks) {
            if (oldLinks.some(function(_ref2) {
                var id = _ref2.id;
                return id === skipLinkData.id;
            })) return oldLinks;
            return [].concat((0, $8DJJm.default)(oldLinks), [
                skipLinkData
            ]).sort($cd3dccf1ab9c5d27$var$getByDomOrderSortFunction());
        });
    }, []);
    var unregisterSkipLink = (0, $1v5pe.useCallback)(function(id) {
        setLinks(function(links) {
            return links.filter(function(link) {
                return link.id !== id;
            });
        });
    }, []);
    var contextValue = (0, $1v5pe.useMemo)(function() {
        var data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $9TUqr.SkipLinksContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $2euwY.SkipLinksDataContext).Provider, {
        value: links
    }, children));
};

});

parcelRegister("fUzPo", function(module, exports) {
$parcel$export(module.exports, "TopNavStartProvider", () => $b957e0a70ec5e2e1$export$bc9d0ad0bce43e75);

var $aHHxB = parcelRequire("aHHxB");

var $1v5pe = parcelRequire("1v5pe");

var $d2bdS = parcelRequire("d2bdS");
var $b957e0a70ec5e2e1$export$bc9d0ad0bce43e75 = function TopNavStartProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $1v5pe.useState)(null), _useState2 = (0, $aHHxB.default)(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $d2bdS.TopNavStartElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $d2bdS.TopNavStartAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("d2bdS", function(module, exports) {
$parcel$export(module.exports, "TopNavStartElement", () => $97d42ae159d02e6e$export$e9e5087bd319cc8c);
$parcel$export(module.exports, "TopNavStartAttachRef", () => $97d42ae159d02e6e$export$55f0a642b785fb1f);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
var $97d42ae159d02e6e$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $1v5pe.createContext)(null);
var $97d42ae159d02e6e$export$55f0a642b785fb1f = /*#__PURE__*/ (0, $1v5pe.createContext)((0, $aD9yk.default));

});


parcelRegister("lSd5u", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $fec8cb059fe0b988$export$66e2c1a0115af861);

var $1v5pe = parcelRequire("1v5pe");
var $fec8cb059fe0b988$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});

parcelRegister("9Gee5", function(module, exports) {
$parcel$export(module.exports, "SideNavElementProvider", () => $70c312596a2f52f7$export$85c1ff84bbf6e6dc);

var $1v5pe = parcelRequire("1v5pe");
var $70c312596a2f52f7$var$SideNavRefContext = /*#__PURE__*/ (0, $1v5pe.createContext)({
    current: null
});
function $70c312596a2f52f7$export$85c1ff84bbf6e6dc(_ref) {
    var children = _ref.children;
    var sideNavRef = (0, $1v5pe.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($70c312596a2f52f7$var$SideNavRefContext.Provider, {
        value: sideNavRef
    }, children);
}
function $70c312596a2f52f7$export$fa4d0cff03b1ea4f() {
    return (0, $1v5pe.useContext)($70c312596a2f52f7$var$SideNavRefContext);
}

});

parcelRegister("9yxUV", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $6f519941d6d021b0$export$ceb8e60e9790fc0f);

var $aHHxB = parcelRequire("aHHxB");

var $1v5pe = parcelRequire("1v5pe");

var $89C0b = parcelRequire("89C0b");
var $6f519941d6d021b0$export$ceb8e60e9790fc0f = function SideNavToggleButtonProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $1v5pe.useState)(null), _useState2 = (0, $aHHxB.default)(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $89C0b.SideNavToggleButtonElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $89C0b.SideNavToggleButtonAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("89C0b", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonElement", () => $5efca466cee1236e$export$9c1768094bef896);
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $5efca466cee1236e$export$fb8fa9a80240785e);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
var $5efca466cee1236e$export$9c1768094bef896 = /*#__PURE__*/ (0, $1v5pe.createContext)(null);
var $5efca466cee1236e$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $1v5pe.createContext)((0, $aD9yk.default));

});


parcelRegister("9YTHd", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityProvider", () => $7444ebbad4155e6d$export$aac8e996360f6ad9);

var $aHHxB = parcelRequire("aHHxB");

var $1v5pe = parcelRequire("1v5pe");

var $6mwPJ = parcelRequire("6mwPJ");
var $7444ebbad4155e6d$export$aac8e996360f6ad9 = function SideNavVisibilityProvider(_ref) {
    var children = _ref.children;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    var _useState = (0, $1v5pe.useState)(null), _useState2 = (0, $aHHxB.default)(_useState, 2), sideNavState = _useState2[0], setSideNavState = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6mwPJ.SideNavVisibilityState).Provider, {
        value: sideNavState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6mwPJ.SetSideNavVisibilityState).Provider, {
        value: setSideNavState
    }, children));
};

});
parcelRegister("6mwPJ", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityState", () => $4a1e4427f586f121$export$eb04201bb6dd1e4e);
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $4a1e4427f586f121$export$f6b496b07d1ea493);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
var $4a1e4427f586f121$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $1v5pe.createContext)(null);
var $4a1e4427f586f121$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $1v5pe.createContext)((0, $aD9yk.default));

});



parcelRegister("fsTfg", function(module, exports) {
$parcel$export(module.exports, "TopNav", () => $b4245315bbc85f25$export$41d0d88a6b0e456f);
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $2aEiL = parcelRequire("2aEiL");

var $9TUqr = parcelRequire("9TUqr");

var $a23jK = parcelRequire("a23jK");

var $e1PhK = parcelRequire("e1PhK");

var $f2EFs = parcelRequire("f2EFs");

var $lSd5u = parcelRequire("lSd5u");

var $8NMhF = parcelRequire("8NMhF");

var $jJU6i = parcelRequire("jJU6i");
var $b4245315bbc85f25$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i1dgc _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
};
function $b4245315bbc85f25$export$41d0d88a6b0e456f(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$height = _ref.height, height = _ref$height === void 0 ? 48 : _ref$height, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? 'Top Bar' : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id, UNSAFE_theme = _ref.UNSAFE_theme;
    var dangerouslyHoistSlotSizes = (0, $1v5pe.useContext)((0, $lSd5u.DangerouslyHoistSlotSizes));
    var id = (0, $jJU6i.useLayoutId)({
        providedId: providedId
    });
    (0, $9TUqr.useSkipLink)(id, skipLinkLabel);
    var customTheme = (0, $e1PhK.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ $1v5pe.createElement((0, $a23jK.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled
    }, /*#__PURE__*/ $1v5pe.createElement("header", {
        id: id,
        "data-layout-slot": true,
        className: (0, $hMvDh.default)([
            $b4245315bbc85f25$var$styles.root,
            (0, $2aEiL.fg)('platform_design_system_nav4_top_nav_columns') ? $b4245315bbc85f25$var$styles.newLayoutStyles : $b4245315bbc85f25$var$styles.oldLayoutStyles,
            xcss
        ]),
        "data-testid": testId,
        style: customTheme.isEnabled ? customTheme.style : undefined
    }, /*#__PURE__*/ $1v5pe.createElement((0, $8NMhF.HoistCssVarToLocalGrid), {
        variableName: (0, $f2EFs.topNavMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $1v5pe.createElement((0, $8NMhF.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $f2EFs.UNSAFE_topNavVar),
        value: height
    }), children));
}

});
parcelRegister("a23jK", function(module, exports) {
$parcel$export(module.exports, "HasCustomThemeContext", () => $74dcaa19178c3db5$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $74dcaa19178c3db5$export$abfcaeeca4ae7a55);

var $1v5pe = parcelRequire("1v5pe");
var $74dcaa19178c3db5$export$d158fa15757a1890 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);
function $74dcaa19178c3db5$export$abfcaeeca4ae7a55() {
    return (0, $1v5pe.useContext)($74dcaa19178c3db5$export$d158fa15757a1890);
}

});

parcelRegister("e1PhK", function(module, exports) {
$parcel$export(module.exports, "useCustomTheme", () => $a368f0dcbe6a55ce$export$c0c5f5b297b77726);

var $1v5pe = parcelRequire("1v5pe");

var $fOLtO = parcelRequire("fOLtO");
function $a368f0dcbe6a55ce$export$c0c5f5b297b77726(theme) {
    var value = (0, $1v5pe.useMemo)(function() {
        if (!(theme !== null && theme !== void 0 && theme.backgroundColor) || !(theme !== null && theme !== void 0 && theme.highlightColor)) return {
            isEnabled: false
        };
        /**
     * Re-creating the `theme` object from it's pieces.
     *
     * _Technically_ we could just use `theme`, but that would involve an eslint opt out
     * as we would be leveraging a value (`theme`) not in the dependency array.
     *
     * The current approach is the most correct™️ and avoids foot guns.
     * We are only using values in the effect that are defined in the dependency array 🙌
     */ var value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        var style = (0, $fOLtO.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme === null || theme === void 0 ? void 0 : theme.backgroundColor,
        theme === null || theme === void 0 ? void 0 : theme.highlightColor
    ]);
    return value;
}

});
parcelRegister("fOLtO", function(module, exports) {
$parcel$export(module.exports, "getCustomThemeStyles", () => $b8405b0983e11ec2$export$3986d75fe2da3239);

var $7sAh5 = parcelRequire("7sAh5");

var $8G6Yr = parcelRequire("8G6Yr");

var $77p4S = parcelRequire("77p4S");

var $7LYdf = parcelRequire("7LYdf");

var $7vvVA = parcelRequire("7vvVA");

var $eq9XK = parcelRequire("eq9XK");

var $7UDGe = parcelRequire("7UDGe");
function $b8405b0983e11ec2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b8405b0983e11ec2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b8405b0983e11ec2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7sAh5.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b8405b0983e11ec2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Expects colors to be passed as `RGB` objects.
 *
 * Allows `string` for hex strings only, for backwards compatibility.
 * This will likely be removed in the future.
 *
 * Allows `null` for ergonomic reasons, because our color parsing utilities can return
 * `null` if they cannot parse a color string.
 */ function $b8405b0983e11ec2$var$toRGBString(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}
function $b8405b0983e11ec2$var$toRGBAString(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b, a = _ref2.a;
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
var $b8405b0983e11ec2$var$buttonStyles = {
    light: (0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)({}, (0, $77p4S.themedButtonBackground), 'transparent'), (0, $77p4S.themedButtonBackgroundHovered), (0, $eq9XK.palette).Neutral200A), (0, $77p4S.themedButtonBackgroundPressed), (0, $eq9XK.palette).Neutral300A), (0, $77p4S.themedButtonBorder), (0, $eq9XK.palette).Neutral300A), (0, $77p4S.themedButtonSelectedBackground), (0, $eq9XK.palette).Neutral300A), (0, $77p4S.themedButtonSelectedBackgroundHovered), (0, $eq9XK.palette).Neutral400A), (0, $77p4S.themedButtonSelectedBackgroundPressed), (0, $eq9XK.palette).Neutral500A), (0, $77p4S.themedButtonDisabledText), (0, $eq9XK.palette).Neutral400A), (0, $77p4S.themedButtonDisabledBackground), (0, $eq9XK.palette).Neutral100A),
    dark: (0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)({}, (0, $77p4S.themedButtonBackground), 'transparent'), (0, $77p4S.themedButtonBackgroundHovered), (0, $eq9XK.palette).DarkNeutral200A), (0, $77p4S.themedButtonBackgroundPressed), (0, $eq9XK.palette).DarkNeutral300A), (0, $77p4S.themedButtonBorder), (0, $eq9XK.palette).DarkNeutral300A), (0, $77p4S.themedButtonSelectedBackground), (0, $eq9XK.palette).DarkNeutral300A), (0, $77p4S.themedButtonSelectedBackgroundHovered), (0, $eq9XK.palette).DarkNeutral400A), (0, $77p4S.themedButtonSelectedBackgroundPressed), (0, $eq9XK.palette).DarkNeutral500A), (0, $77p4S.themedButtonDisabledText), (0, $eq9XK.palette).DarkNeutral400A), (0, $77p4S.themedButtonDisabledBackground), (0, $eq9XK.palette).DarkNeutral100A)
};
var $b8405b0983e11ec2$var$logoStyles = {
    light: (0, $7sAh5.default)((0, $7sAh5.default)({}, (0, $8G6Yr.themedLogoIcon), (0, $eq9XK.palette).DarkNeutral0), (0, $8G6Yr.themedLogoText), (0, $eq9XK.palette).DarkNeutral0),
    dark: (0, $7sAh5.default)((0, $7sAh5.default)({}, (0, $8G6Yr.themedLogoIcon), (0, $eq9XK.palette).Neutral0), (0, $8G6Yr.themedLogoText), (0, $eq9XK.palette).Neutral0)
};
function $b8405b0983e11ec2$export$3986d75fe2da3239(_ref3) {
    var backgroundColor = _ref3.backgroundColor, highlightColor = _ref3.highlightColor;
    var backgroundRgb = typeof backgroundColor === 'string' ? (0, $7vvVA.parseHex)(backgroundColor) : backgroundColor;
    var highlightRgb = typeof highlightColor === 'string' ? (0, $7vvVA.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    var textColor = (0, $7LYdf.getTextColor)(backgroundRgb);
    var colorMode = (0, $7LYdf.getColorMode)(backgroundRgb);
    var highlightTextColor = (0, $7LYdf.getTextColor)(highlightRgb);
    return $b8405b0983e11ec2$var$_objectSpread($b8405b0983e11ec2$var$_objectSpread($b8405b0983e11ec2$var$_objectSpread($b8405b0983e11ec2$var$_objectSpread({
        backgroundColor: $b8405b0983e11ec2$var$toRGBString(backgroundRgb),
        color: textColor.hex
    }, $b8405b0983e11ec2$var$buttonStyles[colorMode]), $b8405b0983e11ec2$var$logoStyles[colorMode]), $b8405b0983e11ec2$var$getSelectedStyles({
        backgroundColor: backgroundRgb,
        colorMode: colorMode
    })), {}, (0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)((0, $7sAh5.default)({}, (0, $7UDGe.themedSearchBorder), $b8405b0983e11ec2$var$toRGBAString($b8405b0983e11ec2$var$_objectSpread($b8405b0983e11ec2$var$_objectSpread({}, textColor.rgb), {}, {
        a: 0.5
    }))), (0, $7UDGe.themedSearchBorderFocused), $b8405b0983e11ec2$var$toRGBAString($b8405b0983e11ec2$var$_objectSpread($b8405b0983e11ec2$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $77p4S.themedButtonPrimaryBackground), $b8405b0983e11ec2$var$toRGBString(highlightRgb)), (0, $77p4S.themedButtonPrimaryBackgroundHovered), $b8405b0983e11ec2$var$toRGBAString($b8405b0983e11ec2$var$_objectSpread($b8405b0983e11ec2$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $77p4S.themedButtonPrimaryBackgroundPressed), $b8405b0983e11ec2$var$toRGBAString($b8405b0983e11ec2$var$_objectSpread($b8405b0983e11ec2$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.65
    }))), (0, $77p4S.themedButtonPrimaryText), highlightTextColor.hex));
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ var $b8405b0983e11ec2$var$selectedBackgroundRGBA = {
    light: (0, $eq9XK.paletteRgba).Neutral300A,
    dark: (0, $eq9XK.paletteRgba).DarkNeutral300A
};
function $b8405b0983e11ec2$var$getSelectedStyles(_ref4) {
    var backgroundColor = _ref4.backgroundColor, colorMode = _ref4.colorMode;
    /**
   * The background color of the selected button in its default state.
   *
   * We are referring to this as a foreground color because it is semi-transparent,
   * so is not the actual color displayed when the button is on top of a background color.
   */ var foregroundColor = $b8405b0983e11ec2$var$selectedBackgroundRGBA[colorMode];
    /**
   * The blended color seen when the selected background is over the top bar.
   */ var blendedBackground = (0, $7LYdf.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return (0, $7sAh5.default)((0, $7sAh5.default)({}, (0, $77p4S.themedButtonSelectedText), (0, $7LYdf.getTextColor)(blendedBackground).hex), (0, $77p4S.themedButtonSelectedBorder), (0, $7LYdf.isLight)(blendedBackground) ? (0, $eq9XK.palette).Neutral1100 : (0, $eq9XK.palette).DarkNeutral1100);
}

});
parcelRegister("8G6Yr", function(module, exports) {
$parcel$export(module.exports, "themedLogoIcon", () => $6517a7d8687b2827$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $6517a7d8687b2827$export$91b0830f8f4ab279);
$parcel$export(module.exports, "NavLogo", () => $6517a7d8687b2827$export$b6394419753329e);
/* nav-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $2aEiL = parcelRequire("2aEiL");

var $hpF1c = parcelRequire("hpF1c");

var $a23jK = parcelRequire("a23jK");
var $6517a7d8687b2827$export$24328117f1132113 = '--ds-top-bar-logo-icon';
var $6517a7d8687b2827$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
var $6517a7d8687b2827$var$anchorStyles = {
    root: "_2rkoiti9 _1e0c1txw _4cvr1h6o _4t3izwfg",
    newBorderRadius: "_2rkoftgi",
    newMargin: "_ahbq1b66",
    newInteractionStates: "_irr3166n _1di61wwy",
    newInteractionStatesCustomTheming: "_irr31rps _1di6yhlj"
};
var $6517a7d8687b2827$var$sharedIconOrLogoContainerStyles = {
    root: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51",
    appIconTilePaddingFlagged: "_18zr1b66"
};
var $6517a7d8687b2827$var$iconContainerStyles = {
    root: "_18zr1b66 _1e0c1txw _p12f1tcg _vchh1ntv _10y4glyw"
};
var $6517a7d8687b2827$var$logoContainerStyles = {
    root: "_18zru2gc _1e0cglyw _p12fnklw _vchh1ntv _10y41txw"
};
var $6517a7d8687b2827$export$b6394419753329e = function NavLogo(_ref) {
    var href = _ref.href, logo = _ref.logo, icon = _ref.icon, onClick = _ref.onClick, label = _ref.label;
    var ref = (0, $1v5pe.useRef)(null);
    (0, $1v5pe.useEffect)(function() {
        var _img$parentElement, _img$parentElement2;
        var img, hasExpectedStructure, isOnlyChild;
        return;
    }, []);
    var hasCustomTheme = (0, $a23jK.useHasCustomTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hpF1c.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        xcss: (0, $hGIzV.cx)($6517a7d8687b2827$var$anchorStyles.root, (0, $2aEiL.fg)('platform_design_system_nav_logo_interaction_states') && $6517a7d8687b2827$var$anchorStyles.newMargin, (0, $2aEiL.fg)('platform_design_system_nav_logo_interaction_states') && $6517a7d8687b2827$var$anchorStyles.newBorderRadius, (0, $2aEiL.fg)('platform_design_system_nav_logo_interaction_states') && (hasCustomTheme ? $6517a7d8687b2827$var$anchorStyles.newInteractionStatesCustomTheming : $6517a7d8687b2827$var$anchorStyles.newInteractionStates)),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        className: (0, $hMvDh.default)([
            $6517a7d8687b2827$var$sharedIconOrLogoContainerStyles.root,
            $6517a7d8687b2827$var$iconContainerStyles.root,
            (0, $2aEiL.fg)('platform-team25-app-icon-tiles') && $6517a7d8687b2827$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($6517a7d8687b2827$var$NavLogoRenderer, {
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        className: (0, $hMvDh.default)([
            $6517a7d8687b2827$var$sharedIconOrLogoContainerStyles.root,
            $6517a7d8687b2827$var$logoContainerStyles.root,
            (0, $2aEiL.fg)('platform-team25-app-icon-tiles') && $6517a7d8687b2827$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($6517a7d8687b2827$var$NavLogoRenderer, {
        logoOrIcon: logo
    })));
};
function $6517a7d8687b2827$var$NavLogoRenderer(_ref2) {
    var logoOrIcon = _ref2.logoOrIcon;
    return (0, $2aEiL.fg)('jiv-20710-fix-nav-rerender') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($6517a7d8687b2827$var$NavLogoRendererMemo, {
        logoOrIcon: logoOrIcon
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($6517a7d8687b2827$var$NavLogoRendererNoMemo, {
        logoOrIcon: logoOrIcon
    });
}
var $6517a7d8687b2827$var$NavLogoRendererMemo = /*#__PURE__*/ (0, $1v5pe.memo)($6517a7d8687b2827$var$NavLogoRendererNoMemo);
function $6517a7d8687b2827$var$NavLogoRendererNoMemo(_ref3) {
    var LogoOrIcon = _ref3.logoOrIcon;
    var hasCustomTheme = (0, $a23jK.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(LogoOrIcon, {
        size: "small",
        label: "",
        iconColor: "var(".concat($6517a7d8687b2827$export$24328117f1132113, ")"),
        textColor: "var(".concat($6517a7d8687b2827$export$91b0830f8f4ab279, ")")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("77p4S", function(module, exports) {
$parcel$export(module.exports, "themedButtonBackground", () => $52eca3c5f78daf73$export$b93b81aa41a8061a);
$parcel$export(module.exports, "themedButtonBackgroundHovered", () => $52eca3c5f78daf73$export$96a2312c81489aa1);
$parcel$export(module.exports, "themedButtonBackgroundPressed", () => $52eca3c5f78daf73$export$9db7a918ddfed23e);
$parcel$export(module.exports, "themedButtonBorder", () => $52eca3c5f78daf73$export$2b00bded80635cbb);
$parcel$export(module.exports, "themedButtonPrimaryText", () => $52eca3c5f78daf73$export$eca746d7c1a9cd6e);
$parcel$export(module.exports, "themedButtonPrimaryBackground", () => $52eca3c5f78daf73$export$2c2bc298cddb8aca);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", () => $52eca3c5f78daf73$export$6b28e650669cd3c7);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", () => $52eca3c5f78daf73$export$1656be06aad539b9);
$parcel$export(module.exports, "themedButtonSelectedText", () => $52eca3c5f78daf73$export$c26a897d419ef487);
$parcel$export(module.exports, "themedButtonSelectedBackground", () => $52eca3c5f78daf73$export$4e50e625ccffdb13);
$parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", () => $52eca3c5f78daf73$export$55c84c90f36bda4d);
$parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", () => $52eca3c5f78daf73$export$c5c0213472126c08);
$parcel$export(module.exports, "themedButtonSelectedBorder", () => $52eca3c5f78daf73$export$22928007ff541429);
$parcel$export(module.exports, "themedButtonDisabledText", () => $52eca3c5f78daf73$export$787ad93d0f2276af);
$parcel$export(module.exports, "themedButtonDisabledBackground", () => $52eca3c5f78daf73$export$5e774f44b77335d6);
$parcel$export(module.exports, "ThemedButton", () => $52eca3c5f78daf73$export$f67fb575035cc7d0);
$parcel$export(module.exports, "ThemedLinkButton", () => $52eca3c5f78daf73$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedIconButton", () => $52eca3c5f78daf73$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $52eca3c5f78daf73$export$a1ab08e79d264ec8);
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $87uOn = parcelRequire("87uOn");

var $68sLR = parcelRequire("68sLR");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $fl4ll = parcelRequire("fl4ll");

var $hK1py = parcelRequire("hK1py");
var $g4uNb = parcelRequire("g4uNb");

var $1Tz0w = parcelRequire("1Tz0w");

var $kFr83 = parcelRequire("kFr83");

var $27HHu = parcelRequire("27HHu");
var $52eca3c5f78daf73$var$_excluded = [
    "style",
    "xcss",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd"
], $52eca3c5f78daf73$var$_excluded2 = [
    "appearance",
    "shape",
    "isSelected",
    "isDisabled"
], $52eca3c5f78daf73$var$_excluded3 = [
    "appearance",
    "shape",
    "isSelected",
    "isDisabled"
], $52eca3c5f78daf73$var$_excluded4 = [
    "iconBefore",
    "children"
], $52eca3c5f78daf73$var$_excluded5 = [
    "iconBefore",
    "children"
], $52eca3c5f78daf73$var$_excluded6 = [
    "icon",
    "label",
    "tooltip"
], $52eca3c5f78daf73$var$_excluded7 = [
    "icon",
    "label",
    "tooltip"
];
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ /**
 * Returns the spread props to pass through to underlying primitive components.
 *
 * It removes the props which apply styles.
 */ function $52eca3c5f78daf73$var$getPrimitiveSpreadProps(_ref) {
    var style = _ref.style, xcss = _ref.xcss, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, props = (0, $68sLR.default)(_ref, $52eca3c5f78daf73$var$_excluded);
    return props;
}
var $52eca3c5f78daf73$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
var $52eca3c5f78daf73$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
var $52eca3c5f78daf73$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
var $52eca3c5f78daf73$export$2b00bded80635cbb = '--ds-top-bar-button-border';
var $52eca3c5f78daf73$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
var $52eca3c5f78daf73$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
var $52eca3c5f78daf73$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
var $52eca3c5f78daf73$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
var $52eca3c5f78daf73$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
var $52eca3c5f78daf73$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
var $52eca3c5f78daf73$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
var $52eca3c5f78daf73$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
var $52eca3c5f78daf73$export$22928007ff541429 = '--ds-top-bar-button-selected-border';
var $52eca3c5f78daf73$export$787ad93d0f2276af = '--ds-top-bar-button-disabled-text';
var $52eca3c5f78daf73$export$5e774f44b77335d6 = '--ds-top-bar-button-disabled-background';
var $52eca3c5f78daf73$var$styles = {
    root: "_zulp12x7 _11c82smr _2rkosqtm _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
var $52eca3c5f78daf73$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
var $52eca3c5f78daf73$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
/**
 * Props shared by `ThemedPressable` and `ThemedAnchor`
 */ /**
 * Intentionally an almost-duplicate of `ThemedAnchor` - make sure to update both.
 *
 * See `ThemedAnchor` for more context.
 */ var $52eca3c5f78daf73$var$ThemedPressable = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function ThemedPressable(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? 'default' : _ref2$shape, isSelected = _ref2.isSelected, isDisabled = _ref2.isDisabled, props = (0, $68sLR.default)(_ref2, $52eca3c5f78daf73$var$_excluded2);
    var hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $g4uNb.Pressable), (0, $87uOn.default)({}, $52eca3c5f78daf73$var$getPrimitiveSpreadProps(props), {
        ref: ref,
        type: "button",
        xcss: (0, $hGIzV.cx)($52eca3c5f78daf73$var$styles.root, $52eca3c5f78daf73$var$shapeStyles[shape], hasBorder && $52eca3c5f78daf73$var$styles.border, $52eca3c5f78daf73$var$appearanceStyles[appearance], isSelected && $52eca3c5f78daf73$var$styles.selected, isDisabled && $52eca3c5f78daf73$var$styles.disabled),
        isDisabled: isDisabled
    }));
});
/**
 * Intentionally an almost-duplicate of `ThemedPressable` - make sure to update both.
 *
 * More 'clever' solutions were tried but I couldn't get them working in an acceptable state.
 *
 * Polymorphism had many typing issues and required sacrificing type safety.
 *
 * Render props had problems passing down styles through `xcss` to the `children` function.
 */ var $52eca3c5f78daf73$var$ThemedAnchor = (0, $27HHu.forwardRefWithGeneric)(function ThemedAnchor(_ref3, ref) {
    var _ref3$appearance = _ref3.appearance, appearance = _ref3$appearance === void 0 ? 'default' : _ref3$appearance, _ref3$shape = _ref3.shape, shape = _ref3$shape === void 0 ? 'default' : _ref3$shape, isSelected = _ref3.isSelected, isDisabled = _ref3.isDisabled, props = (0, $68sLR.default)(_ref3, $52eca3c5f78daf73$var$_excluded3);
    var hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hK1py.Anchor), (0, $87uOn.default)({}, $52eca3c5f78daf73$var$getPrimitiveSpreadProps(props), {
        ref: ref,
        xcss: (0, $hGIzV.cx)($52eca3c5f78daf73$var$styles.root, $52eca3c5f78daf73$var$shapeStyles[shape], hasBorder && $52eca3c5f78daf73$var$styles.border, $52eca3c5f78daf73$var$appearanceStyles[appearance], isSelected && $52eca3c5f78daf73$var$styles.selected, isDisabled && $52eca3c5f78daf73$var$styles.disabled)
    }));
});
var $52eca3c5f78daf73$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
var $52eca3c5f78daf73$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function ThemedButton(_ref4, ref) {
    var IconBefore = _ref4.iconBefore, children = _ref4.children, props = (0, $68sLR.default)(_ref4, $52eca3c5f78daf73$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($52eca3c5f78daf73$var$ThemedPressable, (0, $87uOn.default)({}, props, {
        ref: ref
    }), IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("span", {
        className: (0, $hMvDh.default)([
            $52eca3c5f78daf73$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(IconBefore, {
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("span", {
        className: (0, $hMvDh.default)([
            $52eca3c5f78daf73$var$textButtonStyles.text
        ])
    }, children));
});
var $52eca3c5f78daf73$export$b0b5aeed52623827 = (0, $27HHu.forwardRefWithGeneric)(function ThemedLinkButton(_ref5, ref) {
    var IconBefore = _ref5.iconBefore, children = _ref5.children, props = (0, $68sLR.default)(_ref5, $52eca3c5f78daf73$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($52eca3c5f78daf73$var$ThemedAnchor, (0, $87uOn.default)({}, props, {
        ref: ref
    }), IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("span", {
        className: (0, $hMvDh.default)([
            $52eca3c5f78daf73$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(IconBefore, {
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("span", {
        className: (0, $hMvDh.default)([
            $52eca3c5f78daf73$var$textButtonStyles.text
        ])
    }, children));
});
var $52eca3c5f78daf73$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function ThemedIconButton(_ref6, ref) {
    var _tooltip$content;
    var Icon = _ref6.icon, label = _ref6.label, tooltip = _ref6.tooltip, props = (0, $68sLR.default)(_ref6, $52eca3c5f78daf73$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1Tz0w.default), (0, $87uOn.default)({}, tooltip, {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label
    }), function(triggerProps) {
        return(/*#__PURE__*/ /**
       * The `aria-describedby` from `triggerProps` is intentionally not passed down,
       * because it would cause double announcements with the `VisuallyHidden` label.
       *
       * The `@atlaskit/button` IconButton uses the same approach.
       */ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($52eca3c5f78daf73$var$ThemedPressable, (0, $87uOn.default)({}, props, {
            shape: "square",
            ref: (0, $fl4ll.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: function onClick(event, analyticsEvent) {
                var _props$onClick, _triggerProps$onClick;
                (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _props$onMouseOver;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_props$onMouseOver = props.onMouseOver) === null || _props$onMouseOver === void 0 || _props$onMouseOver.call(props, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _props$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_props$onMouseOut = props.onMouseOut) === null || _props$onMouseOut === void 0 || _props$onMouseOut.call(props, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _props$onMouseMove;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_props$onMouseMove = props.onMouseMove) === null || _props$onMouseMove === void 0 || _props$onMouseMove.call(props, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _props$onMouseDown;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_props$onMouseDown = props.onMouseDown) === null || _props$onMouseDown === void 0 || _props$onMouseDown.call(props, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _props$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _props$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, e);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kFr83.default), null, label)));
    });
});
var $52eca3c5f78daf73$export$a1ab08e79d264ec8 = (0, $27HHu.forwardRefWithGeneric)(function ThemedLinkIconButton(_ref7, ref) {
    var _tooltip$content2;
    var Icon = _ref7.icon, label = _ref7.label, tooltip = _ref7.tooltip, props = (0, $68sLR.default)(_ref7, $52eca3c5f78daf73$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1Tz0w.default), (0, $87uOn.default)({}, tooltip, {
        content: (_tooltip$content2 = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content2 !== void 0 ? _tooltip$content2 : label
    }), function(triggerProps) {
        return(/*#__PURE__*/ /**
       * The `aria-describedby` from `triggerProps` is intentionally not passed down,
       * because it would cause double announcements with the `VisuallyHidden` label.
       *
       * The `@atlaskit/button` IconButton uses the same approach.
       */ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($52eca3c5f78daf73$var$ThemedAnchor, (0, $87uOn.default)({}, props, {
            shape: "square",
            ref: (0, $fl4ll.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: function onClick(event, analyticsEvent) {
                var _props$onClick2, _triggerProps$onClick2;
                (_props$onClick2 = props.onClick) === null || _props$onClick2 === void 0 || _props$onClick2.call(props, event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick2 = triggerProps.onClick) === null || _triggerProps$onClick2 === void 0 || _triggerProps$onClick2.call(triggerProps, event);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse5, _props$onMouseOver2;
                (_triggerProps$onMouse5 = triggerProps.onMouseOver) === null || _triggerProps$onMouse5 === void 0 || _triggerProps$onMouse5.call(triggerProps, e);
                (_props$onMouseOver2 = props.onMouseOver) === null || _props$onMouseOver2 === void 0 || _props$onMouseOver2.call(props, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse6, _props$onMouseOut2;
                (_triggerProps$onMouse6 = triggerProps.onMouseOut) === null || _triggerProps$onMouse6 === void 0 || _triggerProps$onMouse6.call(triggerProps, e);
                (_props$onMouseOut2 = props.onMouseOut) === null || _props$onMouseOut2 === void 0 || _props$onMouseOut2.call(props, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse7, _props$onMouseMove2;
                (_triggerProps$onMouse7 = triggerProps.onMouseMove) === null || _triggerProps$onMouse7 === void 0 || _triggerProps$onMouse7.call(triggerProps, e);
                (_props$onMouseMove2 = props.onMouseMove) === null || _props$onMouseMove2 === void 0 || _props$onMouseMove2.call(props, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse8, _props$onMouseDown2;
                (_triggerProps$onMouse8 = triggerProps.onMouseDown) === null || _triggerProps$onMouse8 === void 0 || _triggerProps$onMouse8.call(triggerProps, e);
                (_props$onMouseDown2 = props.onMouseDown) === null || _props$onMouseDown2 === void 0 || _props$onMouseDown2.call(props, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus2, _props$onFocus2;
                (_triggerProps$onFocus2 = triggerProps.onFocus) === null || _triggerProps$onFocus2 === void 0 || _triggerProps$onFocus2.call(triggerProps, e);
                (_props$onFocus2 = props.onFocus) === null || _props$onFocus2 === void 0 || _props$onFocus2.call(props, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur2, _props$onBlur2;
                (_triggerProps$onBlur2 = triggerProps.onBlur) === null || _triggerProps$onBlur2 === void 0 || _triggerProps$onBlur2.call(triggerProps, e);
                (_props$onBlur2 = props.onBlur) === null || _props$onBlur2 === void 0 || _props$onBlur2.call(props, e);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kFr83.default), null, label)));
    });
});

});
parcelRegister("27HHu", function(module, exports) {
$parcel$export(module.exports, "forwardRefWithGeneric", () => $18be2239201f3d60$export$8ab756e06c5d9001);

var $1v5pe = parcelRequire("1v5pe");
var $18be2239201f3d60$export$8ab756e06c5d9001 = (0, $1v5pe.forwardRef);

});


parcelRegister("7LYdf", function(module, exports) {
$parcel$export(module.exports, "isLight", () => $5a8ba12994353bb8$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $5a8ba12994353bb8$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $5a8ba12994353bb8$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $5a8ba12994353bb8$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $5a8ba12994353bb8$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $5a8ba12994353bb8$var$relativeLuminanceW3C(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    /**
   * Normalized sRGB - each channel is between 0 and 1
   */ var normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
   * linear RGB - the gamma correction of sRGB is removed and
   * the channels correspond directly to subpixel intensity
   */ var linear = {
        r: $5a8ba12994353bb8$var$linearizeRGBChannel(normal.r),
        g: $5a8ba12994353bb8$var$linearizeRGBChannel(normal.g),
        b: $5a8ba12994353bb8$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    var L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ var $5a8ba12994353bb8$var$flipLuminance = 0.179129;
function $5a8ba12994353bb8$export$44af652f4cca9039(color) {
    return $5a8ba12994353bb8$var$relativeLuminanceW3C(color) >= $5a8ba12994353bb8$var$flipLuminance;
}
function $5a8ba12994353bb8$export$5573a5bab3e074b5(backgroundColor) {
    if ($5a8ba12994353bb8$var$relativeLuminanceW3C(backgroundColor) >= $5a8ba12994353bb8$var$flipLuminance) return 'light';
    return 'dark';
}
var $5a8ba12994353bb8$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $5a8ba12994353bb8$export$5357fe757c335c0d(backgroundColor) {
    var colorMode = $5a8ba12994353bb8$export$5573a5bab3e074b5(backgroundColor);
    return $5a8ba12994353bb8$var$textColor[colorMode];
}
function $5a8ba12994353bb8$export$e5e64c30bee1469b(_ref2) {
    var background = _ref2.background, foreground = _ref2.foreground;
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("7vvVA", function(module, exports) {
$parcel$export(module.exports, "parseHex", () => $577431dda9284701$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
var $577431dda9284701$var$isValidHex = function isValidHex(hex) {
    return(// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex));
};
function $577431dda9284701$export$103711ef09c6edec(color) {
    if (!$577431dda9284701$var$isValidHex(color)) return null;
    var channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("eq9XK", function(module, exports) {
$parcel$export(module.exports, "palette", () => $a7fb38cc4e7db30e$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $a7fb38cc4e7db30e$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ var $a7fb38cc4e7db30e$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
var $a7fb38cc4e7db30e$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("7UDGe", function(module, exports) {
$parcel$export(module.exports, "themedSearchBorder", () => $5c2c8b06e8713a0b$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $5c2c8b06e8713a0b$export$ee42b8430f4c19bd);

var $77p4S = parcelRequire("77p4S");

var $a23jK = parcelRequire("a23jK");
var $5c2c8b06e8713a0b$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
var $5c2c8b06e8713a0b$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ var $5c2c8b06e8713a0b$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: "var(".concat($5c2c8b06e8713a0b$export$ae6fbf5ba3a7a784, ")")
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: "var(".concat($5c2c8b06e8713a0b$export$ee42b8430f4c19bd, ")"),
        boxShadow: "inset 0px 0px 0px 1px var(".concat($5c2c8b06e8713a0b$export$ee42b8430f4c19bd, ")")
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: "var(".concat((0, $77p4S.themedButtonBackgroundHovered), ")")
    }
};
function $5c2c8b06e8713a0b$export$18a29b1ed2212823() {
    var hasCustomTheme = (0, $a23jK.useHasCustomTheme)();
    if (hasCustomTheme) return $5c2c8b06e8713a0b$var$legacySearchTheme;
    return undefined;
}

});



parcelRegister("f2EFs", function(module, exports) {
$parcel$export(module.exports, "bannerMountedVar", () => $af3696ac1a2c6b98$export$515a0b1baafe906c);
$parcel$export(module.exports, "topNavMountedVar", () => $af3696ac1a2c6b98$export$60ef3a7b1ed42328);
$parcel$export(module.exports, "UNSAFE_topNavVar", () => $af3696ac1a2c6b98$export$855f5a09f5c99ac);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $af3696ac1a2c6b98$export$26354f9814213292);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
var $af3696ac1a2c6b98$export$951bf5156e86d974 = '--n_sNvw';
var $af3696ac1a2c6b98$export$594e6a30db7c057e = '--n_asDw';
var $af3696ac1a2c6b98$export$db0c2e1d744fb281 = '--n_pnlW';
var $af3696ac1a2c6b98$export$515a0b1baafe906c = '--n_bnrM';
var $af3696ac1a2c6b98$export$60ef3a7b1ed42328 = '--n_tNvM';
var $af3696ac1a2c6b98$export$1216dacffd1e9e65 = '--n_sNvlw';
var $af3696ac1a2c6b98$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
var $af3696ac1a2c6b98$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
var $af3696ac1a2c6b98$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
var $af3696ac1a2c6b98$export$2874e68531ce3163 = "calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))";
var $af3696ac1a2c6b98$export$bfabd8c2c572ad29 = "calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))";
var $af3696ac1a2c6b98$export$855f5a09f5c99ac = '--topNavigationHeight';
var $af3696ac1a2c6b98$export$26354f9814213292 = '--bannerHeight';
var $af3696ac1a2c6b98$export$6bfc931a04ec5741 = '--leftSidebarWidth';
var $af3696ac1a2c6b98$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
var $af3696ac1a2c6b98$export$753bf7651b25db91 = '--rightPanelWidth';
var $af3696ac1a2c6b98$export$6460bd6a2446260 = "calc(var(".concat($af3696ac1a2c6b98$export$26354f9814213292, ", 0px) + var(").concat($af3696ac1a2c6b98$export$855f5a09f5c99ac, ", 0px))");
var $af3696ac1a2c6b98$export$3055529fab2b4edf = "var(".concat($af3696ac1a2c6b98$export$6bfc931a04ec5741, ", 0px)");
var $af3696ac1a2c6b98$export$166d8fd766c3eb92 = "calc(var(".concat($af3696ac1a2c6b98$export$bbbace2ff0c7ae1b, ", 0px) + var(").concat($af3696ac1a2c6b98$export$753bf7651b25db91, ", 0px))");
var $af3696ac1a2c6b98$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};

});

parcelRegister("8NMhF", function(module, exports) {
$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $66885a81829919ec$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $66885a81829919ec$export$9f45a1325e3cdfb8);

var $1v5pe = parcelRequire("1v5pe");

var $7kOlB = parcelRequire("7kOlB");
var $66885a81829919ec$export$cfa3cd08d675e56e = function HoistCssVarToLocalGrid(_ref) {
    var variableName = _ref.variableName, value = _ref.value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("style", null, "#".concat((0, $7kOlB.gridRootId), " { ").concat(variableName, ": ").concat(value, "px }"));
};
var $66885a81829919ec$var$getCssStringValue = function getCssStringValue(value) {
    return typeof value === 'number' ? "".concat(value, "px") : value;
};
var $66885a81829919ec$export$9f45a1325e3cdfb8 = function DangerouslyHoistCssVarToDocumentRoot(_ref2) {
    var variableName = _ref2.variableName, value = _ref2.value, mediaQuery = _ref2.mediaQuery, responsiveValue = _ref2.responsiveValue;
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ var style = ":root { ".concat(variableName, ": ").concat($66885a81829919ec$var$getCssStringValue(value), " }");
    if (mediaQuery && responsiveValue) style += " ".concat(mediaQuery, " { :root { ").concat(variableName, ": ").concat($66885a81829919ec$var$getCssStringValue(responsiveValue), " } }");
    return(/*#__PURE__*/ // Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("style", null, style));
};

});


parcelRegister("9eJtQ", function(module, exports) {
$parcel$export(module.exports, "TopNavEnd", () => $6b98b3523ae3ccac$export$8b7a38b70a3c9839);
/* top-nav-end.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $87uOn = parcelRequire("87uOn");

var $aHHxB = parcelRequire("aHHxB");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $3q5kf = parcelRequire("3q5kf");

var $dEGdm = parcelRequire("dEGdm");

var $2aEiL = parcelRequire("2aEiL");

var $c633V = parcelRequire("c633V");

var $bMABl = parcelRequire("bMABl");

var $5bU3A = parcelRequire("5bU3A");

var $a23jK = parcelRequire("a23jK");

var $eO1xw = parcelRequire("eO1xw");
var $6b98b3523ae3ccac$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg",
    newLayoutStyles: "_1d2y1ris",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi _ndwch9n0"
};
var $6b98b3523ae3ccac$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
};
function $6b98b3523ae3ccac$export$8b7a38b70a3c9839(_ref) {
    var children = _ref.children, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Actions' : _ref$label, _ref$showMoreButtonLa = _ref.showMoreButtonLabel, showMoreButtonLabel = _ref$showMoreButtonLa === void 0 ? 'Show more' : _ref$showMoreButtonLa;
    var _useState = (0, $1v5pe.useState)(false), _useState2 = (0, $aHHxB.default)(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    var _useState3 = (0, $1v5pe.useState)(false), _useState4 = (0, $aHHxB.default)(_useState3, 2), isMobile = _useState4[0], setIsMobile = _useState4[1];
    // Note: `query` is a stable value between renders
    var query = (0, $bMABl.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $3q5kf.useLayoutEffect)(function() {
        var _query$matches;
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile((_query$matches = query === null || query === void 0 ? void 0 : query.matches) !== null && _query$matches !== void 0 ? _query$matches : false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("nav", {
        "aria-label": label,
        className: (0, $hMvDh.default)([
            $6b98b3523ae3ccac$var$containerStyles.root,
            (0, $2aEiL.fg)('platform_design_system_nav4_top_nav_columns') && $6b98b3523ae3ccac$var$containerStyles.newLayoutStyles,
            (0, $2aEiL.fg)('platform_design_system_nav4_top_nav_min_widths') && $6b98b3523ae3ccac$var$containerStyles.contentMinWidthStyles
        ])
    }, isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $c633V.default), {
        isOpen: isOpen,
        onClose: function onClose() {
            return setIsOpen(false);
        },
        placement: "bottom-start",
        shouldRenderToParent: true,
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $a23jK.HasCustomThemeContext).Provider, {
                value: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5bU3A.List), {
                xcss: (0, $hGIzV.cx)($6b98b3523ae3ccac$var$listStyles.root, $6b98b3523ae3ccac$var$listStyles.popupContainer)
            }, children));
        },
        trigger: function trigger(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eO1xw.IconButton), (0, $87uOn.default)({}, triggerProps, {
                label: showMoreButtonLabel,
                isSelected: isOpen,
                onClick: function onClick() {
                    return setIsOpen(!isOpen);
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($dEGdm))),
                isTooltipDisabled: false
            }));
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5bU3A.List), {
        xcss: (0, $hGIzV.cx)($6b98b3523ae3ccac$var$listStyles.root, $6b98b3523ae3ccac$var$listStyles.hideOnSmallViewport)
    }, children));
}

});
parcelRegister("5bU3A", function(module, exports) {
$parcel$export(module.exports, "List", () => $3c79768ac713e19c$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1v5pe = parcelRequire("1v5pe");

function $3c79768ac713e19c$var$_List(_ref, forwardedRef) {
    var children = _ref.children, testId = _ref.testId, xcss = _ref.xcss;
    return(/*#__PURE__*/ /**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ $1v5pe.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
var $3c79768ac713e19c$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $1v5pe.forwardRef)($3c79768ac713e19c$var$_List);

});

parcelRegister("eO1xw", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $ac76edf5c2b495f9$export$c25acd513dcc8062);

var $87uOn = parcelRequire("87uOn");

var $1v5pe = parcelRequire("1v5pe");

var $49361 = parcelRequire("49361");
var $hHzJx = parcelRequire("hHzJx");
var $gQyTH = parcelRequire("gQyTH");
var $iPwBl = parcelRequire("iPwBl");

var $77p4S = parcelRequire("77p4S");

var $a23jK = parcelRequire("a23jK");
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $ac76edf5c2b495f9$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $a23jK.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $77p4S.ThemedIconButton) : (0, $hHzJx.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, (0, $87uOn.default)({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $ac76edf5c2b495f9$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $a23jK.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $77p4S.ThemedLinkIconButton) : (0, $iPwBl.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, (0, $87uOn.default)({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $ac76edf5c2b495f9$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $a23jK.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $77p4S.ThemedButton) : (0, $49361.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, (0, $87uOn.default)({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $ac76edf5c2b495f9$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $a23jK.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $77p4S.ThemedLinkButton) : (0, $gQyTH.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, (0, $87uOn.default)({
        ref: ref
    }, props));
});

});


parcelRegister("XC39w", function(module, exports) {
$parcel$export(module.exports, "TopNavStart", () => $0b3306b5e2601270$export$4c15269b98c5129);
/* top-nav-start.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $d2bdS = parcelRequire("d2bdS");
var $0b3306b5e2601270$var$styles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw",
    logoPaddingStyles: "_pwyo12x7",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi"
};
function $0b3306b5e2601270$export$4c15269b98c5129(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var ref = (0, $1v5pe.useContext)((0, $d2bdS.TopNavStartAttachRef));
    var elementRef = (0, $1v5pe.useRef)(null);
    (0, $1v5pe.useEffect)(function() {
        if ((0, $2aEiL.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        ref: (0, $2aEiL.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        "data-testid": testId,
        className: (0, $hMvDh.default)([
            $0b3306b5e2601270$var$styles.root,
            (0, $2aEiL.fg)('platform_design_system_nav4_top_nav_min_widths') ? $0b3306b5e2601270$var$styles.contentMinWidthStyles : // Removing the extra logo padding when applying the content min width
            $0b3306b5e2601270$var$styles.logoPaddingStyles
        ])
    }, children);
}

});

parcelRegister("jbdyd", function(module, exports) {
$parcel$export(module.exports, "useMutation", () => $df698e58873fd245$export$609860bf8b0084c);

var $1v5pe = parcelRequire("1v5pe");

var $eiOpN = parcelRequire("eiOpN");
var $7SKaq = parcelRequire("7SKaq");

var $eAih2 = parcelRequire("eAih2");

var $6hs8J = parcelRequire("6hs8J");
"use client";
function $df698e58873fd245$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $eAih2.useQueryClient)(queryClient);
    const [observer] = $1v5pe.useState(()=>new (0, $eiOpN.MutationObserver)(client, options));
    $1v5pe.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $1v5pe.useSyncExternalStore($1v5pe.useCallback((onStoreChange)=>observer.subscribe((0, $7SKaq.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $1v5pe.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $6hs8J.noop));
    }, [
        observer
    ]);
    if (result.error && (0, $6hs8J.shouldThrowError)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}

});
parcelRegister("eiOpN", function(module, exports) {
$parcel$export(module.exports, "MutationObserver", () => $a699da81e0828140$export$d3c1860ee66f291a);
// src/mutationObserver.ts

var $bdmAo = parcelRequire("bdmAo");

var $7SKaq = parcelRequire("7SKaq");

var $g6YUH = parcelRequire("g6YUH");

var $jWbIA = parcelRequire("jWbIA");
var $a699da81e0828140$export$d3c1860ee66f291a = class extends (0, $g6YUH.Subscribable) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $jWbIA.shallowEqualObjects)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $jWbIA.hashKey)(prevOptions.mutationKey) !== (0, $jWbIA.hashKey)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $bdmAo.getDefaultState)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $7SKaq.notifyManager).batch(()=>{
            if (this.#mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const context = this.#currentResult.context;
                if (action?.type === "success") {
                    this.#mutateOptions.onSuccess?.(action.data, variables, context);
                    this.#mutateOptions.onSettled?.(action.data, null, variables, context);
                } else if (action?.type === "error") {
                    this.#mutateOptions.onError?.(action.error, variables, context);
                    this.#mutateOptions.onSettled?.(void 0, action.error, variables, context);
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};

});
parcelRegister("bdmAo", function(module, exports) {
$parcel$export(module.exports, "Mutation", () => $82a26db8c7c9013b$export$17b8b19c814bcf56);
$parcel$export(module.exports, "getDefaultState", () => $82a26db8c7c9013b$export$a1659b54bac3252a);
// src/mutation.ts

var $7SKaq = parcelRequire("7SKaq");

var $a9qWf = parcelRequire("a9qWf");

var $6G84Q = parcelRequire("6G84Q");
var $82a26db8c7c9013b$export$17b8b19c814bcf56 = class extends (0, $a9qWf.Removable) {
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $82a26db8c7c9013b$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        this.#retryer = (0, $6G84Q.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (!restored) {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await this.#mutationCache.config.onMutate?.(variables, this);
                const context = await this.options.onMutate?.(variables);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this);
            await this.options.onSuccess?.(data, variables, this.state.context);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this);
            await this.options.onSettled?.(data, null, variables, this.state.context);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this);
                await this.options.onError?.(error, variables, this.state.context);
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this);
                await this.options.onSettled?.(void 0, error, variables, this.state.context);
                throw error;
            } finally{
                this.#dispatch({
                    type: "error",
                    error: error
                });
            }
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7SKaq.notifyManager).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $82a26db8c7c9013b$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}

});



parcelRegister("l83dT", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", () => $b6c31a76153de8b9$export$8489e2f039bfcc4c);

var $fIsE2 = parcelRequire("fIsE2");
class $b6c31a76153de8b9$export$8489e2f039bfcc4c {
    static async fetch(options) {
        const fetch = options.fetch ?? globalThis.fetch;
        const response = await fetch(`${options.ffsBaseUrl}/api/v2/configurations`, {
            method: 'POST',
            body: JSON.stringify(options.context),
            headers: {
                'content-type': 'application/json',
                'x-api-key': options.ffsApiKey
            }
        });
        if (!response.ok) throw new Error(`Unexpected response ${response.status}: ${await response.text()}`);
        const valuesPayload = await response.text();
        return (0, $fIsE2.ConfigCollection).fromValues(valuesPayload);
    }
}

});
parcelRegister("fIsE2", function(module, exports) {
$parcel$export(module.exports, "ConfigCollection", () => $df1d8bbd213158b3$export$2be5653e4dada0a3);

var $1aT38 = parcelRequire("1aT38");
class $df1d8bbd213158b3$export$f9c837a54db411d extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
function $df1d8bbd213158b3$var$safeParse(json) {
    try {
        return {
            data: (0, $1aT38.AnyConfigSchema).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $df1d8bbd213158b3$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
class $df1d8bbd213158b3$export$2be5653e4dada0a3 {
    static fromValues(values, options) {
        const result = $df1d8bbd213158b3$var$safeParse(values);
        if (!result.success) {
            const parseError = new $df1d8bbd213158b3$export$f9c837a54db411d('Failed to deserialize config', result.error);
            if (options?.throw) throw parseError;
            // eslint-disable-next-line no-console
            console.error(parseError);
            return $df1d8bbd213158b3$export$2be5653e4dada0a3.empty();
        }
        return this.fromData(result.data);
    }
    static fromData(data) {
        return new $df1d8bbd213158b3$export$2be5653e4dada0a3(Array.isArray(data) ? (0, $1aT38.minimalToMap)(data) : (0, $1aT38.standardToMap)(data));
    }
    static empty() {
        return new $df1d8bbd213158b3$export$2be5653e4dada0a3(new Map());
    }
    toJson(format) {
        switch(format){
            case 'standard':
                return JSON.stringify((0, $1aT38.mapToStandard)(this.config));
            case 'minimal':
                return JSON.stringify((0, $1aT38.mapToMinimal)(this.config));
        }
    }
    constructor(config){
        this.config = config;
    }
    getBoolean(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $1aT38.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'boolean') return {
            error: (0, $1aT38.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getString(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $1aT38.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'string') return {
            error: (0, $1aT38.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumber(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $1aT38.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'number') return {
            error: (0, $1aT38.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getStringList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $1aT38.ConfigError).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'string')) return {
            error: (0, $1aT38.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumberList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $1aT38.ConfigError).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'number')) return {
            error: (0, $1aT38.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
}

});
parcelRegister("1aT38", function(module, exports) {
$parcel$export(module.exports, "ConfigError", () => $7297ff8ece5114e6$export$c5fb415882705cf4);
$parcel$export(module.exports, "AnyConfigSchema", () => $7297ff8ece5114e6$export$960d45de79bd7d81);
$parcel$export(module.exports, "minimalToMap", () => $7297ff8ece5114e6$export$c29ba52779f58587);
$parcel$export(module.exports, "standardToMap", () => $7297ff8ece5114e6$export$be5b69ecb011d7cc);
$parcel$export(module.exports, "mapToMinimal", () => $7297ff8ece5114e6$export$460f06addafd9f86);
$parcel$export(module.exports, "mapToStandard", () => $7297ff8ece5114e6$export$9d0101ad8235e092);

var $iboSh = parcelRequire("iboSh");
const $7297ff8ece5114e6$export$c5fb415882705cf4 = {
    NotFound: 'not_found',
    InvalidState: 'state_invalid',
    IncorrectType: 'incorrect_type'
};
const $7297ff8ece5114e6$export$e94ee64b2671e155 = (0, $iboSh.z).record((0, $iboSh.z).string(), (0, $iboSh.z).object({
    value: (0, $iboSh.z).union([
        (0, $iboSh.z).boolean(),
        (0, $iboSh.z).string(),
        (0, $iboSh.z).number(),
        (0, $iboSh.z).string().array(),
        (0, $iboSh.z).number().array()
    ])
}));
const $7297ff8ece5114e6$export$e38f7b10db0e126a = (0, $iboSh.z).tuple([
    // list of boolean configs which are on
    (0, $iboSh.z).string().array(),
    // list of string config tuples
    (0, $iboSh.z).array((0, $iboSh.z).string()).refine((arr)=>arr.length % 2 === 0),
    // list of number config tuples
    (0, $iboSh.z).array((0, $iboSh.z).union([
        (0, $iboSh.z).string(),
        (0, $iboSh.z).number()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $iboSh.z).array((0, $iboSh.z).union([
        (0, $iboSh.z).string(),
        (0, $iboSh.z).string().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'string')) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $iboSh.z).array((0, $iboSh.z).union([
        (0, $iboSh.z).string(),
        (0, $iboSh.z).number().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'number')) return false;
        }
        return true;
    })
]);
const $7297ff8ece5114e6$export$960d45de79bd7d81 = (0, $iboSh.z).union([
    $7297ff8ece5114e6$export$e94ee64b2671e155,
    $7297ff8ece5114e6$export$e38f7b10db0e126a
]);
const $7297ff8ece5114e6$export$ac2e9c88ba5d7cbb = (0, $iboSh.z).map((0, $iboSh.z).string(), (0, $iboSh.z).object({
    value: (0, $iboSh.z).union([
        (0, $iboSh.z).boolean(),
        (0, $iboSh.z).string(),
        (0, $iboSh.z).number(),
        (0, $iboSh.z).string().array(),
        (0, $iboSh.z).number().array()
    ])
}));
function $7297ff8ece5114e6$var$pairs(arr, fn) {
    for(let i = 0; i < arr.length; i += 2){
        const key = arr[i];
        const val = arr[i + 1];
        if (typeof key !== 'string') throw new Error(`Expected a string while iterating pairs, got: ${arr[i]}`);
        fn(key, val);
    }
}
function $7297ff8ece5114e6$export$c29ba52779f58587(minimal) {
    const map = new Map();
    minimal[0].forEach((boolean)=>map.set(boolean, {
            value: true
        }));
    $7297ff8ece5114e6$var$pairs(minimal[1], (a, b)=>map.set(a, {
            value: b
        }));
    $7297ff8ece5114e6$var$pairs(minimal[2], (a, b)=>map.set(a, {
            value: b
        }));
    $7297ff8ece5114e6$var$pairs(minimal[3], (a, b)=>map.set(a, {
            value: b
        }));
    $7297ff8ece5114e6$var$pairs(minimal[4], (a, b)=>map.set(a, {
            value: b
        }));
    return map;
}
function $7297ff8ece5114e6$export$be5b69ecb011d7cc(standard) {
    const map = new Map();
    Object.entries(standard).forEach(([key, value])=>map.set(key, value));
    return map;
}
function $7297ff8ece5114e6$export$460f06addafd9f86(map) {
    const minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    for (const [key, { value: value }] of map.entries())switch(typeof value){
        case 'boolean':
            if (value) minimal[0].push(key);
            break;
        case 'string':
            minimal[1].push(key, value);
            break;
        case 'number':
            minimal[2].push(key, value);
            break;
        default:
            if (!Array.isArray(value)) throw new Error(`Unexpected configuration value: ${value}`);
            const allStrings = value.every((x)=>typeof x === 'string');
            if (allStrings) {
                minimal[3].push(key, value);
                break;
            }
            const allNumbers = value.every((x)=>typeof x === 'number');
            if (allNumbers) {
                minimal[4].push(key, value);
                break;
            }
            throw new Error(`Unexpected configuration value: ${value}`);
    }
    return minimal;
}
function $7297ff8ece5114e6$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}

});



parcelRegister("SOJpc", function(module, exports) {
"use strict";
var $0a4c6572dbf104c4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a4c6572dbf104c4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a4c6572dbf104c4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("ir32P")), module.exports);

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("bj8Zo")), module.exports);

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("dQ3yU")), module.exports);

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("kyyQ5")), module.exports);

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("i6koh")), module.exports);

});
parcelRegister("ir32P", function(module, exports) {
"use strict";
var $d6bd1c351628a6f2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $d6bd1c351628a6f2$var$feature_gate_js_client_1 = $d6bd1c351628a6f2$var$__importDefault((parcelRequire("gGyUC")));
const $d6bd1c351628a6f2$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $1v5pe.useState)(()=>$d6bd1c351628a6f2$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $1v5pe.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $d6bd1c351628a6f2$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $d6bd1c351628a6f2$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $d6bd1c351628a6f2$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $1v5pe.useState)(()=>$d6bd1c351628a6f2$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $1v5pe.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $d6bd1c351628a6f2$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $d6bd1c351628a6f2$var$useExperimentValue;

});
parcelRegister("gGyUC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("4d1Vr")).default);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("joS99")).FeatureGateEnvironment);
$parcel$export(module.exports, "PerimeterType", () => (parcelRequire("joS99")).PerimeterType);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("4d6dI")).CLIENT_VERSION);
$parcel$export(module.exports, "DynamicConfig", () => (parcelRequire("4p9Sd")).DynamicConfig);
$parcel$export(module.exports, "Layer", () => (parcelRequire("kIeaF")).Layer);
$parcel$export(module.exports, "EvaluationReason", () => (parcelRequire("lOIRH")).EvaluationReason);
parcelRequire("4d1Vr");
var $4d6dI = parcelRequire("4d6dI");
var $4d1Vr = parcelRequire("4d1Vr");
var $joS99 = parcelRequire("joS99");

var $4p9Sd = parcelRequire("4p9Sd");

var $kIeaF = parcelRequire("kIeaF");

var $lOIRH = parcelRequire("lOIRH");

});


parcelRegister("bj8Zo", function(module, exports) {
"use strict";
var $83b87120a3a3f350$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $83b87120a3a3f350$var$feature_gate_js_client_1 = $83b87120a3a3f350$var$__importDefault((parcelRequire("gGyUC")));

var $5cBwV = parcelRequire("5cBwV");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $83b87120a3a3f350$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $1v5pe.useState)(!overrides && (0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $1v5pe.useRef)(options);
    (0, $1v5pe.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (enabled) {
            if ((0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $5cBwV.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $83b87120a3a3f350$var$feature_gate_js_client_1.default.initializeCalled() ? $83b87120a3a3f350$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $83b87120a3a3f350$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $5cBwV.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $5cBwV.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $5cBwV.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $5cBwV.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $83b87120a3a3f350$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("5cBwV", function(module, exports) {
"use strict";
var $3c9b2f71dbe5292d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClientAlreadyInCorrectState = $3c9b2f71dbe5292d$var$isClientAlreadyInCorrectState;
module.exports.pickChildToRender = $3c9b2f71dbe5292d$var$pickChildToRender;
module.exports.toError = $3c9b2f71dbe5292d$var$toError;
module.exports.applyOverrides = $3c9b2f71dbe5292d$var$applyOverrides;
module.exports.clearOverrides = $3c9b2f71dbe5292d$var$clearOverrides;

const $3c9b2f71dbe5292d$var$react_1 = $3c9b2f71dbe5292d$var$__importDefault((parcelRequire("1v5pe")));

const $3c9b2f71dbe5292d$var$feature_gate_js_client_1 = $3c9b2f71dbe5292d$var$__importDefault((parcelRequire("gGyUC")));
let $3c9b2f71dbe5292d$var$hasWarnedAboutMissingOverrideSupport = false;
function $3c9b2f71dbe5292d$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default)) && ((_b = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
function $3c9b2f71dbe5292d$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $3c9b2f71dbe5292d$var$react_1.default.createElement($3c9b2f71dbe5292d$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $3c9b2f71dbe5292d$var$react_1.default.createElement($3c9b2f71dbe5292d$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
function $3c9b2f71dbe5292d$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
function $3c9b2f71dbe5292d$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.overrideGate || !$3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$3c9b2f71dbe5292d$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            $3c9b2f71dbe5292d$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, configName, values);
    });
}
function $3c9b2f71dbe5292d$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, configName);
    });
}

});


parcelRegister("dQ3yU", function(module, exports) {
"use strict";
var $a132e508e4c80896$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $a132e508e4c80896$var$feature_gate_js_client_1 = $a132e508e4c80896$var$__importDefault((parcelRequire("gGyUC")));

var $5cBwV = parcelRequire("5cBwV");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $a132e508e4c80896$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $1v5pe.useState)(!overrides && (0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $1v5pe.useRef)(options);
    const providerRef = (0, $1v5pe.useRef)(provider);
    (0, $1v5pe.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (enabled) {
            if ((0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $5cBwV.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $a132e508e4c80896$var$feature_gate_js_client_1.default.initializeCalled() ? $a132e508e4c80896$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $a132e508e4c80896$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $5cBwV.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $5cBwV.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $5cBwV.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $5cBwV.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $a132e508e4c80896$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("kyyQ5", function(module, exports) {
"use strict";
var $ef7201ee4557bb25$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $ef7201ee4557bb25$var$feature_gate_js_client_1 = $ef7201ee4557bb25$var$__importDefault((parcelRequire("gGyUC")));

var $5cBwV = parcelRequire("5cBwV");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $ef7201ee4557bb25$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $1v5pe.useState)(!overrides && (0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $1v5pe.useRef)(options);
    (0, $1v5pe.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (enabled) {
            if ((0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $5cBwV.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $ef7201ee4557bb25$var$feature_gate_js_client_1.default.initializeCalled() ? $ef7201ee4557bb25$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $ef7201ee4557bb25$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: 'client-default-key'
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.catch((err)=>(0, $5cBwV.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $5cBwV.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $5cBwV.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $5cBwV.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $ef7201ee4557bb25$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("i6koh", function(module, exports) {
"use strict";
var $d2d89ab43b3c322f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $d2d89ab43b3c322f$var$feature_gate_js_client_1 = $d2d89ab43b3c322f$var$__importDefault((parcelRequire("gGyUC")));

var $5cBwV = parcelRequire("5cBwV");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $d2d89ab43b3c322f$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $1v5pe.useState)(!overrides && (0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $1v5pe.useRef)(options);
    (0, $1v5pe.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (enabled) {
            if ((0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $5cBwV.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $d2d89ab43b3c322f$var$feature_gate_js_client_1.default.initializeCalled() ? $d2d89ab43b3c322f$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $d2d89ab43b3c322f$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.catch((err)=>(0, $5cBwV.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $5cBwV.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $5cBwV.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $5cBwV.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $d2d89ab43b3c322f$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});


parcelRegister("275D8", function(module, exports) {
$parcel$export(module.exports, "default", () => $5365344aa32db5fa$export$2e2bcd8739ae039);

var $9eAWN = parcelRequire("9eAWN");

var $8jRfN = parcelRequire("8jRfN");

var $92SYF = parcelRequire("92SYF");

var $liOg6 = parcelRequire("liOg6");

var $fpEUz = parcelRequire("fpEUz");
const $5365344aa32db5fa$export$45f8278e99551e4d = 10000;
class $5365344aa32db5fa$export$2e2bcd8739ae039 {
    constructor(providerOptions){
        this.lastUpdatedTimestamp = 0;
        this.providerOptions = providerOptions;
        this.featureGateUpdateHttpHandler = this.featureGateUpdateHttpHandler.bind(this);
        this.featureGateUpdateBroadcastHandler = this.featureGateUpdateBroadcastHandler.bind(this);
        this.refresh = new (0, $liOg6.default)(providerOptions, this.featureGateUpdateHttpHandler);
        this.broadcast = new (0, $8jRfN.default)(providerOptions.apiKey, this.featureGateUpdateBroadcastHandler);
        try {
            this.featureGatesDB = new (0, $92SYF.default)();
            // Dont run on startup to prevent slowdown
            setTimeout(()=>this.featureGatesDB?.purgeStaleEntries(), $5365344aa32db5fa$export$45f8278e99551e4d);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(`Error when trying to start DB, ${JSON.stringify(error)}`);
        }
    }
    setApplyUpdateCallback(applyUpdate) {
        this.applyUpdate = applyUpdate;
    }
    setClientVersion(clientVersion) {
        this.clientVersion = clientVersion;
        this.refresh.setClientVersion(clientVersion);
    }
    async setProfile(clientOptions, identifiers, customAttributes) {
        const { profileHash: profileHash, rulesetProfile: rulesetProfile } = await this.getProfileHashAndProfile(clientOptions, identifiers, customAttributes);
        if (this.currentProfileHash !== profileHash) this.lastUpdatedTimestamp = 0;
        this.currentProfileHash = profileHash;
        this.currentRulesetProfile = rulesetProfile;
        this.broadcast.updateUserContext(profileHash);
        this.refresh.updateProfile(profileHash, rulesetProfile, // We expect setProfile to be set 1. before calls to get* methods and 2. used to revert the user if updateUser* fails
        // For 1, we will set the timestamp to the current time as the get methods will cause a request if it is needed
        // For 2, it is an error case and with this code it would reset the next polling interval, delaying the next poll for new values
        Date.now());
        this.refresh.start();
    }
    async getExperimentValues() {
        if (!this.clientVersion) throw new Error('Client version has not been set');
        if (!this.currentRulesetProfile || !this.currentProfileHash) throw new Error('Profile has not been set');
        const profileHash = (0, $fpEUz.cloneObject)(this.currentProfileHash);
        const rulesetProfile = (0, $fpEUz.cloneObject)(this.currentRulesetProfile);
        // Attempt to get from the DB
        const dbValues = await this.featureGatesDB?.getExperimentValues(profileHash);
        const lastKnownUpdatedTimestamp = dbValues?.timestamp ?? 0;
        this.lastUpdatedTimestamp = lastKnownUpdatedTimestamp;
        if (dbValues) {
            this.refresh.setTimestamp(lastKnownUpdatedTimestamp);
            this.refresh.start();
            return (0, $fpEUz.getFrontendExperimentsResult)(dbValues.experimentValuesResponse);
        }
        let newLastUpdatedTimestamp = lastKnownUpdatedTimestamp;
        const experimentResult = await this.fetchExperimentValues(this.clientVersion, rulesetProfile).then((result)=>{
            newLastUpdatedTimestamp = Date.now();
            return result;
        }).finally(()=>{
            if (profileHash === this.currentProfileHash) {
                this.lastUpdatedTimestamp = newLastUpdatedTimestamp;
                this.refresh.setTimestamp(newLastUpdatedTimestamp);
                this.refresh.start();
            }
        });
        const featureGateState = {
            profileHash: profileHash,
            rulesetProfile: rulesetProfile,
            experimentValuesResponse: experimentResult,
            timestamp: newLastUpdatedTimestamp
        };
        // Should not process this update as getExperimentValues will only be called on initialize and update user,
        // and in those cases processing is handled elsewhere
        this.featureGateUpdateHttpHandler(featureGateState, false);
        return (0, $fpEUz.getFrontendExperimentsResult)(experimentResult);
    }
    async getClientSdkKey() {
        if (!this.clientVersion) throw new Error('Client version has not been set');
        if (!this.currentRulesetProfile) throw new Error('Profile has not been set');
        const { environment: environment, targetApp: targetApp, perimeter: perimeter } = this.currentRulesetProfile;
        const { apiKey: apiKey, initialFetchTimeout: initialFetchTimeout, useGatewayURL: useGatewayURL } = this.providerOptions;
        const fetcherOptions = {
            environment: environment,
            targetApp: targetApp,
            perimeter: perimeter,
            apiKey: apiKey,
            fetchTimeoutMs: initialFetchTimeout,
            useGatewayURL: useGatewayURL
        };
        const clientKeyFromDB = await this.featureGatesDB?.getClientSdkKey({
            targetApp: targetApp,
            environment: environment,
            perimeter: perimeter
        });
        if (clientKeyFromDB) return clientKeyFromDB.clientSdkKey;
        const { clientSdkKey: clientSdkKey } = await (0, $9eAWN.default).fetchClientSdkKey(this.clientVersion, fetcherOptions);
        this.featureGatesDB?.setClientSdkKey({
            clientSdkKey: clientSdkKey,
            targetApp: targetApp,
            environment: environment,
            perimeter: perimeter,
            timestamp: Date.now()
        });
        return clientSdkKey;
    }
    getApiKey() {
        return this.providerOptions.apiKey;
    }
    async getProfileHashAndProfile(clientOptions, identifiers, customAttributes) {
        const rulesetProfile = this.getRulesetProfile(clientOptions, identifiers, customAttributes);
        const hashedProfile = await (0, $fpEUz.createHash)(JSON.stringify(rulesetProfile));
        return {
            profileHash: (0, $9eAWN.EXPERIMENT_VALUES_API_VERSION) + '.' + hashedProfile,
            rulesetProfile: rulesetProfile
        };
    }
    getRulesetProfile(clientOptions, identifiers, customAttributes) {
        return {
            identifiers: identifiers,
            customAttributes: customAttributes,
            environment: clientOptions.environment,
            targetApp: clientOptions.targetApp,
            perimeter: clientOptions.perimeter
        };
    }
    async fetchExperimentValues(clientVersion, rulesetProfile) {
        const { identifiers: identifiers, customAttributes: customAttributes, environment: environment, targetApp: targetApp, perimeter: perimeter } = rulesetProfile;
        const { apiKey: apiKey, initialFetchTimeout: initialFetchTimeout, useGatewayURL: useGatewayURL } = this.providerOptions;
        const fetcherOptions = {
            environment: environment,
            targetApp: targetApp,
            perimeter: perimeter,
            apiKey: apiKey,
            fetchTimeoutMs: initialFetchTimeout,
            useGatewayURL: useGatewayURL
        };
        return await (0, $9eAWN.default).fetchExperimentValues(clientVersion, fetcherOptions, identifiers, customAttributes);
    }
    featureGateUpdateHttpHandler(experimentValuesEntry, shouldProcessUpdate = true) {
        if (shouldProcessUpdate) this.processFeatureGateUpdate(experimentValuesEntry);
        this.featureGatesDB?.setExperimentValues(experimentValuesEntry);
        // broadcast the flag state to other tabs if the profile matches that of the current broadcast channel
        if (experimentValuesEntry.profileHash === this.currentProfileHash) this.broadcast.sendFeatureGateState(experimentValuesEntry);
    }
    featureGateUpdateBroadcastHandler(featureGateState) {
        // return if broadcasted feature gate state is stale
        if (featureGateState.timestamp < this.lastUpdatedTimestamp) return;
        this.processFeatureGateUpdate(featureGateState);
    }
    processFeatureGateUpdate(featureGateState) {
        if (this.currentProfileHash === featureGateState.profileHash) {
            this.lastUpdatedTimestamp = featureGateState.timestamp;
            this.refresh.setTimestamp(featureGateState.timestamp);
            if (!this.applyUpdate) // eslint-disable-next-line no-console
            console.warn('No apply update callback has been set. Cannot update experiment values.');
            else this.applyUpdate((0, $fpEUz.getFrontendExperimentsResult)(featureGateState.experimentValuesResponse));
        }
    }
}

});
parcelRegister("9eAWN", function(module, exports) {
$parcel$export(module.exports, "EXPERIMENT_VALUES_API_VERSION", () => $107086d39aeec330$export$1e164866fd37d1a9);
$parcel$export(module.exports, "default", () => $107086d39aeec330$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ResponseError", () => (parcelRequire("8OrYS")).ResponseError);

var $joS99 = parcelRequire("joS99");

var $8OrYS = parcelRequire("8OrYS");
const $107086d39aeec330$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $107086d39aeec330$var$PROD_BASE_URL = 'https://api.atlassian.com/flags';
const $107086d39aeec330$var$STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const $107086d39aeec330$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $107086d39aeec330$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $107086d39aeec330$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $107086d39aeec330$export$450bd8fb2a6d7ace = '/gateway/api/flags';
const $107086d39aeec330$export$1e164866fd37d1a9 = 'v2';
class $107086d39aeec330$export$2e2bcd8739ae039 {
    static async fetchClientSdkKey(clientVersion, fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(clientVersion, url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(clientVersion, fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest(clientVersion, `/api/${$107086d39aeec330$export$1e164866fd37d1a9}/frontend/experimentValues`, 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $8OrYS.ResponseError)('Non 2xx response status received', response.status, JSON.stringify(body));
        }
        if (response.status === 204) throw new (0, $8OrYS.ResponseError)('Unexpected 204 response', response.status, '');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter = (0, $joS99.PerimeterType).COMMERCIAL) {
        if (useGatewayUrl) return $107086d39aeec330$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $joS99.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $joS99.FeatureGateEnvironment).Production:
                return $107086d39aeec330$export$18c93900db9358a4;
            case (0, $joS99.FeatureGateEnvironment).Staging:
                return $107086d39aeec330$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $joS99.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $joS99.FeatureGateEnvironment).Development:
                return $107086d39aeec330$export$f058dbf75c3bc647;
            case (0, $joS99.FeatureGateEnvironment).Staging:
                return $107086d39aeec330$var$STAGING_BASE_URL;
            default:
                return $107086d39aeec330$var$PROD_BASE_URL;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(clientVersion, path, method, fetcherOptions, body) {
        const baseUrl = $107086d39aeec330$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $107086d39aeec330$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': clientVersion,
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}

});
parcelRegister("8OrYS", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $acd18e934317dd82$export$286baf652d0b1206);
class $acd18e934317dd82$export$286baf652d0b1206 extends Error {
    constructor(message, status, body){
        super(message);
        this._status = status;
        this._body = body;
    }
    get status() {
        return this._status;
    }
    get body() {
        return this._body;
    }
}

});


parcelRegister("8jRfN", function(module, exports) {
$parcel$export(module.exports, "default", () => $02397d6af42728b8$export$2e2bcd8739ae039);
const $02397d6af42728b8$export$dce59ee845588a78 = 'gateData';
class $02397d6af42728b8$export$2e2bcd8739ae039 {
    constructor(apiKey, stateUpdateCallback){
        this.apiKey = apiKey;
        this.stateUpdateCallback = stateUpdateCallback;
    }
    updateUserContext(profileHash) {
        this.stop();
        this.setupChannel(profileHash);
    }
    sendFeatureGateState(featureGateState) {
        this.channel?.postMessage(featureGateState);
    }
    stop() {
        this.channel?.close();
    }
    setupChannel(profileHash) {
        try {
            // eslint-disable-next-line compat/compat
            const channel = new BroadcastChannel(this.createChannelName(profileHash));
            channel.onmessage = (e)=>{
                this.stateUpdateCallback(e.data);
            };
            this.channel = channel;
        } catch (error) {
        // This could fail due to BroadcastChannel not available.
        // In that case, we do nothing.
        }
    }
    createChannelName(profileHash) {
        return `${$02397d6af42728b8$export$dce59ee845588a78}.${this.apiKey}.${profileHash}`;
    }
}

});

parcelRegister("92SYF", function(module, exports) {
$parcel$export(module.exports, "default", () => $45e99ecd08dc0271$export$2e2bcd8739ae039);

var $2LD0F = parcelRequire("2LD0F");

var $lvsqE = parcelRequire("lvsqE");
const $45e99ecd08dc0271$export$5e224bda12b7734d = 604800000;
const $45e99ecd08dc0271$export$324526f88ea0789d = 86400000;
class $45e99ecd08dc0271$export$2e2bcd8739ae039 {
    constructor(){
        if (!window.indexedDB) throw new Error();
        this.db = this.startDB();
    }
    async startDB() {
        return new Promise(async (resolve, reject)=>{
            if (typeof window !== 'undefined') {
                const dbTimeout = window.setTimeout(()=>{
                    const message = 'IndexedDB timed out.';
                    // eslint-disable-next-line no-console
                    console.warn(message);
                    reject(new Error(message));
                }, (0, $2LD0F.INDEXEDDB_TIMEOUT));
                /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how Feature Gates client is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $2LD0F.FEATURE_GATES_DB_NAME), 1);
                request.onupgradeneeded = (event)=>{
                    if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                    const db = request.result;
                    const clientSdkKeyStore = db.createObjectStore((0, $2LD0F.StoreName).CLIENT_SDK_KEY_STORE_NAME, {
                        keyPath: 'dbKey'
                    });
                    clientSdkKeyStore.createIndex((0, $2LD0F.CLIENT_SDK_KEY_TIMESTAMP_INDEX), 'timestamp', {
                        unique: false
                    });
                    const experimentValuesStore = db.createObjectStore((0, $2LD0F.StoreName).EXPERIMENT_VALUES_STORE_NAME, {
                        keyPath: 'profileHash'
                    });
                    experimentValuesStore.createIndex((0, $2LD0F.EXPERIMENT_VALUES_TIMESTAMP_INDEX), 'timestamp', {
                        unique: false
                    });
                };
                try {
                    await (0, $lvsqE.requestToPromise)(request);
                    return resolve(request.result);
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('IndexedDB failed to initialise.', error);
                    reject(error);
                } finally{
                    window.clearTimeout(dbTimeout);
                }
            } else {
                const message = "IndexedDB failed to initialise. No 'window' object.";
                // eslint-disable-next-line no-console
                console.warn(message);
                reject(new Error(message));
            }
        });
    }
    async setExperimentValues(entry) {
        this.setItem((0, $2LD0F.StoreName).EXPERIMENT_VALUES_STORE_NAME, entry.profileHash, entry);
    }
    async getExperimentValues(profileHash) {
        return this.getItem((0, $2LD0F.StoreName).EXPERIMENT_VALUES_STORE_NAME, profileHash);
    }
    async setClientSdkKey(entry) {
        const dbKey = (0, $lvsqE.getClientSdkKeyDBKey)(entry);
        this.setItem((0, $2LD0F.StoreName).CLIENT_SDK_KEY_STORE_NAME, dbKey, {
            ...entry,
            dbKey: dbKey
        });
    }
    async getClientSdkKey(entry) {
        return this.getItem((0, $2LD0F.StoreName).CLIENT_SDK_KEY_STORE_NAME, (0, $lvsqE.getClientSdkKeyDBKey)(entry));
    }
    async purgeStaleEntries() {
        await Promise.all([
            this.purgeStaleExperimentValues(),
            this.purgeStaleClientSdkKeys()
        ]);
    }
    async purgeStaleExperimentValues() {
        this.purgeOldEntries((0, $2LD0F.StoreName).EXPERIMENT_VALUES_STORE_NAME, (0, $2LD0F.EXPERIMENT_VALUES_TIMESTAMP_INDEX), $45e99ecd08dc0271$export$5e224bda12b7734d, (entry)=>entry.profileHash);
    }
    async purgeStaleClientSdkKeys() {
        this.purgeOldEntries((0, $2LD0F.StoreName).CLIENT_SDK_KEY_STORE_NAME, (0, $2LD0F.CLIENT_SDK_KEY_TIMESTAMP_INDEX), $45e99ecd08dc0271$export$324526f88ea0789d, (entry)=>entry.dbKey);
    }
    async getObjectStoreAndTransaction(storeName, mode) {
        const transaction = (await this.db).transaction(storeName, mode);
        const objectStore = transaction.objectStore(storeName);
        return {
            transaction: transaction,
            objectStore: objectStore
        };
    }
    async deleteItem(objectStore, id) {
        try {
            await (0, $lvsqE.requestToPromise)(objectStore.delete(id));
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to delete item:', id, error);
            throw error;
        }
    }
    async getItem(storeName, key) {
        try {
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction(storeName, 'readonly');
            const request = objectStore.get(key);
            const event = await (0, $lvsqE.requestToPromise)(request);
            await (0, $lvsqE.commitTransaction)(transaction);
            return event.target.result;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(`Error when trying to get item in store ${storeName} for key ${key}`, error);
        }
        return null;
    }
    async setItem(storeName, key, value) {
        try {
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction(storeName, 'readwrite');
            const request = objectStore.put(value);
            await (0, $lvsqE.requestToPromise)(request);
            await (0, $lvsqE.commitTransaction)(transaction);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(`Error when trying to set item in store ${storeName} with key ${key}`, error);
        }
    }
    async purgeOldEntries(storename, timestampIndexKey, expiryPeriod, getKey) {
        const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction(storename, 'readwrite');
        try {
            objectStore.getAll();
            const timeIndex = objectStore.index(timestampIndexKey);
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now() - expiryPeriod);
            const request = timeIndex.getAll(upperBoundOpenKeyRange);
            const event = await (0, $lvsqE.requestToPromise)(request);
            const deletePromises = event.target.result.map((entry)=>this.deleteItem(objectStore, getKey(entry)));
            await (0, $lvsqE.commitTransaction)(transaction);
            await Promise.all(deletePromises);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Failed to delete items from indexeddb.', error);
            throw error;
        }
    }
}

});
parcelRegister("2LD0F", function(module, exports) {
$parcel$export(module.exports, "FEATURE_GATES_DB_NAME", () => $4be89c4ee59d20d2$export$caa0390d514e457b);
$parcel$export(module.exports, "EXPERIMENT_VALUES_TIMESTAMP_INDEX", () => $4be89c4ee59d20d2$export$469d4c295729d34);
$parcel$export(module.exports, "CLIENT_SDK_KEY_TIMESTAMP_INDEX", () => $4be89c4ee59d20d2$export$3e70a6a23414e2ae);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $4be89c4ee59d20d2$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreName", () => $4be89c4ee59d20d2$export$79234e00edec7f22);
const $4be89c4ee59d20d2$export$caa0390d514e457b = 'feature-gates-client';
const $4be89c4ee59d20d2$export$469d4c295729d34 = 'experiment-values-timestamp-index';
const $4be89c4ee59d20d2$export$3e70a6a23414e2ae = 'client-sdk-key-timestamp-index';
const $4be89c4ee59d20d2$export$6d8635fed0e4b14d = 15000;
var $4be89c4ee59d20d2$export$79234e00edec7f22 = /*#__PURE__*/ function(StoreName) {
    StoreName["EXPERIMENT_VALUES_STORE_NAME"] = "experiment-values-store";
    StoreName["CLIENT_SDK_KEY_STORE_NAME"] = "client-sdk-key-store";
    return StoreName;
}({});

});

parcelRegister("lvsqE", function(module, exports) {
$parcel$export(module.exports, "getClientSdkKeyDBKey", () => $0fc70c60f8553791$export$33d2e03312ce4747);
$parcel$export(module.exports, "requestToPromise", () => $0fc70c60f8553791$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $0fc70c60f8553791$export$feab8418f018df89);
const $0fc70c60f8553791$export$33d2e03312ce4747 = (entry)=>`${entry.targetApp}.${entry.environment}.${entry.perimeter}`;
const $0fc70c60f8553791$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $0fc70c60f8553791$var$transactionToPromise = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $0fc70c60f8553791$export$feab8418f018df89 = (transaction)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $0fc70c60f8553791$var$transactionToPromise(transaction);
};

});


parcelRegister("liOg6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fc8640612650866$export$2e2bcd8739ae039);

var $dmmsG = parcelRequire("dmmsG");

var $9eAWN = parcelRequire("9eAWN");
var $8OrYS = parcelRequire("8OrYS");

var $fpEUz = parcelRequire("fpEUz");
const $2fc8640612650866$export$e368b3f041583a9f = 300000;
const $2fc8640612650866$export$9f07cc6db84eac61 = {
    minWaitInterval: 300000,
    // 300 second = 5 mins
    maxWaitInterval: 1200000,
    // 1200 second = 20 mins
    backOffFactor: 2,
    backOffJitter: 0.1,
    // Jitter is upto 10% of wait time
    interval: 300000,
    // 300 second = 5 mins
    tabHiddenPollingFactor: 12,
    // for hidden tabs, use hiddenTabFactor * interval for polling = 1 hour (default)
    maxInstantRetryTimes: 0
};
const $2fc8640612650866$export$2b558311ac69763c = {
    ...$2fc8640612650866$export$9f07cc6db84eac61,
    minWaitInterval: 500,
    interval: 500,
    maxInstantRetryTimes: 1
};
class $2fc8640612650866$export$2e2bcd8739ae039 {
    constructor(providerOptions, onExperimentValuesUpdate){
        this.failureCount = 0;
        this.lastUpdateTimestamp = 0;
        this.hasIntervalBeenValidated = false;
        this.onExperimentValuesUpdate = onExperimentValuesUpdate;
        this.pollingConfig = {
            ...$2fc8640612650866$export$9f07cc6db84eac61,
            interval: providerOptions.pollingInterval ?? $2fc8640612650866$export$9f07cc6db84eac61.interval,
            maxInstantRetryTimes: 0 // Force this to 0 so this never reschedules instantly with cache
        };
        this.noCachePollingConfig = $2fc8640612650866$export$2b558311ac69763c;
        this.providerOptions = providerOptions;
        this.visibilityChangeHandler = this.visibilityChangeHandler.bind(this);
    }
    // start refresh by fetchAndReschedule
    start() {
        this.stop();
        this.bindVisibilityChange();
        this.fetchAndReschedule();
    }
    // cancel pending schedule
    stop() {
        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = undefined;
            this.unbindVisibilityChange();
        }
    }
    updateProfile(profileHash, rulesetProfile, lastUpdateTimestamp = 0) {
        this.profileHash = profileHash;
        this.rulesetProfile = rulesetProfile;
        this.lastUpdateTimestamp = this.adjustBasedOnStaleness(lastUpdateTimestamp);
        this.failureCount = 0;
    }
    // update version and timestamp
    setClientVersion(clientVersion) {
        this.clientVersion = clientVersion;
    }
    setTimestamp(lastUpdateTimestamp) {
        this.lastUpdateTimestamp = this.adjustBasedOnStaleness(lastUpdateTimestamp);
    }
    adjustBasedOnStaleness(timestamp) {
        return Date.now() - timestamp >= $2fc8640612650866$export$e368b3f041583a9f ? 0 : timestamp;
    }
    visibilityChangeHandler() {
        // cancel existing schedule
        window.clearTimeout(this.timerId);
        this.timerId = undefined;
        // get current tab hidden state (for unsupported browser isTabHidden() will return false), so
        // if isTabHidden true: create a new schedule with a longer interval
        // if isTabHidden false: do a fetchAndReschedule (conditional do a fetch, schedule with normal interval)
        if ($2fc8640612650866$export$2e2bcd8739ae039.isTabHidden()) this.schedule();
        else this.fetchAndReschedule();
    }
    static isTabHidden() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- visibilityState is read from the active document
        return document.visibilityState === 'hidden';
    }
    // bind tab visibility change callback
    bindVisibilityChange() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- page visibility listener is bound on document
        this.unbind = (0, $dmmsG.bind)(document, {
            type: 'visibilitychange',
            listener: this.visibilityChangeHandler
        });
    }
    // unbind tab visibility change callback
    unbindVisibilityChange() {
        if (this.unbind) this.unbind();
    }
    // schedule a fetchAndReschedule
    schedule() {
        this.timerId = window.setTimeout(()=>{
            this.fetchAndReschedule();
        }, this.calculateInterval());
    }
    // conditional fetch ffs via fetcher, and schedule another fetchAndReschedule unless we have 400/401 from ffs
    fetchAndReschedule() {
        if (!this.clientVersion) throw new Error('Client version has not been set');
        if (!this.profileHash || !this.rulesetProfile) throw new Error('Profile has not been set');
        const fetchedProfileHash = this.profileHash;
        const fetchedRulesetProfile = this.rulesetProfile;
        const { environment: environment, targetApp: targetApp, perimeter: perimeter } = this.rulesetProfile;
        const { apiKey: apiKey, useGatewayURL: useGatewayURL } = this.providerOptions;
        // validate the polling interval is not too short based on the environment
        this.pollingConfig.interval = (0, $fpEUz.getValidatedPollingInterval)(this.pollingConfig.interval, environment, !this.hasIntervalBeenValidated);
        // set this to true after first validation to prevent multiple info logs
        this.hasIntervalBeenValidated = true;
        const fetcherOptions = {
            environment: environment,
            targetApp: targetApp,
            perimeter: perimeter,
            apiKey: apiKey,
            useGatewayURL: useGatewayURL
        };
        if (this.isFetchRequired()) (0, $9eAWN.default).fetchExperimentValues(this.clientVersion, fetcherOptions, this.rulesetProfile.identifiers, this.rulesetProfile.customAttributes).then((resp)=>{
            if (fetchedProfileHash === this.profileHash) {
                this.failureCount = 0;
                this.onExperimentValuesUpdate({
                    profileHash: fetchedProfileHash,
                    rulesetProfile: fetchedRulesetProfile,
                    experimentValuesResponse: resp,
                    timestamp: Date.now()
                });
                this.schedule();
            }
        }).catch((err)=>{
            // 401 means client info or apiKey invalid, will have no retry
            // 400 means request body invalid, will have at most `maxInstantRetryTimes` instant retries
            // other 4xx or 5xx will do `maxInstantRetryTimes` instant retries and continue to do backoff retries
            if (err instanceof (0, $8OrYS.ResponseError) && [
                400,
                401
            ].includes(err.status)) {
                // no retry needed
                const message = `Feature flag service returned ${err.status}, "${err.body}". This request will not be retried until the profile data has been changed.`;
                // eslint-disable-next-line no-console
                console.error(message);
            } else {
                this.failureCount += 1;
                this.schedule();
            }
        });
        else this.schedule();
    }
    isFetchRequired() {
        return Date.now() - this.getPollingConfig().interval >= this.lastUpdateTimestamp;
    }
    // calculate wait interval based on failure count
    calculateInterval() {
        const { interval: interval, tabHiddenPollingFactor: tabHiddenPollingFactor, minWaitInterval: minWaitInterval, maxWaitInterval: maxWaitInterval, backOffFactor: backOffFactor, backOffJitter: backOffJitter, maxInstantRetryTimes: maxInstantRetryTimes } = this.getPollingConfig();
        if (maxInstantRetryTimes !== undefined && maxInstantRetryTimes !== 0 && maxInstantRetryTimes >= this.failureCount) return 0;
        if (this.failureCount === 0) return $2fc8640612650866$export$2e2bcd8739ae039.isTabHidden() ? interval * tabHiddenPollingFactor : interval;
        let ms = minWaitInterval * backOffFactor ** (this.failureCount - 1);
        if (backOffJitter) {
            const rand = Math.random();
            const deviation = Math.floor(rand * backOffJitter * ms);
            if (Math.floor(rand * 10) < 5) ms -= deviation;
            else ms += deviation;
        }
        return Number(Math.min(ms, maxWaitInterval));
    }
    getPollingConfig() {
        if (this.lastUpdateTimestamp === 0) return this.noCachePollingConfig;
        return this.pollingConfig;
    }
}

});
parcelRegister("fpEUz", function(module, exports) {
$parcel$export(module.exports, "getFrontendExperimentsResult", () => $053708b8f98db226$export$ea331062506158bf);
$parcel$export(module.exports, "getValidatedPollingInterval", () => $053708b8f98db226$export$5063c9cde7b925d3);
$parcel$export(module.exports, "createHash", () => $053708b8f98db226$export$2fb37efbf6ae0c0e);
$parcel$export(module.exports, "cloneObject", () => $053708b8f98db226$export$d30aea6baca0538b);

var $joS99 = parcelRequire("joS99");
const $053708b8f98db226$export$ea331062506158bf = (frontendExperimentsResponse)=>{
    const { clientSdkKey: clientSdkKey, experimentValues: experimentValues, customAttributes: customAttributesFromFetch } = frontendExperimentsResponse;
    return {
        clientSdkKey: clientSdkKey,
        experimentValues: experimentValues,
        customAttributesFromFetch: customAttributesFromFetch
    };
};
const $053708b8f98db226$export$5063c9cde7b925d3 = (currentInterval, environment, logInfo)=>{
    const prodMinInterval = 60000;
    const nonProdMinInterval = 1000;
    let newInterval = currentInterval;
    if (currentInterval < prodMinInterval) {
        if (environment === (0, $joS99.FeatureGateEnvironment).Production) {
            newInterval = prodMinInterval;
            if (logInfo) // eslint-disable-next-line no-console
            console.info(`options.pollingInterval needs to be greater than ${prodMinInterval}, interval has been set to minimum`);
        } else if (currentInterval < nonProdMinInterval) {
            newInterval = nonProdMinInterval;
            if (logInfo) // eslint-disable-next-line no-console
            console.info(`options.pollingInterval needs to be greater than ${nonProdMinInterval}, interval has been set to minimum`);
        } else if (logInfo) // eslint-disable-next-line no-console
        console.info(`options.pollingInterval needs to be greater than ${prodMinInterval} in Production`);
    }
    return newInterval;
};
const $053708b8f98db226$export$2fb37efbf6ae0c0e = async (input)=>{
    const msgUint8 = new TextEncoder().encode(input); // encode as (utf-8) Uint8Array
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
    return hashHex;
};
const $053708b8f98db226$export$d30aea6baca0538b = (obj)=>{
    const str = JSON.stringify(obj);
    return JSON.parse(str);
};

});



parcelRegister("7KlwK", function(module, exports) {
$parcel$export(module.exports, "createSyncStoragePersister", () => $5a3d872710bdb479$export$35561f995d4e487d);
function $5a3d872710bdb479$export$35561f995d4e487d({ storage: storage, key: key = "REACT_QUERY_OFFLINE_CACHE", throttleTime: throttleTime = 1000, serialize: serialize = JSON.stringify, deserialize: deserialize = JSON.parse, retry: retry }) {
    if (storage) {
        const trySave = (persistedClient)=>{
            try {
                storage.setItem(key, serialize(persistedClient));
                return;
            } catch (error) {
                return error;
            }
        };
        return {
            persistClient: $5a3d872710bdb479$var$throttle((persistedClient)=>{
                let client = persistedClient;
                let error = trySave(client);
                let errorCount = 0;
                while(error && client){
                    errorCount++;
                    client = retry == null ? void 0 : retry({
                        persistedClient: client,
                        error: error,
                        errorCount: errorCount
                    });
                    if (client) error = trySave(client);
                }
            }, throttleTime),
            restoreClient: ()=>{
                const cacheString = storage.getItem(key);
                if (!cacheString) return;
                return deserialize(cacheString);
            },
            removeClient: ()=>{
                storage.removeItem(key);
            }
        };
    }
    return {
        persistClient: $5a3d872710bdb479$var$noop,
        restoreClient: ()=>undefined,
        removeClient: $5a3d872710bdb479$var$noop
    };
}
function $5a3d872710bdb479$var$throttle(func, wait = 100) {
    let timer = null;
    let params;
    return function(...args) {
        params = args;
        if (timer === null) timer = setTimeout(()=>{
            func(...params);
            timer = null;
        }, wait);
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $5a3d872710bdb479$var$noop() {}

});

parcelRegister("jDOwD", function(module, exports) {
$parcel$export(module.exports, "QueryClient", () => $e4c8da2672b01a6f$export$405d0624ed55a03f);
// src/queryClient.ts

var $jWbIA = parcelRequire("jWbIA");

var $4yvMS = parcelRequire("4yvMS");

var $l4G1g = parcelRequire("l4G1g");

var $bxfwH = parcelRequire("bxfwH");

var $7LwdT = parcelRequire("7LwdT");

var $7SKaq = parcelRequire("7SKaq");

var $92O0e = parcelRequire("92O0e");
var $e4c8da2672b01a6f$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $4yvMS.QueryCache)();
        this.#mutationCache = config.mutationCache || new (0, $l4G1g.MutationCache)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $bxfwH.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $7LwdT.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $jWbIA.resolveStaleTime)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $jWbIA.functionalUpdate)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $7SKaq.notifyManager).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $7SKaq.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $7SKaq.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $7SKaq.notifyManager).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $jWbIA.noop)).catch((0, $jWbIA.noop));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $7SKaq.notifyManager).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $7SKaq.notifyManager).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $jWbIA.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $jWbIA.noop));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $jWbIA.resolveStaleTime)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $jWbIA.noop)).catch((0, $jWbIA.noop));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $92O0e.infiniteQueryBehavior)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $jWbIA.noop)).catch((0, $jWbIA.noop));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $92O0e.infiniteQueryBehavior)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $7LwdT.onlineManager).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $jWbIA.hashKey)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $jWbIA.partialMatchKey)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $jWbIA.hashKey)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $jWbIA.partialMatchKey)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $jWbIA.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $jWbIA.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};

});
parcelRegister("4yvMS", function(module, exports) {
$parcel$export(module.exports, "QueryCache", () => $3512feb3f7821e6f$export$5dde0cd941da8468);
// src/queryCache.ts

var $jWbIA = parcelRequire("jWbIA");

var $98YQN = parcelRequire("98YQN");

var $7SKaq = parcelRequire("7SKaq");

var $g6YUH = parcelRequire("g6YUH");
var $3512feb3f7821e6f$export$5dde0cd941da8468 = class extends (0, $g6YUH.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $jWbIA.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $98YQN.Query)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $7SKaq.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $jWbIA.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $jWbIA.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, $7SKaq.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $7SKaq.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $7SKaq.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};

});

parcelRegister("l4G1g", function(module, exports) {
$parcel$export(module.exports, "MutationCache", () => $f57a90db2e90bad2$export$1fcfd9a244434844);
// src/mutationCache.ts

var $7SKaq = parcelRequire("7SKaq");

var $bdmAo = parcelRequire("bdmAo");

var $jWbIA = parcelRequire("jWbIA");

var $g6YUH = parcelRequire("g6YUH");
var $f57a90db2e90bad2$export$1fcfd9a244434844 = class extends (0, $g6YUH.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $bdmAo.Mutation)({
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = $f57a90db2e90bad2$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $f57a90db2e90bad2$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $f57a90db2e90bad2$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $f57a90db2e90bad2$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $7SKaq.notifyManager).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $jWbIA.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $jWbIA.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $7SKaq.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $7SKaq.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $jWbIA.noop)))));
    }
};
function $f57a90db2e90bad2$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}

});

parcelRegister("92O0e", function(module, exports) {
$parcel$export(module.exports, "infiniteQueryBehavior", () => $695b167b51ecd7c2$export$84470d1367601e8d);
// src/infiniteQueryBehavior.ts

var $jWbIA = parcelRequire("jWbIA");
function $695b167b51ecd7c2$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $jWbIA.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        client: context.client,
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $jWbIA.addToStart) : (0, $jWbIA.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $695b167b51ecd7c2$var$getPreviousPageParam : $695b167b51ecd7c2$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $695b167b51ecd7c2$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $695b167b51ecd7c2$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $695b167b51ecd7c2$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $695b167b51ecd7c2$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $695b167b51ecd7c2$var$getNextPageParam(options, data) != null;
}
function $695b167b51ecd7c2$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $695b167b51ecd7c2$var$getPreviousPageParam(options, data) != null;
}

});


parcelRegister("71PQa", function(module, exports) {
$parcel$export(module.exports, "useSuspenseQueries", () => $51e0d6d42675b41a$export$5d5d53208d49f2c9);


var $ftUZL = parcelRequire("ftUZL");

var $aw3OK = parcelRequire("aw3OK");
"use client";
function $51e0d6d42675b41a$export$5d5d53208d49f2c9(options, queryClient) {
    return (0, $ftUZL.useQueries)({
        ...options,
        queries: options.queries.map((query)=>{
            return {
                ...query,
                suspense: true,
                throwOnError: (0, $aw3OK.defaultThrowOnError),
                enabled: true,
                placeholderData: void 0
            };
        })
    }, queryClient);
}

});
parcelRegister("ftUZL", function(module, exports) {
$parcel$export(module.exports, "useQueries", () => $b455c68303e2c76c$export$408667c6c87da1e5);

var $1v5pe = parcelRequire("1v5pe");

var $7SKaq = parcelRequire("7SKaq");
var $hnfVe = parcelRequire("hnfVe");
var $8JUrJ = parcelRequire("8JUrJ");

var $eAih2 = parcelRequire("eAih2");

var $9Zfop = parcelRequire("9Zfop");

var $17k5Z = parcelRequire("17k5Z");

var $hTEKq = parcelRequire("hTEKq");

var $aw3OK = parcelRequire("aw3OK");

var $6hs8J = parcelRequire("6hs8J");
"use client";
function $b455c68303e2c76c$export$408667c6c87da1e5({ queries: queries, ...options }, queryClient) {
    const client = (0, $eAih2.useQueryClient)(queryClient);
    const isRestoring = (0, $9Zfop.useIsRestoring)();
    const errorResetBoundary = (0, $17k5Z.useQueryErrorResetBoundary)();
    const defaultedQueries = $1v5pe.useMemo(()=>queries.map((opts)=>{
            const defaultedOptions = client.defaultQueryOptions(opts);
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
            return defaultedOptions;
        }), [
        queries,
        client,
        isRestoring
    ]);
    defaultedQueries.forEach((query)=>{
        (0, $aw3OK.ensureSuspenseTimers)(query);
        (0, $hTEKq.ensurePreventErrorBoundaryRetry)(query, errorResetBoundary);
    });
    (0, $hTEKq.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $1v5pe.useState(()=>new (0, $hnfVe.QueriesObserver)(client, defaultedQueries, options));
    const [optimisticResult, getCombinedResult, trackResult] = observer.getOptimisticResult(defaultedQueries, options.combine);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $1v5pe.useSyncExternalStore($1v5pe.useCallback((onStoreChange)=>shouldSubscribe ? observer.subscribe((0, $7SKaq.notifyManager).batchCalls(onStoreChange)) : (0, $6hs8J.noop), [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $1v5pe.useEffect(()=>{
        observer.setQueries(defaultedQueries, options);
    }, [
        defaultedQueries,
        options,
        observer
    ]);
    const shouldAtLeastOneSuspend = optimisticResult.some((result, index)=>(0, $aw3OK.shouldSuspend)(defaultedQueries[index], result));
    const suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap((result, index)=>{
        const opts = defaultedQueries[index];
        if (opts) {
            const queryObserver = new (0, $8JUrJ.QueryObserver)(client, opts);
            if ((0, $aw3OK.shouldSuspend)(opts, result)) return (0, $aw3OK.fetchOptimistic)(opts, queryObserver, errorResetBoundary);
            else if ((0, $aw3OK.willFetch)(result, isRestoring)) (0, $aw3OK.fetchOptimistic)(opts, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        const query = defaultedQueries[index];
        return query && (0, $hTEKq.getHasError)({
            result: result,
            errorResetBoundary: errorResetBoundary,
            throwOnError: query.throwOnError,
            query: client.getQueryCache().get(query.queryHash),
            suspense: query.suspense
        });
    });
    if (firstSingleResultWhichShouldThrow?.error) throw firstSingleResultWhichShouldThrow.error;
    return getCombinedResult(trackResult());
}

});
parcelRegister("hnfVe", function(module, exports) {
$parcel$export(module.exports, "QueriesObserver", () => $ca60ef6e07328690$export$15352e437905ad4c);
// src/queriesObserver.ts

var $7SKaq = parcelRequire("7SKaq");

var $8JUrJ = parcelRequire("8JUrJ");

var $g6YUH = parcelRequire("g6YUH");

var $jWbIA = parcelRequire("jWbIA");
function $ca60ef6e07328690$var$difference(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $ca60ef6e07328690$var$replaceAt(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
var $ca60ef6e07328690$export$15352e437905ad4c = class extends (0, $g6YUH.Subscribable) {
    #client;
    #result;
    #queries;
    #options;
    #observers;
    #combinedResult;
    #lastCombine;
    #lastResult;
    #observerMatches = [];
    constructor(client, queries, options){
        super();
        this.#client = client;
        this.#options = options;
        this.#queries = [];
        this.#observers = [];
        this.#result = [];
        this.setQueries(queries);
    }
    onSubscribe() {
        if (this.listeners.size === 1) this.#observers.forEach((observer)=>{
            observer.subscribe((result)=>{
                this.#onUpdate(observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#observers.forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, options) {
        this.#queries = queries;
        this.#options = options;
        (0, $7SKaq.notifyManager).batch(()=>{
            const prevObservers = this.#observers;
            const newObserverMatches = this.#findMatchingObservers(this.#queries);
            this.#observerMatches = newObserverMatches;
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            this.#observers = newObservers;
            this.#result = newResult;
            if (!this.hasListeners()) return;
            $ca60ef6e07328690$var$difference(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            $ca60ef6e07328690$var$difference(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    this.#onUpdate(observer, result);
                });
            });
            this.#notify();
        });
    }
    getCurrentResult() {
        return this.#result;
    }
    getQueries() {
        return this.#observers.map((observer)=>observer.getCurrentQuery());
    }
    getObservers() {
        return this.#observers;
    }
    getOptimisticResult(queries, combine) {
        const matches = this.#findMatchingObservers(queries);
        const result = matches.map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
        return [
            result,
            (r)=>{
                return this.#combineResult(r ?? result, combine);
            },
            ()=>{
                return this.#trackResult(result, matches);
            }
        ];
    }
    #trackResult(result, matches) {
        return matches.map((match, index)=>{
            const observerResult = result[index];
            return !match.defaultedQueryOptions.notifyOnChangeProps ? match.observer.trackResult(observerResult, (accessedProp)=>{
                matches.forEach((m)=>{
                    m.observer.trackProp(accessedProp);
                });
            }) : observerResult;
        });
    }
    #combineResult(input, combine) {
        if (combine) {
            if (!this.#combinedResult || this.#result !== this.#lastResult || combine !== this.#lastCombine) {
                this.#lastCombine = combine;
                this.#lastResult = this.#result;
                this.#combinedResult = (0, $jWbIA.replaceEqualDeep)(this.#combinedResult, combine(input));
            }
            return this.#combinedResult;
        }
        return input;
    }
    #findMatchingObservers(queries) {
        const prevObserversMap = new Map(this.#observers.map((observer)=>[
                observer.options.queryHash,
                observer
            ]));
        const observers = [];
        queries.forEach((options)=>{
            const defaultedOptions = this.#client.defaultQueryOptions(options);
            const match = prevObserversMap.get(defaultedOptions.queryHash);
            if (match) observers.push({
                defaultedQueryOptions: defaultedOptions,
                observer: match
            });
            else observers.push({
                defaultedQueryOptions: defaultedOptions,
                observer: new (0, $8JUrJ.QueryObserver)(this.#client, defaultedOptions)
            });
        });
        return observers;
    }
    #onUpdate(observer, result) {
        const index = this.#observers.indexOf(observer);
        if (index !== -1) {
            this.#result = $ca60ef6e07328690$var$replaceAt(this.#result, index, result);
            this.#notify();
        }
    }
    #notify() {
        if (this.hasListeners()) {
            const previousResult = this.#combinedResult;
            const newTracked = this.#trackResult(this.#result, this.#observerMatches);
            const newResult = this.#combineResult(newTracked, this.#options?.combine);
            if (previousResult !== newResult) (0, $7SKaq.notifyManager).batch(()=>{
                this.listeners.forEach((listener)=>{
                    listener(this.#result);
                });
            });
        }
    }
};

});



parcelRegister("54QYY", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $3b266cac75530a48$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $2aEiL = parcelRequire("2aEiL");

var $9TUqr = parcelRequire("9TUqr");

var $f2EFs = parcelRequire("f2EFs");

var $lSd5u = parcelRequire("lSd5u");

var $8NMhF = parcelRequire("8NMhF");

var $jJU6i = parcelRequire("jJU6i");
var $3b266cac75530a48$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
};
function $3b266cac75530a48$export$3b4e64e77073e307(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$height = _ref.height, height = _ref$height === void 0 ? (0, $2aEiL.fg)('platform_dst_nav4_banner_default_height') ? 48 : 64 : _ref$height, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? 'Banner' : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id;
    var dangerouslyHoistSlotSizes = (0, $1v5pe.useContext)((0, $lSd5u.DangerouslyHoistSlotSizes));
    var id = (0, $jJU6i.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   */ (0, $9TUqr.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0
    });
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $hMvDh.default)([
            $3b266cac75530a48$var$styles.root,
            xcss
        ]),
        "data-testid": testId
    }, /*#__PURE__*/ $1v5pe.createElement((0, $8NMhF.HoistCssVarToLocalGrid), {
        variableName: (0, $f2EFs.bannerMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $1v5pe.createElement((0, $8NMhF.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $f2EFs.UNSAFE_bannerVar),
        value: height
    }), children);
}

});


//# sourceMappingURL=OptionsPage.cdac67e9.js.map
